<!-- 老人健康数据 -->
<template>
	<!-- <div class="healthy-main" v-if="oneDayData.sleepIndexCommonList"> -->
	<div class="healthy-main">
		<!-- 查看 -->
		<!-- <a-modal :title="bedName + '睡眠报告'" :visible="detailsPopup" :maskClosable="false" @cancel="detailsOff"
			:dialog-style="{ 'min-width': '900px', 'max-width': '900px' }" :footer="null" id="viewBox"> -->
		<div style="width: 900px;  padding: 0px 24px 14px 24px; background: linear-gradient(180deg, #f3f4f7 0%, #ffffff 100%);">
			<div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; font-size: 16px; line-height: 22px; word-wrap: break-word; margin-bottom: 24px; height: 55px; background-color: #FFFFFF; margin-left: -24px; margin-right: -24px; display: flex; align-items: center; padding-left: 24px;">{{ bedName + '睡眠报告' }}</div>
			<a-spin :spinning="spinning" tip="加载中" :delay="100">
				<div class="content">
					<!-- 头部日历等 -->
					<div class="topright">
						<div class="saiBtn">
							<a-popover v-model="showCalendar" overlayClassName="calendar-name" placement="bottom">
								<template slot="content">
									<a-calendar :fullscreen="false" :defaultValue="$moment(activeDate, 'YYYY-MM-DD')"
										:value="$moment(activeDate, 'YYYY-MM-DD')" :validRange="[
											$moment(
												activeDates[activeDates.length - 1],
												'YYYY-MM-DD'
											),
											$moment(activeDates[0], 'YYYY-MM-DD'),
										]" :disabledDate="getInvalidDates" @panelChange="panelChange" @select="changeDate">
										<template slot="dateCellRender" slot-scope="value">
											<div v-if="getDayData(value)">
												<section>
													<div class="calDot"></div>
												</section>
											</div>
										</template>
									</a-calendar>
								</template>
								<div :class="{ actives: activeType == true }" class="hoverBtns on">
									{{
										activeDate.slice(5, 7) + '月' + activeDate.slice(8) + '日'
									}}
									<a-icon type="calendar" />
								</div>
							</a-popover>
							&nbsp;&nbsp;
							<!-- 多日 -->
							<div v-for="(item, index) in btnList2" :key="index"
								@click="btnClick(item.val, activeDates[0], 2)" :title="item.placeholder"
								class="hoverBtns on" :class="{ actives: activeType == item.val }">
								{{ item.title }}
							</div>
						</div>
						<div v-if="activeType == 1 && isEmpty" style="flex: 1; display: flex; justify-content: flex-end; align-items: center; height: 30px;">
							<div class="ai-btn" @click="clickAiReport"></div>
						</div>
						<span class="share">
							<a-popover placement="bottomRight" destroyTooltipOnHide trigger="click" v-model="popoverVisible"
								id="sharePopover">
								<template slot="content">
									<div class="shareBox">
										<div id="qrCode" ref="qrCodeDetails"></div>
										<p>
											<a-icon type="wechat" style="color: #09bb07; font-size: 22px" />
											<span>微信扫一扫</span>
										</p>
									</div>
								</template>
								<a-button type="primary" @click="shareBtn" :disabled="disabled"
									v-preventReClick>分享</a-button>
							</a-popover>
						</span>
					</div>
					<!-- 有数据 -->
					<div v-if="isEmpty">
						<!-- 单日有数据 -->
						<div v-if="activeType == 1 && oneDayData.sleepIndexCommonList">
							<div class="report-plate" v-if="this.oneDayData.potentialRiskVo.potentialRiskIndexList">
								<div class="report-plate-title1">习惯变化</div>
								<div class="report-plate-title2">/ Habit Changes</div>
							</div>
							<habitChange v-if="actionReport" ref="commentHb" :oneDayData="oneDayData"></habitChange>
							<div v-if="!disabled">
								<!-- 单日 睡眠得分部分-->
								<div class="report-plate">
									<div class="report-plate-title1">睡眠指标</div>
									<div class="report-plate-title2">/ Sleep Indices</div>
								</div>
								<div class="zb_topWrap" v-if="!disabled">
									<div class="leCont">
										<div :class="['leList', smzbObj.smsc.comment == '正常' ? '' : 'leListRed']">
											<div class="flex_alignCen ml10">
												<div :class="['lePoint', smzbObj.smsc.comment == '正常' ? '' : 'lePointRed']">
												</div>
												<div class="leName ml5">睡眠时长：</div>
												<div :class="['leTime', smzbObj.smsc.comment == '正常' ? '' : 'leTimeRed']">
													{{ smzbObj.smsc.allIndexValue }}</div>
												<div :class="['tag', smzbObj.smsc.comment == '正常' ? '' : 'tagRed']">{{
													smzbObj.smsc.comment }}
												</div>
											</div>
											<div class="flex_alignCen mt5">
												<div class="leCkz">参考值：6～10小时</div>
											</div>
										</div>
										<div :class="['leList', smzbObj.sssc.comment == '正常' ? '' : 'leListRed']">
											<div class="flex_alignCen ml10">
												<div :class="['lePoint', smzbObj.sssc.comment == '正常' ? '' : 'lePointRed']">
												</div>
												<div class="leName ml5">深睡时长：</div>
												<div :class="['leTime', smzbObj.sssc.comment == '正常' ? '' : 'leTimeRed']">
													{{ smzbObj.sssc.allIndexValue }}</div>
												<div :class="['tag', smzbObj.sssc.comment == '正常' ? '' : 'tagRed']">{{
													smzbObj.sssc.comment }}
												</div>
											</div>
											<div class="flex_alignCen mt5">
												<div class="leCkz">参考值：20%～60%</div>
											</div>
										</div>
										<div :class="['leList', smzbObj.yxsc.comment == '正常' ? '' : 'leListRed']">
											<div class="flex_alignCen ml10">
												<div :class="['lePoint', smzbObj.yxsc.comment == '正常' ? '' : 'lePointRed']">
												</div>
												<div class="leName ml5">夜醒时长：</div>
												<div :class="['leTime', smzbObj.yxsc.comment == '正常' ? '' : 'leTimeRed']">
													{{ smzbObj.yxsc.allIndexValue }}</div>
												<div :class="['tag', smzbObj.yxsc.comment == '正常' ? '' : 'tagRed']">{{
													smzbObj.yxsc.comment }}
												</div>
											</div>
											<div class="flex_alignCen mt5">
												<div class="leCkz">参考值：≤31分钟</div>
											</div>
										</div>
										<div :class="['leList', smzbObj.lc.comment == '正常' ? '' : 'leListRed']">
											<div class="flex_alignCen ml10">
												<div :class="['lePoint', smzbObj.lc.comment == '正常' ? '' : 'lePointRed']">
												</div>
												<div class="leName ml5">离床：</div>
												<div :class="['leTime', smzbObj.lc.comment == '正常' ? '' : 'leTimeRed']">
													{{ smzbObj.lc.allIndexValue }}</div>
												<div :class="['tag', smzbObj.lc.comment == '正常' ? '' : 'tagRed']">{{
													smzbObj.lc.comment }}</div>
											</div>
											<div class="flex_alignCen mt5">
												<div class="leCkz">参考值：0～2次</div>
											</div>
										</div>
										<div :class="['leList', smzbObj.rssc.comment == '正常' ? '' : 'leListRed']">
											<div class="flex_alignCen ml10">
												<div :class="['lePoint', smzbObj.rssc.comment == '正常' ? '' : 'lePointRed']">
												</div>
												<div class="leName ml5">入睡时长：</div>
												<div :class="['leTime', smzbObj.rssc.comment == '正常' ? '' : 'leTimeRed']">
													{{ smzbObj.rssc.allIndexValue }}</div>
												<div :class="['tag', smzbObj.rssc.comment == '正常' ? '' : 'tagRed']">{{
													smzbObj.rssc.comment }}
												</div>
											</div>
											<div class="flex_alignCen mt5">
												<div class="leCkz">参考值：{{ xyh_lt }}30分钟</div>
											</div>
										</div>
										<div :class="['leList', smzbObj.smxl.comment == '正常' ? '' : 'leListRed']">
											<div class="flex_alignCen ml10">
												<div :class="['lePoint', smzbObj.smxl.comment == '正常' ? '' : 'lePointRed']">
												</div>
												<div class="leName ml5">睡眠效率：</div>
												<div :class="['leTime', smzbObj.smxl.comment == '正常' ? '' : 'leTimeRed']">
													{{ smzbObj.smxl.allIndexValue }}</div>
												<div :class="['tag', smzbObj.smxl.comment == '正常' ? '' : 'tagRed']">{{
													smzbObj.smxl.comment }}
												</div>
											</div>
											<div class="flex_alignCen mt5">
												<div class="leCkz">参考值：≥80%</div>
											</div>
										</div>
										<div :class="['leList', smzbObj.td.comment == '正常' ? '' : 'leListRed']">
											<div class="flex_alignCen ml10">
												<div :class="['lePoint', smzbObj.td.comment == '正常' ? '' : 'lePointRed']">
												</div>
												<div class="leName ml5">体动：</div>
												<div :class="['leTime', smzbObj.td.comment == '正常' ? '' : 'leTimeRed']">
													{{ smzbObj.td.extendData.num }}次</div>
												<div class="leName ml5">·体动指数:</div>
												<div :class="['leTime', smzbObj.td.comment == '正常' ? '' : 'leTimeRed']">{{
													smzbObj.td.indexVal }}
												</div>
												<div :class="['tag', smzbObj.td.comment == '正常' ? '' : 'tagRed']">{{
													smzbObj.td.comment }}</div>

											</div>
											<div class="flex_alignCen mt5">
												<div class="leCkz">参考值：1.25～15

													<div class="tooltip"
														style="height: 24px;margin-left:auto;position:relative;top:-2px;">
														<img style="width:20px;height:20px;"
															src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/QL_official_account/wenhaoIcon.png"
															alt="" />
														<div class="tooltiptext">
															<div class="ahi-title">
																·体动指数是您睡眠阶段平均每小时体动次数的指标，体现的是您睡眠期间身体活动的规律，包括翻身和其他身体活动的记录，一般来说，我们都会有睡眠期间的体动，如无其他不适，均视为正常。
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											:class="['leList', oneDayData.breathRateVo.avgLabel == '正常' ? '' : 'leListRed']">
											<div class="flex_alignCen ml10">
												<div
													:class="['lePoint', oneDayData.breathRateVo.avgLabel == '正常' ? '' : 'lePointRed']">
												</div>
												<div class="leName ml5">呼吸率：</div>
												<div
													:class="['leTime', oneDayData.breathRateVo.avgLabel == '正常' ? '' : 'leTimeRed']">
													平均{{ oneDayData.breathRateVo.avg }}次/分钟</div>
												<div
													:class="['tag', oneDayData.breathRateVo.avgLabel == '正常' ? '' : 'tagRed']">
													{{ oneDayData.breathRateVo.avgLabel }}</div>
											</div>
											<div class="flex_alignCen mt5">
												<div class="leCkz">参考值：8～22次/分钟</div>
											</div>
										</div>
										<div
											:class="['leList', oneDayData.heartRateVo.avgLabel == '正常' ? '' : 'leListRed']">
											<div class="flex_alignCen ml10">
												<div
													:class="['lePoint', oneDayData.heartRateVo.avgLabel == '正常' ? '' : 'lePointRed']">
												</div>
												<div class="leName ml5">心率：</div>
												<div
													:class="['leTime', oneDayData.heartRateVo.avgLabel == '正常' ? '' : 'leTimeRed']">
													平均{{ oneDayData.heartRateVo.avg }}次/分钟</div>
												<div
													:class="['tag', oneDayData.heartRateVo.avgLabel == '正常' ? '' : 'tagRed']">
													{{ oneDayData.heartRateVo.avgLabel }}</div>
											</div>
											<div class="flex_alignCen mt5">
												<div class="leCkz">参考值：40～100次/分钟</div>
											</div>
										</div>
										<div :class="['leList', smzbObj.ddfxzs.comment == '正常' ? '' : 'leListRed']">
											<div class="flex_alignCen ml10">
												<div
													:class="['lePoint', smzbObj.ddfxzs.comment == '正常' ? '' : 'lePointRed']">
												</div>
												<div class="leName ml5">跌倒风险指数：</div>
												<div :class="['leTime', smzbObj.ddfxzs.comment == '正常' ? '' : 'leTimeRed']">
													{{ smzbObj.ddfxzs.value }}</div>
												<div :class="['tag', smzbObj.ddfxzs.comment == '正常' ? '' : 'tagRed']">{{
													smzbObj.ddfxzs.comment }}
												</div>
											</div>
											<div class="flex_alignCen mt5">
												<div class="leCkz">参考值：≤50</div>
											</div>
										</div>
									</div>
									<div class="riCont">
										<img class="banCir" src="../assets/banCir.png" />
										<div class="core-ranking-div">
											<div id="myChartsScore"
												style="width: 160px; height: 100px; margin: 0 auto; top: 0px"
												key="myChartsScore"></div>
											<div class="score-ranking-tips"
												:class="scoreLabel == '一般' ? 'score-ranking-tips-red' : ''">
												{{ scoreLabel }}
											</div>
											<div class="score-ranking">
												超过{{ sleepProportion }}%的用户
											</div>
										</div>

										<div class="botTime">

											<div class="tCont">
												<div class="flex_alignCen">
													<div class="tPoint"></div>
													<div class="tTime ml5">上床时间：{{ oneDayData.getBedIdx }}</div>
												</div>
											</div>
											<div class="tCont">
												<div class="flex_alignCen">
													<div class="tPoint"></div>
													<div class="tTime ml5">入睡时间：{{ oneDayData.sleepStIdx }}</div>
												</div>
												<div class="tTip" v-if="oneDayData.sleepStIdxSuggest">
													建议00:00前入睡
												</div>
											</div>
											<div class="tCont">
												<div class="flex_alignCen">
													<div class="tPoint"></div>
													<div class="tTime ml5">醒来时间：{{ oneDayData.sleepEdIdx }}</div>
												</div>
											</div>
											<div class="tCont" style="border:none;">
												<div class="flex_alignCen">
													<div class="tPoint"></div>
													<div class="tTime ml5">起床时间：{{ oneDayData.leaveBedIdx }}</div>
												</div>
											</div>
										</div>
									</div>

								</div>

								<div class="dataTitle" v-if="!disabled">
									<Comment v-if="actionReport" ref="comment" :oneDayData="oneDayData"
										:searchTime="activeDate" :searchBedId="typeId" />
								</div>
								<div class="report-plate">
									<div class="report-plate-title1">呼吸详情</div>
									<div class="report-plate-title2">/ Respiratory Details</div>
								</div>
								<div class="dataTitle" v-if="!disabled">
									<breathDetail v-if="actionReport" :oneDayData="oneDayData" :searchTime="activeDate"
										:searchBedId="typeId" />
								</div>
								<div class="report-plate">
									<div class="report-plate-title1">睡眠详情</div>
									<div class="report-plate-title2">/ Sleep Details</div>
								</div>
								<div class="myCharts">
									<!-- <div class="bt">
										<img src="../assets/icon_SleepTime_36.png" alt="" />
										睡眠详情（{{ oneDayData.sleepIndexCommonList.sleepDuration }}
										含睡眠段里发生的清醒和离床）
									</div> -->
									<div id="myCharts0" style="height: 10px; margin: 10px 0 -15px 0" :key="activeType">
									</div>
								</div>
								<div class="myCharts">
									<div v-if="oneDayData.sleepIndexCommonList">
										<div class="sleep-div">
											<div class="sleep-item">
												<div class="sleep-begin sleep-begin1"></div>
												<div class="sleep-title">
													深睡 ：{{
														oneDayData.sleepIndexCommonList.deepSleepDuration.value
													}}
												</div>
												<span :class="['sleep-title ml10 sleep-title-bg']" :style="{
													background:
														oneDayData.sleepIndexCommonList.deepSleepDuration.comment ==
															'正常'
															? '#1890ff'
															: '#ff4d4f',
												}">{{oneDayData.sleepIndexCommonList.deepSleepDuration.comment}}</span>
											</div>
											<div class="sleep-item-slipe"></div>
											<div class="sleep-item">
												<div class="sleep-begin sleep-begin2"></div>
												<div class="sleep-title">
													浅睡 ：{{
														oneDayData.sleepIndexCommonList.lightSleepDuration.value
													}}
												</div>
												<span :class="['sleep-title ml10 sleep-title-bg']" :style="{
													background:
														oneDayData.sleepIndexCommonList.lightSleepDuration.comment ==
															'正常'
															? '#1890ff'
															: '#ff4d4f',
												}">{{oneDayData.sleepIndexCommonList.lightSleepDuration.comment}}</span>
											</div>
											<div class="sleep-item-slipe"></div>
											<div class="sleep-item">
												<div class="sleep-begin sleep-begin3"></div>
												<div class="sleep-title">
													清醒 ：{{
														oneDayData.sleepIndexCommonList.clearSleepDuration.value
													}}
												</div>
												<span :class="['sleep-title ml10 sleep-title-bg']" :style="{
													background:
														oneDayData.sleepIndexCommonList.clearSleepDuration.comment ==
															'正常'
															? '#1890ff'
															: '#ff4d4f',
												}">{{oneDayData.sleepIndexCommonList.clearSleepDuration.comment}}</span>
											</div>
											<div class="sleep-item-slipe"></div>
											<div class="sleep-item">
												<div class="sleep-begin sleep-begin4"></div>
												<div class="sleep-title">
													离床 ：{{ oneDayData.sleepIndexCommonList.outBedDuration.value }}
												</div>
												<span :class="['sleep-title ml10 sleep-title-bg']" :style="{
													background:
														oneDayData.sleepIndexCommonList.outBedDuration.comment ==
															'正常'
															? '#1890ff'
															: '#ff4d4f',
												}">{{oneDayData.sleepIndexCommonList.outBedDuration.comment}}</span>
											</div>
										</div>
									</div>

									<!-- 睡眠周期 -->
									<!-- <div style="height: 20px;"></div> -->
									<div
										style="margin-left: 32px;height:22px;border-bottom:1px solid #D9D9D9;padding-bottom:24px;position: relative;margin-top: 10px;">
										<span class="begin-end">
											<img src="../assets/img/report_index_icon_bed_d@2x.png" alt="" />
											<span> {{ oneDayData.getBedIdx }}上床</span>
										</span>
										<span class="begin-end" style="right: 0">
											<img class="sleep-end" src="../assets/img/report_index_icon_clock_d@2x.png"
												alt="" />
											{{ oneDayData.leaveBedIdx }}起床
										</span>
									</div>
									<div style="position:relative;">
										<div class="zqTopArr">
											<div class="zqTipTime" v-for="(item, index) in sleepTableTimeList" :key="index">
												{{ item }}
											</div>
										</div>
										<div id="myCharts2" style="height: 124px; margin: 0 auto" :key="activeType"></div>
									</div>
								</div>

								<!-- 卫生间使用情况 -->
								<div class="myCharts" v-if="hasFallPicData">
									<div class="bt">
										<img src="../assets/img/report_details_icon_frequency_d@2x.png" alt="" />
										<span class="">卫生间使用情况
											<span style="color: #8c8c8c" v-if="oneDayData.fallImgVo.totalUsedTimes > 1">
												（共{{ oneDayData.fallImgVo.totalUsedTimes }}次 &nbsp;
												最短{{
													oneDayData.fallImgVo.shortestUsedTime || '-'
												}}
												&nbsp; 最长{{
													oneDayData.fallImgVo.longestUsedTime || '-'
												}}）
											</span>
											<span style="color: #8c8c8c" v-if="oneDayData.fallImgVo.totalUsedTimes === 0">
												（共0次）
											</span>
											<span style="color: #8c8c8c" v-if="oneDayData.fallImgVo.totalUsedTimes === 1">
												（共1次 &nbsp; 用时{{
													oneDayData.fallImgVo.longestUsedTime
												}}）
											</span>
										</span>
									</div>
									<div class="pic">
										<pieCom v-if="isShowPic && detailsPopup" :timeArrData="timeArr" :formBG="'healthy'">
										</pieCom>
										<div class="no-picdata" v-else>
											<div class="mins">
												<div>10</div>
												<div>5</div>
												<div>0</div>
											</div>
											<div class="picdata-content">昨晚未使用卫生间</div>
										</div>

									</div>
								</div>
								<!-- 呼吸率 -->
								<div class="myCharts" style="height: 110px">
									<div class="bt">
										<img src="../assets/img/report_details_icon_breathe_d@2x.png" alt="" />
										<span class="">呼吸率<span style="color: #8c8c8c">
												（最低{{ oneDayData.breathRateVo.min }}次/分钟
												&nbsp; 平均{{
													oneDayData.breathRateVo.avg
												}}次/分钟
												<span class="sleep-title-bg" :style="{
															background:
																oneDayData.breathRateVo.avgLabel == '正常'
																	? '#1890ff'
																	: '#ff4d4f',
														}">{{ oneDayData.breathRateVo.avgLabel }}</span>
												&nbsp;最高{{
													oneDayData.breathRateVo.max
												}}次/分钟）</span></span>
									</div>
									<div id="myCharts3" style="height: 100px; margin: 10px auto" :key="activeType"></div>
								</div>
								<!-- 心率 -->
								<div class="myCharts" style="height: 110px">
									<div class="bt">
										<img src="../assets/img/report_details_icon_heart_d@2x.png" alt="" />
										<span class="">心率<span style="color: #8c8c8c">
												（最低{{ oneDayData.heartRateVo.min }}次/分钟
												&nbsp; 平均{{
													oneDayData.heartRateVo.avg
												}}次/分钟
												<span class="sleep-title-bg" :style="{
															background:
																oneDayData.heartRateVo.avgLabel ==
																	'正常'
																	? '#1890ff'
																	: '#ff4d4f',
														}">{{ oneDayData.heartRateVo.avgLabel }}</span>
												&nbsp;最高{{
													oneDayData.heartRateVo.max
												}}次/分钟）</span></span>
									</div>
									<div id="myCharts4" style="height: 100px; margin: 10px auto" :key="activeType"></div>
								</div>
								<!-- 体动详情 -->
								<div class="myCharts">
									<div class="bt">
										<img src="../assets/img/report_details_icon_bodymove_d@2x.png" alt="" />
										<span class="">体动详情
											<span style="color: #8c8c8c">（共{{
												oneDayData.turnOverNum
											}}次）</span>
										</span>
										<div class="tooltip" style="height: 20px;">
											<img style="width:20px;height:20px;"
												src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/QL_official_account/wenhaoIcon.png"
												alt="" />
											<div class="tooltiptext">
												<div class="ahi-title">
													·体动指数是您睡眠阶段平均每小时体动次数的指标，体现的是您睡眠期间身体活动的规律，包括翻身和其他身体活动的记录，一般来说，我们都会有睡眠期间的体动，如无其他不适，均视为正常。
												</div>
											</div>
										</div>
									</div>
									<div id="myCharts5" style="height: 126px; margin: 10px auto" :key="activeType"></div>
								</div>
								<div
									style="display: flex; justify-content: center; padding-bottom: 10px; padding-bottom: 5px;">
									<span
										style="font-size: 14px; font-weight: 400; font-family: PingFangSC-Regular, PingFang SC; color: rgba(202, 205, 217, 1);">{{
											"sn：" + snCode }}</span>
								</div>
							</div>
						</div>
						<!-- 多日 -->
						<div class="moreDays" v-if="(activeType == 3 || activeType == 4) && !disabled">
							<div class="content">

								<!-- 睡眠指标 -->
								<div class="comNameTitWrap mt32">
									<div class="leCircle"></div>
									<div class="riFontWrap">
										<div class="fontName">睡眠指标</div>
										<div class="engName">/ Sleep Indices</div>
									</div>
								</div>
								<!-- 指标列表 -->
								<div class="nowListWrap" v-if="true">
									<div :key="index + 'uyy'" v-for="(item, index) in moreDayData.reportIndexList">
										<div :class="['nowList', item.normalFlag != 0 ? 'nowList_Ques' : '',]"
											v-if="item.indexName != '吸呼比' && item.indexName != 'AHI'">
											<!-- <div :class="['nowList',item.normalFlag != 0 ? 'nowList_Ques' : '']"> -->
											<!-- 指标标题start -->
											<div class="nowTop alignItemStart">
												<img class="goodImg" :src="imgUrl + '/report_icon_good_d@2x.png'"
													v-if="item.normalFlag == 0"></img>
												<img class="goodImg" :src="imgUrl + '/Icon_alarm.png'"
													v-if="item.normalFlag != 0"></img>
												<!-- 无问题数据 -->
												<div class="titName ml10" v-if="item.normalFlag == 0">
													<div
														v-if="item.indexName != '吸呼比' && item.indexName != 'AHI' && item.indexName != '离床次数'">
														平均{{ item.indexName }}
													</div>
													<div v-if="item.indexName == '离床次数'">
														最多{{ item.indexName }}
													</div>
													<div v-if="item.indexName == '吸呼比'">
														{{ item.indexName }}
													</div>
													<div v-if="item.indexName == 'AHI'">
														{{ item.indexName }}平均
													</div>
													<!-- 睡眠时长、夜醒时长、入睡时长、深睡时长 -->
													<div class="sleepTime ml10" v-if="item.indexName == '睡眠时长' ||
														item.indexName == '夜醒时长' ||
														item.indexName == '入睡时长' ||
														item.indexName == '深睡时长'
														">
														<div class="color1890FF" v-if="item.indexValHour">
															{{ item.indexValHour }}
														</div>
														<div class="" v-if="item.indexValHour">小时</div>
														<div class="color1890FF">
															{{ item.indexValMinute }}
														</div>
														<div class="">分钟</div>
													</div>
													<!-- 深睡时长 -->
													<div class="flex" v-if="item.indexName == '深睡时长'">
														(
														<div class="color1890FF">{{ item.indexValPct }}%</div>
														)
													</div>
													<!-- 睡眠效率 -->
													<div class="color1890FF ml10" v-if="item.indexName == '睡眠效率'">
														{{ item.indexVal }}
													</div>
													<!-- 离床次数 -->
													<div class="sleepTime ml10" v-if="item.indexName == '离床次数'">
														<div class="color1890FF">{{ item.indexVal }}</div>
														<div>次</div>
													</div>
													<!-- 体动指数 -->
													<div class="sleepTime ml10" v-if="item.indexName == '体动指数'">
														<div class="color1890FF">{{ item.indexVal }}</div>
														<div class="tooltip"
															style="height: 24px;margin-left:5px;position:relative;top:-2px;">
															<img style="width:20px;height:20px;"
																src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/QL_official_account/wenhaoIcon.png"
																alt="" />
															<div class="tooltiptext">
																<div class="ahi-title">
																	·体动指数是您睡眠阶段平均每小时体动次数的指标，体现的是您睡眠期间身体活动的规律，包括翻身和其他身体活动的记录，一般来说，我们都会有睡眠期间的体动，如无其他不适，均视为正常。
																</div>
															</div>
														</div>
													</div>
													<!-- 吸呼比 -->
													<div class="sleepTime ml10" v-if="item.indexName == '吸呼比'">
														<div class="color1890FF">{{ item.indexVal }}</div>
													</div>
													<!-- AHI -->
													<div class="color1890FF ml10 posRela flex_alignCen"
														v-if="item.indexName == 'AHI'">
														{{ item.indexVal }}

														<img class="wenhaoImg" :src="imgUrl + '/wenhaoIcon.png'"
															@click="ahiWenhaoTan = true" id="ahi" style="margin-top:7px;" />
													</div>
												</div>
												<!-- 有问题数据 -->
												<div class="titName ml10"
													v-if="item.normalFlag == 3 || item.normalFlag == 4 || item.normalFlag == 5 || item.normalFlag == 6">
													<!-- 睡眠时长小于6小时 -->
													<div v-if="item.indexName == '睡眠时长' &&
														item.normalFlagSleepDuration == 6
														">
														<!-- 睡眠时长_周_月_3月_6月 -->
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚睡眠时长小于6小时
														</div>
														<div v-if="activeType == 4">
															过去30天出现
															<span class="colorFF7186">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚睡眠时长小于6小时
														</div>
														<div v-if="activeType == 3 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月出现
															<span class="colorFF7186">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚睡眠时长小于6小时
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月出现
															<span class="colorFF7186">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚睡眠时长小于6小时
														</div>
													</div>
													<!-- 睡眠时长大于10小时 -->
													<div v-if="item.indexName == '睡眠时长' &&
															item.normalFlagSleepDuration == 10
															">
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚睡眠时长大于10小时
														</div>
														<div v-if="activeType == 4">
															过去30天出现
															<span class="colorFF7186">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚睡眠时长大于10小时
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月出现
															<span class="colorFF7186">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚睡眠时长大于10小时
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月出现
															<span class="colorFF7186">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚睡眠时长大于10小时
														</div>
													</div>
													<!-- 深睡时长少于20% -->
													<div v-if="item.indexName == '深睡时长' &&
															item.normalFlagDeepDuration == 20
															">
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚深睡时长少于20%
														</div>
														<div v-if="activeType == 4">
															过去30天出现
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚深睡时长少于20%
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月出现3晚深睡时长少于20%
														</div>
														<div v-if="activeType == 4 &&
															InterfaceBack_healthTrendsDays == 180
															">
															过去6个月天出现3晚深睡时长少于20%
														</div>
													</div>
													<!-- 深睡时长大于60% -->
													<div v-if="item.indexName == '深睡时长' &&
														item.normalFlagDeepDuration == 60
														">
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚深睡时长大于60%
														</div>
														<div v-if="activeType == 4">
															过去30天出现3晚深睡时长大于60%
														</div>
														<div v-if="activeType == 4 &&
															InterfaceBack_healthTrendsDays == 90
															">
															过去3个月出现3晚深睡时长大于60%
														</div>
														<div v-if="activeType == 4 &&
															InterfaceBack_healthTrendsDays == 180
															">
															过去6个月天出现3晚深睡时长大于60%
														</div>
													</div>
													<!-- 夜醒时长超过31分钟 -->
													<div v-if="item.indexName == '夜醒时长'">
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚夜间醒来时长超过31分钟
														</div>
														<div v-if="activeType == 4">
															过去30天出现
															<span class="colorFF7186">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚夜间醒来时长超过31分钟
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月出现
															<span class="colorFF7186">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚夜间醒来时长超过31分钟
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月出现
															<span class="colorFF7186">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚夜间醒来时长超过31分钟
														</div>
													</div>
													<!-- 离床次数大于2次 -->
													<div v-if="item.indexName == '离床次数'">
														<div v-if="activeType == 3">
															过去7天有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚夜间离床次数超过2次
														</div>
														<div v-if="activeType == 4">
															过去30天有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚夜间离床次数超过2次
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚夜间离床次数超过2次
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚夜间离床次数超过2次
														</div>
													</div>
													<!-- 入睡时长超过30分钟 -->
													<div v-if="item.indexName == '入睡时长'">
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚入睡时长超过30分钟
														</div>
														<div v-if="activeType == 4">
															过去30天出现
															<span class="colorFF7186">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚入睡时长超过30分钟
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月出现
															<span class="colorFF7186">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚入睡时长超过30分钟
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月出现
															<span class="colorFF7186">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚入睡时长超过30分钟
														</div>
													</div>
													<!-- 睡眠效率>=80% -->
													<div v-if="item.indexName == '睡眠效率'">
														<div v-if="activeType == 3">
															过去7天有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚睡眠效率小于80%
														</div>
														<div v-if="activeType == 4">
															过去30天有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚睡眠效率小于80%
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚睡眠效率小于80%
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚睡眠效率小于80%
														</div>
													</div>
													<!-- 体动指数大于15 -->
													<div
														v-if="item.indexName == '体动指数' && item.normalFlagTurnOverIndex == 15">
														<div v-if="activeType == 3">
															过去7天有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚体动指数大于15
														</div>
														<div v-if="activeType == 4">
															过去30天有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚体动指数大于15
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚体动指数大于15
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚体动指数大于15
														</div>
													</div>
													<!-- 体动指数小于1.25 -->
													<div v-if="item.indexName == '体动指数' &&
															item.normalFlagTurnOverIndex == 1.25
															">
														<div v-if="activeType == 3">
															过去7天有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚体动指数小于1.25
														</div>
														<div v-if="activeType == 4">
															过去30天有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚体动指数小于1.25
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚体动指数小于1.25
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚体动指数小于1.25
														</div>
													</div>
													<!-- 体动指数 -->
													<div class="tooltip" v-if="item.indexName == '体动指数'"
														style="height: 24px;margin-left:5px;position:relative;top:-6px;">
														<img style="width:20px;height:20px;"
															src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/QL_official_account/wenhaoIcon.png"
															alt="" />
														<div class="tooltiptext">
															<div class="ahi-title">
																·体动指数是您睡眠阶段平均每小时体动次数的指标，体现的是您睡眠期间身体活动的规律，包括翻身和其他身体活动的记录，一般来说，我们都会有睡眠期间的体动，如无其他不适，均视为正常。
															</div>
														</div>
													</div>
													<!-- AHI 5-15 15-30 >30 -->
													<div v-if="item.indexName == 'AHI'">
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚呼吸异常指数大于等于
															<span v-if="item.normalFlagAhi == 5">5</span>
															<span v-if="item.normalFlagAhi == 15">15</span>
															<span v-if="item.normalFlagAhi == 30">30</span>
														</div>
														<div v-if="activeType == 4">
															过去30天有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚呼吸异常指数大于等于
															<span v-if="item.normalFlagAhi == 5">5</span>
															<span v-if="item.normalFlagAhi == 15">15</span>
															<span v-if="item.normalFlagAhi == 30">30</span>
														</div>
														<div v-if="activeType == 4 &&
															InterfaceBack_healthTrendsDays == 90
															">
															过去3个月有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚呼吸异常指数大于等于
															<span v-if="item.normalFlagAhi == 5">5</span>
															<span v-if="item.normalFlagAhi == 15">15</span>
															<span v-if="item.normalFlagAhi == 30">30</span>
														</div>
														<div v-if="activeType == 4 &&
															InterfaceBack_healthTrendsDays == 180
															">
															过去6个月有
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚呼吸异常指数大于等于
															<span v-if="item.normalFlagAhi == 5">5</span>
															<span v-if="item.normalFlagAhi == 15">15</span>
															<span v-if="item.normalFlagAhi == 30">30</span>
														</div>
													</div>
													<!-- 吸呼比 -->
													<div v-if="item.indexName == '吸呼比'">
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚吸呼比集中在非正常区间
														</div>
														<div v-if="activeType == 4">
															过去30天出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚吸呼比集中在非正常区间
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚吸呼比集中在非正常区间
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚吸呼比集中在非正常区间
														</div>
													</div>
												</div>
											</div>
											<!-- 指标标题end -->
											<!-- 有问题和没问题的共用start -->
											<div class="referVal" v-if="item.indexName == '睡眠时长'">
												参考值：6～10小时
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<div class="referVal" v-if="item.indexName == '深睡时长'">
												参考值：20%~60%
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<div class="referVal" v-if="item.indexName == '夜醒时长'">
												参考值：≤31分钟
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<div class="referVal" v-if="item.indexName == '离床次数'">
												参考值：0～2次
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">最高值</div>
												</div>
											</div>
											<div class="referVal" v-if="item.indexName == '入睡时长'">
												参考值：{{ xyh_lt }} 30分钟
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<div class="referVal" v-if="item.indexName == '睡眠效率'">
												参考值：≥80%
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<div class="referVal" v-if="item.indexName == '体动指数'">
												参考值：1.25~15
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<div class="referVal" v-if="item.indexName == 'AHI'">
												参考值：{{ xyh_lt }} 5
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bgFF7186"></div>
														<div class="gang bgFF7186"></div>
														<div class="gang bgFF7186"></div>
													</div>
													<div class="gantTip">异常参考</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<!-- 有问题和没问题的共用end -->

											<div class="deExplain"
												v-if="item.normalFlag == 3 || item.normalFlag == 4 || item.normalFlag == 5 || item.normalFlag == 6">
												<div class="deExTop" @click="clc_xxjd(index, 'more_smzb')">
													<div class="deExTopTip">详细解读</div>
													<div class="deExTop_iconWrap">
														<img class="deExTop_icon" v-if="item.isShow_advise"
															src="../assets/static/icon_unscramble_up_h@2x.png"
															mode="widthFix"></img>
														<img class="deExTop_icon" v-if="!item.isShow_advise"
															src="../assets/static/report_detail_icon_down_h@2x.png"
															mode="widthFix"></img>
													</div>
												</div>
												<div class="pb10" style="border-top: 2px solid #E8EAED;"
													v-if="item.isShow_advise">
													<!-- 有问题的指标 -->
													<div
														v-if="item.normalFlag == 3 || item.normalFlag == 4 || item.normalFlag == 5 || item.normalFlag == 6">
														<!-- 睡眠时长 -->
														<div class="yxsc" v-if="item.indexName == '睡眠时长'">
															<div class="quesCont">
																<!-- 小于6小时 -->
																<div v-if="item.normalFlagSleepDuration == 6">
																	<span class="title-left-dian"></span>
																	根据美国南佛罗里达大学衰老研究学院助理教授Soomi
																	Lee研究发现，只需要连续3个晚上的睡眠时长小于6小时，就足以导致人的精神和身体健康状况出现严重恶化
																</div>
																<!-- 大于10小时 -->
																<div v-if="item.normalFlagSleepDuration == 10">
																	<span class="title-left-dian"></span>
																	英国基尔大学的科学家在对74项研究涉及300余万人的研究分析发现，与睡7个小时相比，睡10个小时的死亡风险会提高30%。与此同时，死于中风的风险会提高56%，死于心血管疾病的风险会提高49%。
																</div>
																<div class="mt15"><span class="title-left-dian"></span>
																	建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green4.png'"></img>
																<div class="yxCont">
																	制定规律的作息时间，并严格遵守
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green1.png'"></img>
																<div class="yxCont">
																	睡眠环境尽量避免光照和噪音，室温保持。在18~24℃，选择舒适的床品，睡前泡脚放松
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green2.png'"></img>
																<div class="yxCont">
																	午睡别太久，20 分钟左右为宜
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	每周3～5次30分钟有氧运动，避开睡前3小时，放松心情，释放压力
																</div>
															</div>
															<div class="quesCont">
																<div>
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助
																</div>
															</div>
														</div>
														<!-- 深睡时长小于20% -->
														<div class="yxsc" v-if="item.indexName == '深睡时长' &&
															item.normalFlagDeepDuration == 20
															">
															<div class="quesCont">
																<div>
																	<span class="title-left-dian"></span>
																	荷兰神经科学研究所的伊斯布兰德·范德韦夫及同事在《自然神经学》杂志发表报告指出深度睡眠过短会导致记忆力变差
																</div>
																<div>
																	<span class="title-left-dian"></span>
																	美国斯坦福大学的研究团队随访持续21年的分析结果表明，深度睡眠不良与全因死亡率及心血管疾病发作风险升高有关。
																</div>
																<div class="mt15"><span class="title-left-dian"></span>
																	建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red4.png'"></img>
																<div class="yxCont">
																	远离烟酒，晚餐避免大吃大喝
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green1.png'"></img>
																<div class="yxCont">
																	睡眠环境尽量避免光照和噪音，室温保持在18~24℃，选择舒适的床品，睡前泡脚放松
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green2.png'"></img>
																<div class="yxCont">
																	午睡别太久，20 分钟左右为宜
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	每周3～5次30分钟有氧运动，避开睡前3小时，放松心情，释放压力
																</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4
																	">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果有6个月依然没有改善，可以找专业的医生寻求帮助
																</div>
															</div>
														</div>
														<!-- 深睡时长大于60% -->
														<div class="yxsc" v-if="item.indexName == '深睡时长' &&
															item.normalFlagDeepDuration == 60
															">
															<div class="quesCont">
																<div>
																	深睡眠是人体黄金睡眠，一般深睡眠占比在20%～60%，具体情况因人而异。过长的深睡眠可能是过度劳累或者身体某种疾病导致的，长期的深睡眠过长，可能会引发头痛、头晕等不适的症状，导致大脑的神经缺乏敏感性，大脑的神经中枢受到影响，容易发生注意力不集中和反应较迟钝的现象，影响日常生活和生命健康
																</div>
																<div class="mt15">建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green4.png'"></img>
																<div class="yxCont">
																	合理安排工作和生活节奏，坚持规律的作息，早上按固定时间起床，不要赖床
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green2.png'"></img>
																<div class="yxCont">适度午休，20分钟左右为宜</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4
																	">
																	在尝试了上述方法后，您可以持续观察深睡时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	在尝试了上述方法后，您可以持续观察深睡时长的变化，您已经有6个月依然没有改善，建议尽快找专业的医生寻求帮助
																</div>
															</div>
														</div>
														<!-- 夜醒时长 -->
														<div class="yxsc" v-if="item.indexName == '夜醒时长'">
															<div class="quesCont">
																<div>
																	<span class="title-left-dian"></span>
																	根据《睡眠医学》的研究，如果连续6个月每周都至少发生3次夜间觉醒时间超过31分钟，即可定义为失眠
																</div>
																<div class="mt15"><span class="title-left-dian"></span>
																	建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red3.png'"></img>
																<div class="yxCont">
																	睡前2小时不要喝咖啡或酒，不要过度饮水，控制一下饮食
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green1.png'"></img>
																<div class="yxCont">
																	睡眠环境尽量避免光照和噪音，室温保持在18~24℃，选择舒适的床品，睡前泡脚放松
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green2.png'"></img>
																<div class="yxCont">
																	午睡别太久，20 分钟左右为宜
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	每周3～5次30分钟有氧运动，避开睡前3小时，放松心情，释放压力
																</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4
																	">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察夜间醒来时长的变化，如果超过6个月依然没有改善，可以去医疗中心找到专业的医生帮您制定解决方案
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察夜间醒来时长的变化，您已经有6个月依然没有改善，建议尽快去医疗中心找到专业的医生帮您制定解决方案
																</div>
															</div>
														</div>
														<!-- 离床次数 -->
														<div class="yxsc" v-if="item.indexName == '离床次数'">
															<div class="quesCont">
																<div>
																	<span class="title-left-dian"></span>
																	专家表示，一般情况下人起夜的次数在0～2次，起夜次数超过2次，且持续多日，则说明夜尿频率高，与之相关的疾病包括：糖尿病、前列腺增生、泌尿系统感染等，需要引起警惕
																</div>
																<div class="mt15"><span class="title-left-dian"></span>
																	建议您尝试如下改善：</div>
															</div>
															<div class="yxscList alignItemStart heiAuto">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red1.png'"></img>
																<div class="yxCont">
																	平常少吃盐
																	<div>
																		英国一项研究发现，减少食盐的摄入量，可明显减少起夜的次数。晚餐尤其要吃得清淡些，同时要减少高蛋白食物的摄入
																	</div>
																</div>
															</div>
															<div class="yxscList alignItemStart heiAuto">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green6.png'"></img>
																<div class="yxCont">
																	睡前半小时内少喝水
																	<div>
																		建议在睡觉前半小时，稍微抿上两口，最多不超过一杯（200毫升）
																	</div>
																</div>
															</div>
															<div class="yxscList alignItemStart heiAuto">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green5.png'"></img>
																<div class="yxCont">
																	经常做提肛运动
																	<div>
																		盆底部肌肉松弛，膀胱括约肌萎缩，包括膀胱弹性差，较少的尿量就会引起较强的尿意，所以提肛运动有助于增强盆底肌肉的力量，很好地减少起夜次数
																	</div>
																</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4
																	">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察夜间离床次数的变化，如果超过6个月依然没有改善，可以去医院做个详细检查
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察夜间离床次数的变化，您已经有6个月依然没有改善，建议尽快去医院做个详细检查
																</div>
															</div>
														</div>
														<!-- 入睡时长 -->
														<div class="yxsc" v-if="item.indexName == '入睡时长'">
															<div class="quesCont">
																<div>
																	<span class="title-left-dian"></span>
																	依据世界卫生组织(WHO)标准，连续一个月每周至少有3天出现上床30分钟无法入睡即可判定为失眠
																</div>
																<div class="mt15">建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green4.png'"></img>
																<div class="yxCont">
																	合理安排工作和生活节奏，坚持规律的作息，按时上床睡觉
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red2.png'"></img>
																<div class="yxCont">
																	睡前远离电子设备，在床上不要玩手机、看书
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	每周坚持3～5次30分钟有氧运动，放松心情，释放压力
																</div>
															</div>

															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4
																	">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察入睡时长的变化，如果超过6个月依然没有改善，可以去医院做个详细检查
																</div>
																<!-- 周月3月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察入睡时长的变化，您已经有6个月依然没有改善，建议尽快去医院做个详细检查
																</div>
															</div>
														</div>
														<!-- 睡眠效率 -->
														<div class="yxsc" v-if="item.indexName == '睡眠效率'">
															<div class="quesCont">
																<div>
																	<span class="title-left-dian"></span>
																	有研究表明，睡眠效率小于80%是肥胖发生的一个危险因素
																</div>
																<div class="mt15"><span class="title-left-dian"></span>
																	建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green4.png'"></img>
																<div class="yxCont">
																	合理安排工作和生活节奏，坚持规律的作息，有困意的时候再上床睡觉
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red2.png'"></img>
																<div class="yxCont">
																	睡前远离电子设备，在床上不要玩手机、看书
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	每周坚持3～5次30分钟有氧运动，放松心情，释放压力
																</div>
															</div>

															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4
																	">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察睡眠效率的变化，如果超过6个月依然没有改善，可以去医院做个详细检查
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察入睡时长的变化，您已经有6个月依然没有改善，建议尽快去医院做个详细检查
																</div>
															</div>
														</div>
														<!-- 体动指数大于15次 -->
														<div class="yxsc" v-if="item.indexName == '体动指数' &&
															item.normalFlagTurnOverIndex == 15
															">
															<div class="quesCont">
																<div>
																	<span class="title-left-dian"></span>
																	根据大数据的分析，大多数人的体动指数集中分布在1.25～15之间
																</div>
																<div>
																	<span class="title-left-dian"></span>
																	体动体现的是您睡眠期间身体活动的规律，包括翻身和其他身体活动的记录，一般来说，我们都会有睡眠期间的体动，体动过多体现的是您睡觉不踏实，睡眠质量不够好，如果没有其他明显不适，均视为正常，无需过度担心
																</div>
																<div class="mt15">建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red4.png'"></img>
																<div class="yxCont">
																	远离烟酒，晚餐避免大吃大喝
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red2.png'"></img>
																<div class="yxCont">
																	睡前远离电子设备，在床上不要玩手机、看书
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	每周坚持3～5次30分钟有氧运动，放松心情，释放压力
																</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4
																	">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察体动指数的变化，如果超过6个月依然没有改善，可以去医院做个详细检查
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察体动指数的变化，您已经超过6个月依然没有改善，建议尽快去医院做个详细检查
																</div>
															</div>
														</div>
														<!-- 体动指数小于1.25次 -->
														<div class="yxsc" v-if="item.indexName == '体动指数' &&
															item.normalFlagTurnOverIndex == 1.25
															">
															<div class="quesCont">
																<div>
																	<span class="title-left-dian"></span>
																	根据大数据的分析，大多数人的体动指数集中分布在1.25～15之间
																</div>
																<div>
																	<span class="title-left-dian"></span>
																	体动体现的是您睡眠期间身体活动的规律，包括翻身和其他身体活动的记录，一般来说，我们都会有睡眠期间的体动，体动过少体现的是您睡觉非常平稳，如果没有其他明显不适，均视为正常，无需过度担心
																</div>
																<div class="mt15"><span class="title-left-dian"></span>
																	建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green4.png'"></img>
																<div class="yxCont">
																	制定规律的作息时间，并严格遵守
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green2.png'"></img>
																<div class="yxCont">适度午休，20分钟左右为宜</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4
																	">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察体动指数的变化，如果超过6个月依然没有改善，可以去医院做个详细检查
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察体动指数的变化，您已经超过6个月依然没有改善，建议尽快去医院做个详细检查
																</div>
															</div>
														</div>
														<!-- AHI -->
														<div class="yxsc" v-if="item.indexName == 'AHI'">
															<div class="quesCont">
																<!-- 大于等于5 -->
																<div v-if="item.normalFlagAhi == 5">
																	<span class="title-left-dian"></span>
																	根据医学临床上的定义，AHI≥5即可定义为轻度的睡眠呼吸暂停低通气综合征
																</div>
																<!-- 大于等于15 -->
																<div v-if="item.normalFlagAhi == 15">
																	<span class="title-left-dian"></span>
																	根据医学临床上的定义，15≤AHI{{ xyh_lt }}30
																	即可定义为中度的睡眠呼吸暂停低通气综合征
																</div>
																<!-- 大于等于30 -->
																<div v-if="item.normalFlagAhi == 30">
																	<span class="title-left-dian"></span>
																	根据医学临床上的定义，AHI≥30即可定义为重度的睡眠呼吸暂停低通气综合征
																</div>
																<div class="mt15"><span class="title-left-dian"></span>
																	建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green8.png'"></img>
																<div class="yxCont">
																	改变卧姿，尽量以侧卧进入睡眠
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green7.png'"></img>
																<div class="yxCont">
																	尽量不睡高枕头，保持呼吸道的通畅
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red4.png'"></img>
																<div class="yxCont">
																	合理饮食，控制体重，远离烟酒
																</div>
															</div>
															<!-- 大于等于5 -->
															<div class="yxscList"
																v-if="item.indexVal >= 5 && item.indexVal < 15">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	适量运动，增强体质，预防感冒
																</div>
															</div>
															<!-- 大于等于15 大于等于30 -->
															<div class="yxscList" v-if="item.indexVal >= 15">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green9.png'"></img>
																<div class="yxCont">
																	必要时可选择经鼻正压通气治疗
																</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4
																	">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察AHI的变化，如果超过6个月依然没有改善，可以去医院做个详细检查
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察AHI的变化，您已经有6个月依然没有改善，建议尽快去医院做个详细检查
																</div>
															</div>
														</div>
														<!-- 吸呼比 -->
														<div class="yxsc" v-if="item.indexName == '吸呼比'">
															<div class="quesCont">
																<div>
																	<span class="title-left-dian"></span>
																	根据大数据分析，正常人的吸呼比集中在0.8～1.5之间
																</div>
																<div class="mt15"><span class="title-left-dian"></span>
																	建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green7.png'"></img>
																<div class="yxCont">
																	尽量不睡高枕头，保持呼吸道的通畅
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red4.png'"></img>
																<div class="yxCont">
																	合理饮食，控制体重，远离烟酒
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	适量运动，增强体质，预防感冒
																</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4
																	">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察吸呼比的变化，如果超过6个月依然没有改善，可以去医院做个详细检查
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	<span class="title-left-dian"></span>
																	在尝试了上述方法后，您可以持续观察吸呼比的变化，您已经有6个月依然没有改善，建议尽快去医院做个详细检查
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>

											<!-- 吸呼比 -->
											<!-- 柱状图有问题的指标共用 -->
											<div v-if="item.indexName == '吸呼比' && item.normalFlag != 0">
												<div class="lx_list_data">
													<div class="lx_list" :key="index2"
														v-for="(item2, index2) in item.extendData"
														@click="cli_more_xh_date(item2.date)">
														<!-- item2.normalFlag "正常标志, 0-正常 1-非正常" -->
														<div :class="[
															'cirIcon',
															item2.isSelectedDate ? 'bg1890FF' : '',
														]" style="border: 6px solid #1890FF" v-if="item2.normalFlag == 0"></div>
														<div :class="[
															'cirIcon',
															item2.isSelectedDate ? 'bgFF4D4F' : '',
														]" v-if="item2.normalFlag == 1"></div>
														<div class="nowDay">{{ item2.date }}</div>
													</div>
												</div>
												<div class="colPicWrap draw_canvas">
													<div class="colTop draw_canvas">
														<div class="topIcon draw_canvas" data-type="span"
															data-background="#EDFFF0"></div>
														<div class="topTit draw_canvas" data-type="span" data-span="正常范围">
															正常范围
														</div>
													</div>
													<div class="colChartWrap draw_canvas">
														<div class="colChart draw_canvas">
															<div class="posAb_X draw_canvas">
																<div class="num draw_canvas" data-type="span" data-span="0">
																	0
																</div>
																<div class="num draw_canvas" data-type="span"
																	data-span="0.5">
																	0.5
																</div>
																<div class="num draw_canvas" data-type="span" data-span="1">
																	1
																</div>
																<div class="num draw_canvas" data-type="span"
																	data-span="1.5">
																	1.5
																</div>
																<div class="num draw_canvas" data-type="span" data-span="2">
																	2
																</div>
																<div class="num draw_canvas" data-type="span"
																	data-span="2.5">
																	2.5
																</div>
															</div>
															<div class="posAb_Y draw_canvas">
																<div class="num draw_canvas" :key="index2"
																	v-for="(item2, index2) in posAb_Y_arr">
																	{{ item2 }}
																</div>
															</div>
															<div class="posAb_Green draw_canvas" data-type="span"
																data-background="#EDFFF0"></div>
															<div class="posAb_cont draw_canvas">
																<div class="cList draw_canvas"
																	v-for="(item5, index5) in everyHeight" :key="index5"
																	:style="{
																		left: index5 * 25 + 'px',
																		height: item5 + 'px',
																	}">
																	<div :class="[
																		'in_cList draw_canvas',
																		isSharing ? 'bgB67FFA' : 'bgB67FFA_D2B1FC',
																	]" data-type="span" data-background="#B67FFA" v-if="index5 < 5"></div>
																	<div :class="[
																		'in_cList draw_canvas',
																		isSharing ? 'bgB67FFA' : 'bg7AAEFC_C8B2FF',
																	]" data-type="span" data-background="#A6B1FF" v-if="index5 >= 5 && index5 < 15">
																	</div>
																	<div :class="[
																		'in_cList draw_canvas',
																		isSharing ? 'bgB67FFA' : 'bgB67FFA_D2B1FC',
																	]" data-type="span" data-background="#B67FFA" v-if="index5 >= 15"></div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<!-- 柱状图end -->

											<!-- 睡眠时长 -->
											<div class="content-chart pd0" v-if="item.indexName == '睡眠时长'">
												<div v-if="item.trendsDataFlag">
													<div id="more_smsc" key="myChartsl1" style="height: 180px;"></div>
												</div>
											</div>
											<!-- 深睡时长 -->
											<div v-if="item.indexName == '深睡时长'">
												<div class="content-chart pd0" v-if="item.trendsDataFlag">
													<div id="more_sssc" key="myCharts33" style="height: 110px;"></div>
												</div>
												<div class="content-chart pd0" v-if="!item.trendsDataFlag">
													<div class="noVal" v-if="activeType == 3">
														过去7天没有深睡
													</div>
													<div class="noVal" v-if="activeType == 4">
														过去30天没有深睡
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 90
														">
														过去3个月没有深睡
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 180
														">
														过去6个月没有深睡
													</div>
												</div>
											</div>
											<!-- 夜醒时长 -->
											<div v-if="item.indexName == '夜醒时长'">
												<div class="content-chart pd0" v-if="item.trendsDataFlag">
													<div id="more_yxsc" key="myCharts" style="height: 110px;"></div>
												</div>
												<div class="content-chart pd0" v-if="!item.trendsDataFlag">
													<div class="noVal" v-if="activeType == 3">
														过去7天夜间没有发生清醒
													</div>
													<div class="noVal" v-if="activeType == 4">
														过去30天夜间没有发生清醒
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 90
														">
														过去3个月夜间没有发生清醒
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 180
														">
														过去6个月夜间没有发生清醒
													</div>
												</div>
											</div>
											<!-- 离床次数 -->
											<div v-if="item.indexName == '离床次数'">
												<!-- {{item.trendsDataFlag}} -->
												<div class="content-chart pd0" v-if="item.trendsDataFlag">
													<div id="more_lccs" key="myCharts23" style="height: 110px;"></div>
												</div>
												<div class="content-chart pd0" v-if="!item.trendsDataFlag">
													<div class="noVal" v-if="activeType == 3">
														过去7天夜间没有发生离床
													</div>
													<div class="noVal" v-if="activeType == 4">
														过去30天夜间没有发生离床
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 90
														">
														过去3个月夜间没有发生离床
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 180
														">
														过去6个月夜间没有发生离床
													</div>
												</div>
											</div>
											<!-- 入睡时长 -->
											<div v-if="item.indexName == '入睡时长'">
												<div class="content-chart pd0" v-if="item.trendsDataFlag">
													<div id="more_rssc" key="myChartsl2" style="height: 110px;"></div>
												</div>
												<div class="content-chart pd0" v-if="!item.trendsDataFlag">
													<div class="noVal" v-if="activeType == 3">
														过去7天入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4">
														过去30天入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 90
														">
														过去3个月入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 180
														">
														过去6个月入睡时长均为0分钟
													</div>
												</div>
											</div>
											<!-- 睡眠效率 -->
											<div v-if="item.indexName == '睡眠效率'">
												<div class="content-chart pd0" v-if="item.trendsDataFlag">
													<div id="more_smxl" key="myChartsl3" style="height: 110px;"></div>
												</div>
											</div>
											<!-- 体动指数 -->
											<div v-if="item.indexName == '体动指数'">
												<div class="content-chart pd0" v-if="item.trendsDataFlag">
													<div id="more_tdzs" key="myChartsl4" style="height: 110px;"></div>
												</div>
												<div class="content-chart pd0" v-if="!item.trendsDataFlag">
													<div class="noVal" v-if="activeType == 3">
														过去7天入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4">
														过去30天入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 90
														">
														过去3个月入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 180
														">
														过去6个月入睡时长均为0分钟
													</div>
												</div>
											</div>
											<!-- AHI -->
											<div v-if="item.indexName == 'AHI'">
												<div class="content-chart pd0" v-if="item.trendsDataFlag">
													<div id="more_ahi" key="myChartsl5" style="height: 110px;"></div>
												</div>
												<div class="content-chart pd0" v-if="!item.trendsDataFlag">
													<div class="noVal" v-if="activeType == 3">
														过去7天入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4">
														过去30天入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 90
														">
														过去3个月入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 180
														">
														过去6个月入睡时长均为0分钟
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<!-- 睡眠规律，呼吸率，心率 -->
								<div class="nowListWrap">
									<div class="nowList">
										<div class="nowTop">
											<img class="goodImg" :src="imgUrl + '/report_index_icon_bed_d@2x.png'"></img>
											<div class="titName ml10">睡眠规律</div>
										</div>
										<div id="more_smgl" key="myChartsl6" style="height: 90px;"></div>
									</div>
									<div class="nowList">
										<div class="nowTop">
											<img class="goodImg" :src="imgUrl + '/h5_details_icon_breathe_d@2x.png'"></img>
											<div class="titName ml10">呼吸率</div>
										</div>
										<div id="more_hxl" key="myChartsl7" style="height: 90px;"></div>
									</div>
									<div class="nowList">
										<div class="nowTop">
											<img class="goodImg" :src="imgUrl + '/h5_details_icon_heart_d@2x.png'"></img>
											<div class="titName ml10">心率</div>
										</div>
										<div id="more_xl" key="myChartsl8" style="height: 90px;"></div>
									</div>
								</div>

								<!-- 呼吸详情 -->
								<div class="comNameTitWrap mt32">
									<div class="leCircle"></div>
									<div class="riFontWrap">
										<div class="fontName">呼吸详情</div>
										<div class="engName">/ Score Details</div>
									</div>
								</div>

								
								<div class="nowListWrap" v-if="true">
									<div :key="index" v-for="(item, index) in moreDayData.reportIndexList">
										<div :class="[
											'nowList',
											item.normalFlag != 0 ? 'nowList_Ques' : '',
										]" v-if="item.indexName == '吸呼比' || item.indexName == 'AHI'">
											<!-- <div :class="['nowList',item.normalFlag != 0 ? 'nowList_Ques' : '']"> -->
											<!-- 指标标题start -->
											<div class="nowTop alignItemStart">
												<img class="goodImg mt5" :src="imgUrl + '/report_icon_good_d@2x.png'"
													v-if="item.normalFlag == 0"></img>
												<img class="goodImg mt5" :src="imgUrl + '/Icon_alarm.png'"
													v-if="item.normalFlag != 0 && item.indexName != 'AHI'"></img>
												<img class="goodImg mt5" src="../assets/img/report_icon_notice_Yellow.png"
													v-if="item.normalFlag != 0 && item.indexName == 'AHI' && (item.normalFlagAhi == 5 || item.normalFlagAhi == 15)"></img>
												<img class="goodImg mt5" :src="imgUrl + '/Icon_alarm.png'"
													v-if="item.normalFlag != 0 && item.indexName == 'AHI' && item.normalFlagAhi == 30"></img>
												<!-- 无问题数据 -->
												<div class="titName ml10" v-if="item.normalFlag == 0">
													<div v-if="item.indexName != '吸呼比' &&
														item.indexName != 'AHI' &&
														item.indexName != '离床次数'
														">
														平均{{ item.indexName }}
													</div>
													<div v-if="item.indexName == '离床次数'">
														最多{{ item.indexName }}
													</div>
													<div v-if="item.indexName == '吸呼比'">
														{{ item.indexName }}
													</div>
													<div v-if="item.indexName == 'AHI'">
														<!-- {{ item.indexName }}平均 -->
														呼吸异常指数平均
													</div>
													<!-- 睡眠时长、夜醒时长、入睡时长、深睡时长 -->
													<div class="sleepTime ml10" v-if="item.indexName == '睡眠时长' ||
														item.indexName == '夜醒时长' ||
														item.indexName == '入睡时长' ||
														item.indexName == '深睡时长'
														">
														<div class="color1890FF" v-if="item.indexValHour">
															{{ item.indexValHour }}
														</div>
														<div class="" v-if="item.indexValHour">小时</div>
														<div class="color1890FF">
															{{ item.indexValMinute }}
														</div>
														<div class="">分钟</div>
													</div>
													<!-- 深睡时长 -->
													<div class="flex" v-if="item.indexName == '深睡时长'">
														(
														<div class="color1890FF">{{ item.indexValPct }}%</div>
														)
													</div>
													<!-- 睡眠效率 -->
													<div class="color1890FF ml10" v-if="item.indexName == '睡眠效率'">
														{{ item.indexVal }}
													</div>
													<!-- 离床次数 -->
													<div class="sleepTime ml10" v-if="item.indexName == '离床次数'">
														<div class="color1890FF">{{ item.indexVal }}</div>
														<div>次</div>
													</div>
													<!-- 体动指数 -->
													<div class="sleepTime ml10" v-if="item.indexName == '体动指数'">
														<div class="color1890FF">{{ item.indexVal }}</div>
													</div>
													<!-- 吸呼比 -->
													<div class="sleepTime ml10" v-if="item.indexName == '吸呼比'">
														<div class="color1890FF">{{ item.indexVal }}</div>
													</div>
													<!-- AHI -->
													<div class="color1890FF ml10 posRela flex_alignCen"
														v-if="item.indexName == 'AHI'">
														{{ item.indexVal }}
														<div class="comment-box-more ">
															<div class="tooltip">
																<img class="wenhaoImg" :src="imgUrl + '/wenhaoIcon.png'"
																	@click="ahiWenhaoTan = true" id="ahi" />
																<div class="tooltiptext" style="top: -360px;">
																	<div class="ahi-title">
																		呼吸异常指数是通过我们观察到的确信的呼吸异常事件发生的次数计算出来的，在一定程度上反应使用者呼吸的大概情况，这个指数越大，您在呼吸方面发生异常的风险越高。如果需要更精准的监测，可以使用我们的QS-600产品，数据仅供参考，如果有需要可以去专业的医疗机构寻求帮助。
																	</div>
																	<div class="ahi-item" v-html="'指数<5 是健康'"></div>
																	<div class="ahi-item ahi-item2"
																		v-html="'5≤指数<15 疑似低风险'"></div>
																	<div class="ahi-item ahi-item2"
																		v-html="'15≤指数<30 疑似中风险'"></div>
																	<div class="ahi-item ahi-item3" v-html="'指数≥30 疑似高风险'">
																	</div>
																</div>
															</div>
														</div>

													</div>
												</div>
												<!-- 有问题数据 -->
												<div class="titName ml10" v-if="item.normalFlag == 3 ||
													item.normalFlag == 4 ||
													item.normalFlag == 5 ||
													item.normalFlag == 6
													">
													<!-- 睡眠时长小于6小时 -->
													<div v-if="item.indexName == '睡眠时长' &&
														item.normalFlagSleepDuration == 6
														">
														<!-- 睡眠时长_周_月_3月_6月 -->
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚睡眠时长小于6小时
														</div>
														<div v-if="activeType == 4">
															过去30天出现
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															晚睡眠时长小于6小时
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月出现
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															晚睡眠时长小于6小时
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月出现
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															晚睡眠时长小于6小时
														</div>
													</div>
													<!-- 睡眠时长大于10小时 -->
													<div v-if="item.indexName == '睡眠时长' &&
															item.normalFlagSleepDuration == 10
															">
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚睡眠时长大于10小时
														</div>
														<div v-if="activeType == 4">
															过去30天出现
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															晚睡眠时长大于10小时
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月出现
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															晚睡眠时长大于10小时
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月出现
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															晚睡眠时长大于10小时
														</div>
													</div>
													<!-- 深睡时长少于20% -->
													<div v-if="item.indexName == '深睡时长' &&
															item.normalFlagDeepDuration == 20
															">
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚深睡时长少于20%
														</div>
														<div v-if="activeType == 4">
															过去30天出现
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚深睡时长少于20%
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月出现
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚深睡时长少于20%
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月天出现
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚深睡时长少于20%
														</div>
													</div>
													<!-- 深睡时长大于60% -->
													<div v-if="item.indexName == '深睡时长' &&
															item.normalFlagDeepDuration == 60
															">
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚深睡时长大于60%
														</div>
														<div v-if="activeType == 4">
															过去30天出现
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚深睡时长大于60%
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月出现
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚深睡时长大于60%
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月天出现
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚深睡时长大于60%
														</div>
													</div>
													<!-- 夜醒时长超过31分钟 -->
													<div v-if="item.indexName == '夜醒时长'">
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚夜间醒来时长超过31分钟
														</div>
														<div v-if="activeType == 4">
															过去30天出现
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															晚夜间醒来时长超过31分钟
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月出现
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															晚夜间醒来时长超过31分钟
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月出现
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															晚夜间醒来时长超过31分钟
														</div>
													</div>
													<!-- 离床次数大于2次 -->
													<div v-if="item.indexName == '离床次数'">
														<div v-if="activeType == 3">
															过去7天有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚夜间离床次数超过2次
														</div>
														<div v-if="activeType == 4">
															过去30天有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚夜间离床次数超过2次
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚夜间离床次数超过2次
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚夜间离床次数超过2次
														</div>
													</div>
													<!-- 入睡时长超过30分钟 -->
													<div v-if="item.indexName == '入睡时长'">
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚入睡时长超过30分钟
														</div>
														<div v-if="activeType == 4">
															过去30天出现
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚入睡时长超过30分钟
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月出现
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚入睡时长超过30分钟
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月出现
															<span class="color1890FF">{{
																item.continuityDaysFrequency
															}}</span>
															次连续至少3晚入睡时长超过30分钟
														</div>
													</div>
													<!-- 睡眠效率>=80% -->
													<div v-if="item.indexName == '睡眠效率'">
														<div v-if="activeType == 3">
															过去7天有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚睡眠效率小于80%
														</div>
														<div v-if="activeType == 4">
															过去30天有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚睡眠效率小于80%
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚睡眠效率小于80%
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚睡眠效率小于80%
														</div>
													</div>
													<!-- 体动指数大于15 -->
													<div v-if="item.indexName == '体动指数' &&
															item.normalFlagTurnOverIndex == 15
															">
														<div v-if="activeType == 3">
															过去7天有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚体动指数大于15
														</div>
														<div v-if="activeType == 4">
															过去30天有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚体动指数大于15
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚体动指数大于15
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚体动指数大于15
														</div>
													</div>
													<!-- 体动指数小于1.25 -->
													<div v-if="item.indexName == '体动指数' &&
															item.normalFlagTurnOverIndex == 1.25
															">
														<div v-if="activeType == 3">
															过去7天有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚体动指数小于1.25
														</div>
														<div v-if="activeType == 4">
															过去30天有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚体动指数小于1.25
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚体动指数小于1.25
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月有
															<span class="color1890FF">{{
																item.continuityDays
															}}</span>
															晚体动指数小于1.25
														</div>
													</div>
													<!-- AHI 5-15 15-30 >30 -->
													<div v-if="item.indexName == 'AHI'" style="display: flex;">
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="colorFFB971"
																v-if="item.normalFlagAhi == 5 || item.normalFlagAhi == 15">{{
																	item.continuityDays }}</span>
															<span class="colorFF7186" v-if="item.normalFlagAhi == 30">{{
																item.continuityDays }}</span>
															晚呼吸异常指数大于等于
															<span v-if="item.normalFlagAhi == 5">5</span>
															<span v-if="item.normalFlagAhi == 15">15</span>
															<span v-if="item.normalFlagAhi == 30">30</span>
														</div>
														<div v-if="activeType == 4">
															过去30天有
															<span class="colorFFB971"
																v-if="item.normalFlagAhi == 5 || item.normalFlagAhi == 15">{{
																	item.continuityDays }}</span>
															<span class="colorFF7186" v-if="item.normalFlagAhi == 30">{{
																item.continuityDays }}</span>
															晚呼吸异常指数大于等于
															<span v-if="item.normalFlagAhi == 5">5</span>
															<span v-if="item.normalFlagAhi == 15">15</span>
															<span v-if="item.normalFlagAhi == 30">30</span>
														</div>
														<div v-if="activeType == 4 && InterfaceBack_healthTrendsDays == 90">
															过去3个月有
															<span class="colorFFB971"
																v-if="item.normalFlagAhi == 5 || item.normalFlagAhi == 15">{{
																	item.continuityDays }}</span>
															<span class="colorFF7186" v-if="item.normalFlagAhi == 30">{{
																item.continuityDays }}</span>
															晚呼吸异常指数大于等于
															<span v-if="item.normalFlagAhi == 5">5</span>
															<span v-if="item.normalFlagAhi == 15">15</span>
															<span v-if="item.normalFlagAhi == 30">30</span>
														</div>
														<div
															v-if="activeType == 4 && InterfaceBack_healthTrendsDays == 180">
															过去6个月有
															<span class="colorFFB971"
																v-if="item.normalFlagAhi == 5 || item.normalFlagAhi == 15">{{
																	item.continuityDays }}</span>
															<span class="colorFF7186" v-if="item.normalFlagAhi == 30">{{
																item.continuityDays }}</span>
															晚呼吸异常指数大于等于
															<span v-if="item.normalFlagAhi == 5">5</span>
															<span v-if="item.normalFlagAhi == 15">15</span>
															<span v-if="item.normalFlagAhi == 30">30</span>
														</div>
														<!-- 新增 -->
														<div class="color1890FF ml10 posRela flex_alignCen"
															v-if="item.indexName == 'AHI'"
															style="margin-left: 0px !important; margin-top: -2px; ">
															<div class="comment-box-more ">
																<div class="tooltip">
																	<img class="wenhaoImg" :src="imgUrl + '/wenhaoIcon.png'"
																		@click="ahiWenhaoTan = true" id="ahi" />
																	<div class="tooltiptext" style="top: -360px;">
																		<div class="ahi-title">
																			呼吸异常指数是通过我们观察到的确信的呼吸异常事件发生的次数计算出来的，在一定程度上反应使用者呼吸的大概情况，这个指数越大，您在呼吸方面发生异常的风险越高。如果需要更精准的监测，可以使用我们的QS-600产品，数据仅供参考，如果有需要可以去专业的医疗机构寻求帮助。
																		</div>
																		<div class="ahi-item" v-html="'指数<5 是健康'"></div>
																		<div class="ahi-item ahi-item2"
																			v-html="'5≤指数<15 疑似低风险'"></div>
																		<div class="ahi-item ahi-item2"
																			v-html="'15≤指数<30 疑似中风险'"></div>
																		<div class="ahi-item ahi-item3"
																			v-html="'指数≥30 疑似高风险'"></div>
																	</div>
																</div>
															</div>

														</div>
													</div>
													<!-- 吸呼比 -->
													<div v-if="item.indexName == '吸呼比'">
														<div v-if="activeType == 3">
															过去7天出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚吸呼比集中在非正常区间
														</div>
														<div v-if="activeType == 4">
															过去30天出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚吸呼比集中在非正常区间
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 90
																">
															过去3个月出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚吸呼比集中在非正常区间
														</div>
														<div v-if="activeType == 4 &&
																InterfaceBack_healthTrendsDays == 180
																">
															过去6个月出现连续
															<span class="colorFF7186">{{
																item.continuityDays
															}}</span>
															晚吸呼比集中在非正常区间
														</div>
													</div>
												</div>
											</div>
											<!-- 指标标题end -->
											<!-- 有问题和没问题的共用start -->
											<div class="referVal" v-if="item.indexName == '睡眠时长'">
												参考值：6～10小时
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<div class="referVal" v-if="item.indexName == '深睡时长'">
												参考值：20%~60%
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<div class="referVal" v-if="item.indexName == '夜醒时长'">
												参考值：≤31分钟
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<div class="referVal" v-if="item.indexName == '离床次数'">
												参考值：0～2次
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<div class="referVal" v-if="item.indexName == '入睡时长'">
												参考值：{{ xyh_lt }} 30分钟
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<div class="referVal" v-if="item.indexName == '睡眠效率'">
												参考值：≥80%
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<div class="referVal" v-if="item.indexName == '体动指数'">
												参考值：1.25~15
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<div class="referVal" v-if="item.indexName == 'AHI'">
												参考值：{{ xyh_lt }} 5
												<div class="referValRight">
													<div class="gangKuai"></div>
													<div class="gantTip">正常范围</div>
													<div class="gangWrap ml24">
														<div class="gang bgFF7186"></div>
														<div class="gang bgFF7186"></div>
														<div class="gang bgFF7186"></div>
													</div>
													<div class="gantTip">异常参考</div>
													<div class="gangWrap ml24">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<!-- 有问题和没问题的共用end -->

											<div class="deExplain mt10"
												v-if="item.normalFlag == 3 || item.normalFlag == 4 || item.normalFlag == 5 || item.normalFlag == 6">
												<div class="deExTop" @click="clc_xxjd(index, 'more_smzb')">
													<div class="deExTopTip">详细解读</div>
													<div class="deExTop_iconWrap">
														<img class="deExTop_icon" v-if="item.isShow_advise"
															src="../assets/static/icon_unscramble_up_h@2x.png"
															mode="widthFix"></img>
														<img class="deExTop_icon" v-if="!item.isShow_advise"
															src="../assets/static/report_detail_icon_down_h@2x.png"
															mode="widthFix"></img>
													</div>
												</div>
												<div class="pb20" style="border-top: 2px solid #E8EAED;"
													v-if="item.isShow_advise">
													<!-- 有问题的指标 -->
													<div v-if="item.normalFlag == 3 ||
														item.normalFlag == 4 ||
														item.normalFlag == 5 ||
														item.normalFlag == 6
														">
														<!-- 睡眠时长 -->
														<div class="yxsc" v-if="item.indexName == '睡眠时长'">
															<div class="quesCont">
																<!-- 小于6小时 -->
																<div v-if="item.normalFlagSleepDuration == 6">
																	根据美国南佛罗里达大学衰老研究学院助理教授Soomi
																	Lee研究发现，只需要连续3个晚上的睡眠时长小于6小时，就足以导致人的精神和身体健康状况出现严重恶化
																</div>
																<!-- 大于10小时 -->
																<div v-if="item.normalFlagSleepDuration == 10">
																	英国基尔大学的科学家在对74项研究涉及300余万人的研究分析发现，与睡7个小时相比，睡10个小时的死亡风险会提高30%。与此同时，死于中风的风险会提高56%，死于心血管疾病的风险会提高49%。
																</div>
																<div class="mt15">建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green4.png'"></img>
																<div class="yxCont">
																	制定规律的作息时间，并严格遵守
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green1.png'"></img>
																<div class="yxCont">
																	睡眠环境尽量避免光照和噪音，室温保持。在18~24℃，选择舒适的床品，睡前泡脚放松
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green2.png'"></img>
																<div class="yxCont">
																	午睡别太久，20 分钟左右为宜
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	每周3～5次30分钟有氧运动，避开睡前3小时，放松心情，释放压力
																</div>
															</div>
															<div class="quesCont">
																<div>
																	在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助
																</div>
															</div>
														</div>
														<!-- 深睡时长小于20% -->
														<div class="yxsc" v-if="item.indexName == '深睡时长' &&
															item.normalFlagDeepDuration == 20
															">
															<div class="quesCont">
																<div>
																	荷兰神经科学研究所的伊斯布兰德·范德韦夫及同事在《自然神经学》杂志发表报告指出深度睡眠过短会导致记忆力变差
																</div>
																<div>
																	美国斯坦福大学的研究团队随访持续21年的分析结果表明，深度睡眠不良与全因死亡率及心血管疾病发作风险升高有关。
																</div>
																<div class="mt15">建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red4.png'"></img>
																<div class="yxCont">
																	远离烟酒，晚餐避免大吃大喝
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green1.png'"></img>
																<div class="yxCont">
																	睡眠环境尽量避免光照和噪音，室温保持在18~24℃，选择舒适的床品，睡前泡脚放松
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green2.png'"></img>
																<div class="yxCont">
																	午睡别太久，20 分钟左右为宜
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	每周3～5次30分钟有氧运动，避开睡前3小时，放松心情，释放压力
																</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4 ||
																	InterfaceBack_healthTrendsDays == 90
																	">
																	在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果有6个月依然没有改善，可以找专业的医生寻求帮助
																</div>
															</div>
														</div>
														<!-- 深睡时长大于60% -->
														<div class="yxsc" v-if="item.indexName == '深睡时长' &&
															item.normalFlagDeepDuration == 60
															">
															<div class="quesCont">
																<div>
																	深睡眠是人体黄金睡眠，一般深睡眠占比在20%～60%，具体情况因人而异。过长的深睡眠可能是过度劳累或者身体某种疾病导致的，长期的深睡眠过长，可能会引发头痛、头晕等不适的症状，导致大脑的神经缺乏敏感性，大脑的神经中枢受到影响，容易发生注意力不集中和反应较迟钝的现象，影响日常生活和生命健康
																</div>
																<div class="mt15">建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green4.png'"></img>
																<div class="yxCont">
																	合理安排工作和生活节奏，坚持规律的作息，早上按固定时间起床，不要赖床
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green2.png'"></img>
																<div class="yxCont">适度午休，20分钟左右为宜</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4 ||
																	InterfaceBack_healthTrendsDays == 90
																	">
																	在尝试了上述方法后，您可以持续观察深睡时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	在尝试了上述方法后，您可以持续观察深睡时长的变化，您已经有6个月依然没有改善，建议尽快找专业的医生寻求帮助
																</div>
															</div>
														</div>
														<!-- 夜醒时长 -->
														<div class="yxsc" v-if="item.indexName == '夜醒时长'">
															<div class="quesCont">
																<div>
																	根据《睡眠医学》的研究，如果连续6个月每周都至少发生3次夜间觉醒时间超过31分钟，即可定义为失眠
																</div>
																<div class="mt15">建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red3.png'"></img>
																<div class="yxCont">
																	睡前2小时不要喝咖啡或酒，不要过度饮水，控制一下饮食
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green1.png'"></img>
																<div class="yxCont">
																	睡眠环境尽量避免光照和噪音，室温保持在18~24℃，选择舒适的床品，睡前泡脚放松
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green2.png'"></img>
																<div class="yxCont">
																	午睡别太久，20 分钟左右为宜
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	每周3～5次30分钟有氧运动，避开睡前3小时，放松心情，释放压力
																</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4 ||
																	InterfaceBack_healthTrendsDays == 90
																	">
																	在尝试了上述方法后，您可以持续观察夜间醒来时长的变化，如果超过6个月依然没有改善，可以去医疗中心找到专业的医生帮您制定解决方案
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	在尝试了上述方法后，您可以持续观察夜间醒来时长的变化，您已经有6个月依然没有改善，建议尽快去医疗中心找到专业的医生帮您制定解决方案
																</div>
															</div>
														</div>
														<!-- 离床次数 -->
														<div class="yxsc" v-if="item.indexName == '离床次数'">
															<div class="quesCont">
																<div>
																	专家表示，一般情况下人起夜的次数在0～2次，起夜次数超过2次，且持续多日，则说明夜尿频率高，与之相关的疾病包括：糖尿病、前列腺增生、泌尿系统感染等，需要引起警惕
																</div>
																<div class="mt15">建议您尝试如下改善：</div>
															</div>
															<div class="yxscList alignItemStart heiAuto">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red1.png'"></img>
																<div class="yxCont">
																	平常少吃盐
																	<div>
																		英国一项研究发现，减少食盐的摄入量，可明显减少起夜的次数。晚餐尤其要吃得清淡些，同时要减少高蛋白食物的摄入
																	</div>
																</div>
															</div>
															<div class="yxscList alignItemStart heiAuto">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green6.png'"></img>
																<div class="yxCont">
																	睡前半小时内少喝水
																	<div>
																		建议在睡觉前半小时，稍微抿上两口，最多不超过一杯（200毫升）
																	</div>
																</div>
															</div>
															<div class="yxscList alignItemStart heiAuto">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green5.png'"></img>
																<div class="yxCont">
																	经常做提肛运动
																	<div>
																		盆底部肌肉松弛，膀胱括约肌萎缩，包括膀胱弹性差，较少的尿量就会引起较强的尿意，所以提肛运动有助于增强盆底肌肉的力量，很好地减少起夜次数
																	</div>
																</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4 ||
																	InterfaceBack_healthTrendsDays == 90
																	">
																	在尝试了上述方法后，您可以持续观察夜间离床次数的变化，如果超过6个月依然没有改善，可以去医院做个详细检查
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	在尝试了上述方法后，您可以持续观察夜间离床次数的变化，您已经有6个月依然没有改善，建议尽快去医院做个详细检查
																</div>
															</div>
														</div>
														<!-- 入睡时长 -->
														<div class="yxsc" v-if="item.indexName == '入睡时长'">
															<div class="quesCont">
																<div>
																	依据世界卫生组织(WHO)标准，连续一个月每周至少有3天出现上床30分钟无法入睡即可判定为失眠
																</div>
																<div class="mt15">建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green4.png'"></img>
																<div class="yxCont">
																	合理安排工作和生活节奏，坚持规律的作息，按时上床睡觉
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red2.png'"></img>
																<div class="yxCont">
																	睡前远离电子设备，在床上不要玩手机、看书
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	每周坚持3～5次30分钟有氧运动，放松心情，释放压力
																</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4 ||
																	InterfaceBack_healthTrendsDays == 90
																	">
																	在尝试了上述方法后，您可以持续观察入睡时长的变化，如果超过6个月依然没有改善，可以去医院做个详细检查
																</div>
																<!-- 周月3月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	在尝试了上述方法后，您可以持续观察入睡时长的变化，您已经有6个月依然没有改善，建议尽快去医院做个详细检查
																</div>
															</div>
														</div>
														<!-- 睡眠效率 -->
														<div class="yxsc" v-if="item.indexName == '睡眠效率'">
															<div class="quesCont">
																<div>
																	有研究表明，睡眠效率小于80%是肥胖发生的一个危险因素
																</div>
																<div class="mt15">建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green4.png'"></img>
																<div class="yxCont">
																	合理安排工作和生活节奏，坚持规律的作息，有困意的时候再上床睡觉
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red2.png'"></img>
																<div class="yxCont">
																	睡前远离电子设备，在床上不要玩手机、看书
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	每周坚持3～5次30分钟有氧运动，放松心情，释放压力
																</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4 ||
																	InterfaceBack_healthTrendsDays == 90
																	">
																	在尝试了上述方法后，您可以持续观察睡眠效率的变化，如果超过6个月依然没有改善，可以去医院做个详细检查
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	在尝试了上述方法后，您可以持续观察入睡时长的变化，您已经有6个月依然没有改善，建议尽快去医院做个详细检查
																</div>
															</div>
														</div>
														<!-- 体动指数大于15次 -->
														<div class="yxsc" v-if="item.indexName == '体动指数' &&
															item.normalFlagTurnOverIndex == 15
															">
															<div class="quesCont">
																<div>
																	根据大数据的分析，大多数人的体动指数集中分布在1.25～15之间
																</div>
																<div>
																	体动体现的是您睡眠期间身体活动的规律，包括翻身和其他身体活动的记录，一般来说，我们都会有睡眠期间的体动，体动过多体现的是您睡觉不踏实，睡眠质量不够好，如果没有其他明显不适，均视为正常，无需过度担心
																</div>
																<div class="mt15">建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red4.png'"></img>
																<div class="yxCont">
																	远离烟酒，晚餐避免大吃大喝
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red2.png'"></img>
																<div class="yxCont">
																	睡前远离电子设备，在床上不要玩手机、看书
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	每周坚持3～5次30分钟有氧运动，放松心情，释放压力
																</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4 ||
																	InterfaceBack_healthTrendsDays == 90
																	">
																	在尝试了上述方法后，您可以持续观察体动指数的变化，如果超过6个月依然没有改善，可以去医院做个详细检查
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	在尝试了上述方法后，您可以持续观察体动指数的变化，您已经超过6个月依然没有改善，建议尽快去医院做个详细检查
																</div>
															</div>
														</div>
														<!-- 体动指数小于1.25次 -->
														<div class="yxsc" v-if="item.indexName == '体动指数' &&
															item.normalFlagTurnOverIndex == 1.25
															">
															<div class="quesCont">
																<div>
																	根据大数据的分析，大多数人的体动指数集中分布在1.25～15之间
																</div>
																<div>
																	体动体现的是您睡眠期间身体活动的规律，包括翻身和其他身体活动的记录，一般来说，我们都会有睡眠期间的体动，体动过少体现的是您睡觉非常平稳，如果没有其他明显不适，均视为正常，无需过度担心
																</div>
																<div class="mt15">建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green4.png'"></img>
																<div class="yxCont">
																	制定规律的作息时间，并严格遵守
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green2.png'"></img>
																<div class="yxCont">适度午休，20分钟左右为宜</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4 ||
																	InterfaceBack_healthTrendsDays == 90
																	">
																	在尝试了上述方法后，您可以持续观察体动指数的变化，如果超过6个月依然没有改善，可以去医院做个详细检查
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	在尝试了上述方法后，您可以持续观察体动指数的变化，您已经超过6个月依然没有改善，建议尽快去医院做个详细检查
																</div>
															</div>
														</div>
														<!-- AHI -->
														<div class="yxsc" v-if="item.indexName == 'AHI'">
															<div class="quesCont">
																<!-- 大于等于5 -->
																<div v-if="item.normalFlagAhi == 5">
																	呼吸异常指数是通过我们观察到的确信的呼吸异常事件发生的次数计算出来的，大于等于5即具有呼吸异常低风险
																</div>
																<!-- 大于等于15 -->
																<div v-if="item.normalFlagAhi == 15">
																	呼吸异常指数是通过我们观察到的确信的呼吸异常事件发生的次数计算出来的，大于等于15小于30即具有呼吸异常中风险
																</div>
																<!-- 大于等于30 -->
																<div v-if="item.normalFlagAhi == 30">
																	呼吸异常指数是通过我们观察到的确信的呼吸异常事件发生的次数计算出来的，大于等于30即具有呼吸异常高风险
																</div>
																<div class="mt15">建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green8.png'"></img>
																<div class="yxCont">
																	改变卧姿，尽量以侧卧进入睡眠
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green7.png'"></img>
																<div class="yxCont">
																	尽量不睡高枕头，保持呼吸道的通畅
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red4.png'"></img>
																<div class="yxCont">
																	合理饮食，控制体重，远离烟酒
																</div>
															</div>
															<!-- 大于等于5 -->
															<div class="yxscList" v-if="item.normalFlagAhi == 5">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	适量运动，增强体质，预防感冒
																</div>
															</div>
															<!-- 大于等于15 大于等于30 -->
															<div class="yxscList"
																v-if="item.normalFlagAhi == 15 || item.normalFlagAhi == 30">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green9.png'"></img>
																<div class="yxCont">
																	必要时可选择经鼻正压通气治疗
																</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div
																	v-if="activeType == 3 || activeType == 4 || InterfaceBack_healthTrendsDays == 90">
																	在尝试了上述方法后，您可以持续观察呼吸异常指数的变化，如果超过6个月依然没有改善，可以去医院做个详细检查
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	在尝试了上述方法后，您可以持续观察呼吸异常指数的变化，您已经有6个月依然没有改善，建议尽快去医院做个详细检查
																</div>
															</div>
														</div>
														<!-- 吸呼比 -->
														<div class="yxsc" v-if="item.indexName == '吸呼比'">
															<div class="quesCont">
																<div>
																	根据大数据分析，正常人的吸呼比集中在0.8～1.5之间
																</div>
																<div class="mt15">建议您尝试如下改善：</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green7.png'"></img>
																<div class="yxCont">
																	尽量不睡高枕头，保持呼吸道的通畅
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_red4.png'"></img>
																<div class="yxCont">
																	合理饮食，控制体重，远离烟酒
																</div>
															</div>
															<div class="yxscList">
																<img class="yxIcon"
																	:src="imgUrl + '/icon_rep_green3.png'"></img>
																<div class="yxCont">
																	适量运动，增强体质，预防感冒
																</div>
															</div>
															<div class="quesCont">
																<!-- 周月3月 -->
																<div v-if="activeType == 3 ||
																	activeType == 4 ||
																	InterfaceBack_healthTrendsDays == 90
																	">
																	在尝试了上述方法后，您可以持续观察吸呼比的变化，如果超过6个月依然没有改善，可以去医院做个详细检查
																</div>
																<!-- 6月 -->
																<div v-if="InterfaceBack_healthTrendsDays == 180">
																	在尝试了上述方法后，您可以持续观察吸呼比的变化，您已经有6个月依然没有改善，建议尽快去医院做个详细检查
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>

											<!-- 吸呼比 -->
											<!-- 柱状图有问题的指标共用 -->
											<!-- <div v-if="item.indexName == '吸呼比' && item.normalFlag != 0"> -->
											<div v-if="item.indexName == '吸呼比'">
												<div class="lx_list_data">
													<div class="lx_list" :key="index2"
														v-for="(item2, index2) in item.extendData"
														@click="cli_more_xh_date(item2.date)">
														<!-- item2.normalFlag "正常标志, 0-正常 1-非正常" -->
														<div :class="['cirIcon', item2.isSelectedDate ? 'bg1890FF' : '',]"
															style="border: 3px solid #1890FF"
															v-if="item2.normalFlag == 0 && item2.inExRatioData.data.length > 0">
														</div>
														<div :class="['cirIcon', item2.isSelectedDate ? 'bgFF4D4F' : '',]"
															v-if="item2.normalFlag == 1 && item2.inExRatioData.data.length > 0">
														</div>
														<div :class="['cirIcon', item2.isSelectedDate ? 'bgCCD0DF' : '',]"
															style="border: 3px solid #CCD0DF"
															v-if="item2.inExRatioData.data.length == 0"></div>
														<div class="nowDay">{{ item2.date }}</div>
													</div>
												</div>
												<div class="colPicWrap draw_canvas" v-show="isHave_xhb">
													<div class="colTop draw_canvas">
														<div class="topIcon draw_canvas" data-type="span"
															data-background="#EDFFF0"></div>
														<div class="topTit draw_canvas" data-type="span" data-span="参考范围">
															参考范围
														</div>
													</div>
													<div class="colChartWrap draw_canvas">
														<div id="myCharts_xhb" style="height: 170px; margin: 0 auto"></div>
													</div>
												</div>

												<div class="content-chart pd0" v-show="!isHave_xhb">
													<div class="noVal mt15" style="height: 200px;">暂无吸呼比</div>
												</div>
											</div>
											<!-- 柱状图end -->

											<!-- 睡眠时长 -->
											<div class="content-chart pd0" v-if="item.indexName == '睡眠时长'">
												<div id="more_smsc" key="myChartsl9" style="height: 180px;"></div>
											</div>
											<!-- 深睡时长 -->
											<div v-if="item.indexName == '深睡时长'">
												<div class="content-chart pd0" v-if="item.trendsDataFlag">
													<div id="more_sssc" key="myChartsl10" style="height: 110px;"></div>
												</div>
												<div class="content-chart pd0" v-if="!item.trendsDataFlag">
													<div class="noVal" v-if="activeType == 3">
														过去7天没有深睡
													</div>
													<div class="noVal" v-if="activeType == 4">
														过去30天没有深睡
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 90
														">
														过去3个月没有深睡
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 180
														">
														过去6个月没有深睡
													</div>
												</div>
											</div>
											<!-- 夜醒时长 -->
											<div v-if="item.indexName == '夜醒时长'">
												<div class="content-chart pd0" v-if="item.trendsDataFlag">
													<div id="more_yxsc" key="myChartsl11" style="width:100%;height: 110px;">
													</div>
												</div>
												<div class="content-chart pd0" v-if="!item.trendsDataFlag">
													<div class="noVal" v-if="activeType == 3">
														过去7天夜间没有发生清醒
													</div>
													<div class="noVal" v-if="activeType == 4">
														过去30天夜间没有发生清醒
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 90
														">
														过去3个月夜间没有发生清醒
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 180
														">
														过去6个月夜间没有发生清醒
													</div>
												</div>
											</div>
											<!-- 离床次数 -->
											<div v-if="item.indexName == '离床次数'">
												<div class="content-chart pd0" v-if="item.trendsDataFlag">
													<div id="more_lccs" key="myChartsl12" style="height: 110px;"></div>
												</div>
												<div class="content-chart pd0" v-if="!item.trendsDataFlag">
													<div class="noVal" v-if="activeType == 3">
														过去7天夜间没有发生离床
													</div>
													<div class="noVal" v-if="activeType == 4">
														过去30天夜间没有发生离床
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 90
														">
														过去3个月夜间没有发生离床
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 180
														">
														过去6个月夜间没有发生离床
													</div>
												</div>
											</div>
											<!-- 入睡时长 -->
											<div v-if="item.indexName == '入睡时长'">
												<div class="content-chart pd0" v-if="item.trendsDataFlag">
													<div id="more_rssc" key="myChartsl13" style="height: 110px;"></div>
												</div>
												<div class="content-chart pd0" v-if="!item.trendsDataFlag">
													<div class="noVal" v-if="activeType == 3">
														过去7天入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4">
														过去30天入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 90
														">
														过去3个月入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 180
														">
														过去6个月入睡时长均为0分钟
													</div>
												</div>
											</div>
											<!-- 睡眠效率 -->
											<div v-if="item.indexName == '睡眠效率'">
												<div class="content-chart pd0" v-if="item.trendsDataFlag">
													<div id="more_smxl" key="myChartsl14" style="height: 110px;"></div>
												</div>
											</div>
											<!-- 体动指数 -->
											<div v-if="item.indexName == '体动指数'">
												<div class="content-chart pd0" v-if="item.trendsDataFlag">
													<div id="more_tdzs" key="myChartsl15" style="height: 110px;"></div>
												</div>
												<div class="content-chart pd0" v-if="!item.trendsDataFlag">
													<div class="noVal" v-if="activeType == 3">
														过去7天入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4">
														过去30天入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 90
														">
														过去3个月入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 180
														">
														过去6个月入睡时长均为0分钟
													</div>
												</div>
											</div>
											<!-- AHI -->
											<div v-if="item.indexName == 'AHI'">
												<div class="content-chart pd0" v-if="item.trendsDataFlag">
													<div id="more_ahi" key="myChartsl16" style="height: 110px;"></div>
												</div>
												<div class="content-chart pd0" v-if="!item.trendsDataFlag">
													<div class="noVal" v-if="activeType == 3">
														过去7天入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4">
														过去30天入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 90
														">
														过去3个月入睡时长均为0分钟
													</div>
													<div class="noVal" v-if="activeType == 4 &&
														InterfaceBack_healthTrendsDays == 180
														">
														过去6个月入睡时长均为0分钟
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<!-- 得分详情 -->
								<div class="comNameTitWrap mt32">
									<div class="leCircle"></div>
									<div class="riFontWrap">
										<div class="fontName">得分详情</div>
										<div class="engName">/ Respiratory Details</div>
									</div>
								</div>

								<div class="nowListWrap">
									<div class="nowList" :key="index" v-for="(item, index) in moreDayData.scoreDetailList">
										<div v-if="item.indexName != '情绪值' && item.indexName != '活力值'">

											<div class="nowTop">
												<img class="goodImg mt5" :src="imgUrl + '/report_icon_good_d@2x.png'"
													v-if="item.normalFlag == 0"></img>
												<img class="goodImg mt5" :src="imgUrl + '/Icon_alarm.png'"
													v-if="item.normalFlag != 0"></img>
												<div class="titName ml10">{{ item.indexName }}</div>
											</div>
											<div class="referVal">
												平均值：{{ item.indexValOriginal }}分
												<div class="referValRight">
													<div class="gangWrap">
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
														<div class="gang bg63B2FB"></div>
													</div>
													<div class="gantTip">平均值</div>
												</div>
											</div>
											<div class="myChartsMore">
												<div id="more_smdf" key="myChartsl17" style="height: 110px;"
													v-if="item.index == 'score'"></div>
												<div id="more_dafxzs" key="myChartsl18" style="height: 110px;"
													v-if="item.index == 'fallIndex'">
												</div>
												<div id="more_hlz" key="myChartsl19" style="height: 110px;"
													v-if="item.index == 'vitalityIndex'">
												</div>
												<div id="more_qxz" key="myChartsl20" style="height: 110px;"
													v-if="item.index == 'moraleIndex'">
												</div>
											</div>

										</div>
									</div>
								</div>

								<!-- 睡眠解读 -->
								<div class="sleepReadWrap"
									v-if="activeType == 4 && moreDayData.sleepLawVo.sleepLawIrregularFlag">
									<img class="sReadTopImg" src="../assets/static/report_image_advice_d@2x.png"></img>
									<div class="smTopName">
										<div class="smTopNamePoint"></div>
										<div class="nameEx">
											根据您多天的睡眠数据，我们发现您的睡眠特点如下，提供给您一些睡眠建议来参考：
										</div>
									</div>
									<!-- 仅月有_睡眠类型 -->
									<div class="smTypeWrap" v-if="activeType == 4 && moreDayData.sleepLawVo">
										<!-- 早睡早起 -->
										<div class="quesCont" v-if="moreDayData.sleepLawVo.sleepLawType == '早睡早起'">
											<div class="smTopName">
												<div class="smTopNamePoint"></div>
												<div class="name">早睡早起</div>
											</div>
											<div class="n_exPlainWrap">
												<img class="blueCir" :src="imgUrl + '/smTypeIcon_zszq.png'"></img>
												<div class="n_exPlain">
													你是云雀型的睡眠习惯，早睡早起有益身心健康，思维活跃，办事效率高，可以继续保持。
												</div>
											</div>
										</div>
										<!-- 晚睡早起 -->
										<div class="quesCont" v-if="moreDayData.sleepLawVo.sleepLawType == '晚睡早起'">
											<div class="smTopName">
												<div class="smTopNamePoint"></div>
												<div class="name">晚睡早起</div>
											</div>
											<div class="n_exPlainWrap">
												<img class="blueCir" :src="imgUrl + '/smTypeIcon_wszq.png'"></img>
												<div class="n_exPlain">
													你是蜂鸟型的睡眠习惯，如果你感受良好，不会出现疲乏无力的现象，不用强行改变现有的习惯，如果想要调整成早睡早起型，可以在睡前避免摄入含有咖啡因的食物，尽早放下手机等电子设备，放松心情。
												</div>
											</div>
										</div>
										<!-- 早睡晚起 -->
										<div class="quesCont" v-if="moreDayData.sleepLawVo.sleepLawType == '早睡晚起'">
											<div class="smTopName">
												<div class="smTopNamePoint"></div>
												<div class="name">早睡晚起</div>
											</div>
											<div class="n_exPlainWrap">
												<img class="blueCir" :src="imgUrl + '/iconCuckoo@2x.png'"></img>
												<div class="n_exPlain">
													你是杜鹃型的睡眠习惯，如果你没有昏沉，疲劳的感受，可以保持现有的睡眠习惯，无需担心。如果你经常出现精神不振，睡不醒的状态，可以尝试早上定好闹钟，准点起床，不赖床，循序渐进地减少睡眠时间。
												</div>
											</div>
										</div>
										<!-- 晚睡晚起 -->
										<div class="quesCont" v-if="moreDayData.sleepLawVo.sleepLawType == '晚睡晚起'">
											<div class="smTopName">
												<div class="smTopNamePoint"></div>
												<div class="name">晚睡晚起</div>
											</div>
											<div class="n_exPlainWrap">
												<img class="blueCir" :src="imgUrl + '/smTypeIcon_wszq.png'"></img>
												<div class="n_exPlain">
													你是猫头鹰型的睡眠习惯，如果你日间并没有出现精神不振、疲乏、困倦等现象，不用过于担心，如果想要调整，可以在白天多晒晒太阳，睡前适当做点放松训练，保持不要太晚的有规律的上床时间。
												</div>
											</div>
										</div>
									</div>
									<!-- 仅月有_睡眠不规律 -->
									<div class="smTypeWrap" v-if="activeType == 4 &&
										moreDayData.sleepLawVo &&
										moreDayData.sleepLawVo.sleepLawIrregularFlag
										">
										<div class="smTopName">
											<div class="smTopNamePoint"></div>
											<div class="name">睡眠不规律</div>
										</div>
										<div class="n_exPlainWrap">
											<img class="blueCir" :src="imgUrl + '/Icon_alarm.png'"
												style="background: #fff;"></img>
											<div class="n_exPlain">
												想要获得规律性睡眠，建议睡前尽量避免摄入含有咖啡因的食物，避免剧烈运动，有了困意再上床，按确定的时间起床，不赖床。
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>

					<div class="content nodata-con" v-if="!isEmpty">
						<div class="empty-div" v-if="oneDayData.resultImg != 14 && resultImg != 15 && resultImg != 10008 && resultImg != 10009">
							<img v-if="resultImg == 12" mode="widthFix" class="empty-img"
								src="../assets/icon_report_empty_logo_1.png" />
							<img v-if="resultImg == 11" mode="widthFix" class="empty-img"
								src="../assets/img/image_middle_empty_check_d@2x.png" />
							<img v-if="resultImg == 13" mode="widthFix" class="empty-img"
								src="../assets/img/image_middle_lose_wifi_d@2x.png" />
							<img v-if="resultImg == 10003 || resultImg == 10004 || resultImg == 10005" mode="widthFix" class="empty-img"
								src="../assets/icon_report_empty_logo_1.png" />
							<img v-if="resultImg == 10002 || resultImg == 10007" mode="widthFix" class="empty-img"
								src="../assets/icon_report_empty_logo_2.png" />
							<img v-if="resultImg == 10000 || resultImg == 10006" mode="widthFix" class="empty-img"
								src="../assets/icon_report_empty_logo_3.png" />
							<img v-if="resultImg == 10001" mode="widthFix" class="empty-img"
								src="../assets/icon_report_empty_logo_4.png" />
							<div class="empty-title" v-if="activeType == 1" style="max-width: 224px;">
								{{ oneDayData.resultReason }}
							</div>
							<div class="empty-title" v-if="activeType != 1" style="max-width: 224px;">
								{{ moreDayData.resultReason }}
							</div>
						</div>

						<!-- 没有报告--调整&干扰 -->
						<div v-if="resultImg == 14 || resultImg == 10008" style="padding-bottom:132px; padding-top: 16px">
							<div class="nodata-report">
								<div class="nodata-span1">
									非常抱歉，我们未能抓到您的睡眠数据，建议您先自行排查床铺周边1米内，是否有以下情况：
								</div>
								<div class="nodata-img-box">
									<img class="nodata-img1" src="../assets/img/image_middle_condition2_d@2x.png" />
								</div>
								<div class="nodata-span1">
									<span>如有，请尽量搬移或避免出风口直吹床铺</span>
								</div>
							</div>
							<div class="nodata-report">
								<div class="nodata-line"></div>
								<div class="nodata-line2"></div>
								<div class="tips-img">
									<img class="tips-img-1" src="../assets/img/h5_share_quotes_left_d@2x.png" />
									<img class="tips-img-2" src="../assets/img/h5_share_matching_d@2x.png" />
								</div>
								<div class="nodata-span1">
									<span>如果已经排除以上原因，仍未收到睡眠报告，请及时与我们联系：</span>
								</div>
							</div>
						</div>
						<!-- 调整 -->
						<div v-if="resultImg == 15" style="padding-bottom:100px;">
							<div class="nodata-report">
								<div class="nodata-img-box">
									<img class="nodata-img2" src="../assets/img/no_sleep_gif.gif" />
								</div>
								<div class="nodata-span1 nodata-span1-mr">
									昨晚您睡觉的位置似乎有点跑偏，暂时无法帮您分析报告哦～
								</div>
							</div>
							<div class="nodata-report">
								<div class="nodata-line"></div>
								<div class="nodata-line2"></div>
								<div class="tips-img">
									<img class="tips-img-1" src="../assets/img/h5_share_quotes_left_d@2x.png" />
									<img class="tips-img-2" src="../assets/img/h5_share_matching_d@2x.png" />
								</div>
								<div class="nodata-span1 nodata-span1-mr">
									您可以尝试按照说明书去调整设备或自己睡觉的位置，让我们可以更精准地照顾到您哦～
								</div>
							</div>
						</div>
						<!-- 没有报告--10812 -->
						<div v-if="resultImg == 10009" style="padding-bottom:132px; padding-top: 16px">
							<div class="nodata-report">
								<div class="nodata-img-box">
									<img style="width: 303px; height: 280px;" src="../assets/img/image_middle_condition2_d_gif_1.png" />
								</div>
								<div class="nodata-span1" style="margin-top: 12px;">
									<span>昨晚您睡觉的位置与设备距离过远，暂时无法帮您分析报告哦～</span>
								</div>
							</div>
							<div class="nodata-report">
								<div class="nodata-line"></div>
								<div class="nodata-line2"></div>
								<div class="tips-img">
									<img class="tips-img-1" src="../assets/img/h5_share_quotes_left_d@2x.png" />
									<img class="tips-img-2" src="../assets/img/h5_share_matching_d@2x.png" />
								</div>
								<div class="nodata-span1">
									<span>您可以尝试按照说明书去调整设备或自己睡觉的位置，让我们可以更精准地照顾到您哦～</span>
								</div>
							</div>
						</div>

					</div>
				</div>
			</a-spin>
		</div>
		<!-- </a-modal> -->

		<AiReport v-if="this.$store.state.aiSingleReportData && this.$route.path.indexOf('report') >= 0" :itemData="this.$store.state.aiSingleReportData"  />

	</div>
</template>

<script>
import QRCode from "qrcodejs2";
import Comment from "../component/healthy/component/comment.vue";
import habitChange from "../component/healthy/component/habitChange.vue";
import breathDetail from "../component/healthy/component/breathDetail.vue";
import Scores from "../component/healthy/component/scores.vue";
import Ahis from "../component/healthy/component/ahis.vue";
import Falls from "../component/healthy/component/falls.vue";
import Vitalitys from "../component/healthy/component/vitalitys.vue";
import Morales from "../component/healthy/component/morales.vue";

import pieCom from "../component/toilet/pieCom.vue";

import AiReport from "./dean/aiReport.vue";

export default {
	components: {
		Comment,
		habitChange,
		Scores,
		Ahis,
		Falls,
		Vitalitys,
		Morales,
		pieCom,
		breathDetail,
		AiReport
	},
	data() {
		return {
			actionReport: false,
			isEmpty: false,
			hasFallPicData: true,
			isShowPic: true,
			timeArr: [],
			oneDayData: {}, //getSleepReportOneDay接口数据
			sleepTableTimeList: [], //睡眠周期上方时间数组字段
			sn: "",
			snCode: "",
			currentCar: "1",
			sliceTimeStr: [],
			showCalendar: false,
			dialogVisible: false,
			breathStatus: "",
			heartStatus: "",
			date: ["选择日期"],
			pbid: "",
			outBedSum: 1, //多日离床次数统计
			outBedTimeSum: 1, //多日离床时间统计
			turnSum: 1, //多日体动次数统计
			resultTitle2: "暂无内容",
			resultTitle: "暂无内容",
			spinning: true,
			beginTime: "",
			endTime: "",
			getBedTime: "",
			leaveBedTime: "",
			beginTimeLoc: 0,
			endTimeLoc: 0,
			getBedLoc: null,
			leaveBedLoc: null,
			effeWakeTime: [],
			effeLeaveBedTime: [],
			pageNum: 1, // 当前页
			pageSize: 20, // 每页默认20条
			total: 0,
			score: 0,
			loading: false,
			btnList: [
				{
					val: 1,
					title: "昨天",
					placeholder: "呈现昨天数据分析结果",
					// {
					//   val: 2,
					//   title: "前天",
					//   placeholder: "呈现前天数据分析结果",
					// },
				},
			],
			btnList2: [
				// 筛选列表
				// {
				//   val: 1,
				//   title: "昨天",
				//   placeholder: "呈现昨天数据分析结果",
				// },
				{
					val: 3,
					title: "过去7天",
					placeholder: "呈现过去7天数据分析结果",
				},
				{
					val: 4,
					title: "过去30天",
					placeholder: "呈现过去30天数据分析结果",
				},
			],
			activeType: 1, // 默认今天
			detailsPopup: true, // 查看弹窗状态
			popoverVisible: false,
			dataTitleList: [
				{
					name: "睡眠时长",
					img: require("../assets/icon_SleepTime_36.png"),
					time: 0,
					num: 0,
					type: 1,
				},
				{
					name: "体动次数",
					img: require("../assets/icon_SleepTurn_36.png"),
					num: 0,
					type: 2,
				},
				{
					name: "离床时长",
					img: require("../assets/icon_SleepLeaveTime_36.png"),
					time: 0,
					num: 0,
					type: 1,
				},
				{
					name: "离床次数",
					img: require("../assets/icon_SleepLeave_36.png"),
					num: 0,
					type: 2,
				},

				{
					name: "睡眠呼吸",
					img: require("../assets/icon_SleepLeaveTime_36.png"),
					status: "健康",
					result: 0,
					type: 3,
				},
			],
			myChart0: null,
			myChart1: null,
			myChart2: null,
			myChart3: null,
			myChart4: null,
			myChart5: null,
			myChart6: null,
			myChart7: null,
			myChart8: null,
			myChart9: null,
			myChart10: null,
			myChart11: null,
			myChart12: null,
			//myChartAbn: null,
			// myChartAbn2: null,
			// myChartAbn3: null,
			// myChartAbn4: null,
			myChartAbns: [],
			myChartAbnHeats: [],
			myChartAHI: null,
			detailsData: {}, // 详情单天数据
			detailsManyData: {}, // 详情多天 数据
			detailsManyData2: {},
			detailsManyData3: {},
			detailsManyDataSug: {},
			bedName: "", // 床名称
			sleepDetails: [], // 睡眠详情数据
			shareUrl: "", // 分享参数
			sortField: null,
			sortOrder: null,
			disabled: false,
			loading1: true,
			popoverTop: null,
			scrollTop: 0,
			healthReport: {
				//呼吸暂停低通气数据
				ahi: "",
				ai: "",
				apneaAverageTime: "",
				apneaFrequencyStr: [],
				apneaMaxTime: "",
				apneaProportion: "",
				apneaTimePoint: "",
				apneaTotalNumber: "",
				hi: "",
				hyponeaFrequencyStr: [],
				hyponeaTotalNumber: "",
				totalApneaTime: "",
				totalApneaTimeStr: "",
				totalHyponeaTime: "",
			},
			myResult: [
				"多吃蔬果多运动，继续保持良好的生活习惯",
				"多吃蔬果多运动，继续保持良好的生活习惯",
				"平时要预防感冒，戒烟戒酒，采用侧睡体位，尽量不睡高枕头，保持呼吸道的通畅，必要时配合药物治疗",
				"请及时就医，需要根据医生建议，配合治疗",
				"请及时就医，需要根据医生建议，配合治疗",
			], //建议
			sleep1: "0%",
			sleep2: "0%",
			sleep3: "0%",
			sleep4: "0%",
			dates: [],
			activeDates: [],
			activeDate: "",
			testData: null,
			testData0: null,
			sleepEffect: null,
			string: "指数<5",
			string1: "5≤指数<15",
			string2: "15≤指数<30",
			abnLength: null,
			abnIds: [],
			abnHeatIds: [],
			sleepBreathStatus: 1,
			sleepTotalTime: {},
			currentPage: 1,
			minutes: [],
			effeDatesData: null,
			effeDates: [],
			invalidDates: [],
			outGet: false,
			outBegin: false,
			outEnd: false,
			outLeave: false,
			// 多日数据开始

			moreDayData: {}, //多日数据
			resultImg: 12,
			imgUrl:
				"https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/QL_official_account",
			xyh_lt: "<",
			InterfaceBack_healthTrendsDays: "", //后端返回的三月六月区分字段  90三月  180六月
			smzbObj: {
				smsc: null,
				sssc: null,
				yxsc: null,
				lc: null,
				rssc: null,
				smxl: null,
				td: null,
				tdzs: null,
				hxl: null,
				xl: null,
				ddfxzs: null,
			},
			scoreLabel: "优秀",
			sleepProportion: "",

			everyHeight: [],
			everyOpacityArr: [],
			posAb_Y_arr: [],
			isHave_xhb: true,     //是否显示吸呼比柱状图

			currentScopeModel: null
		};
	},
	created() {
		// 1.获取 query 参数
		let params = this.$route.query;
		console.log('=====报告传入参数=====', params);

		// 2.请求接口获取需要的数据
		this.getThirdRadarBed(params)
	},
	mounted() {
		//this.testData = require('./20211102_result_night.json');
		//this.testData0 = require('./“看不懂图”模拟数据.json');
		//this.testData0 = require('./新建文本文档.json');
		//this.testData0 = require('./模拟数据.json');
		this.getMinutes();
		this.getDates();
		this.getActiveDates();
		// this.activeDate = this.activeDates[0];
		console.log(this.activeDate, "this.activeDate");
		window.addEventListener("resize", () => {
			if (this.myChart6) {
				this.myChart6.resize();
			}
			if (this.myChart7) {
				this.myChart7.resize();
			}
			if (this.myChart8) {
				this.myChart8.resize();
			}
			if (this.myChart9) {
				this.myChart9.resize();
			}
			for (var i = 0; i < this.myChartAbns.length; i++) {
				if (this.myChartAbns[i]) this.myChartAbns[i].resize();
			}
			for (var i = 0; i < this.myChartAbnHeats.length; i++) {
				if (this.myChartAbnHeats[i]) this.myChartAbnHeats[i].resize();
			}
		});
	},
	methods: {
		getThirdRadarBed(dict) {
			this.spinning = true;
			let sn = dict.sn;
			let date = dict.date;
			let params = {
				snCode: sn
			};
			this.$get(
				"/api/thirdAccess/thirdRadarBed",
				params,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.details({
								bedId: res.data.bedId,
								bedName: res.data.bedName,
								activeType: 1,
								activeDate: date,
								sn: sn,
							});
						} else {

						}
					} else {
						this.$message.error(res.msg);
					}
					this.spinning = false;
				},
				(err) => {
					//console.log(err);
					this.spinning = false;
					// // this.$message.error("服务端发生异常");
				}
			);
		},
		// 新版获取多天详情数据
		getH5ManyDaysReport() {
			let healthTrendsDays; //健康趋势日期天数, 取值: 7, 30, -1(全部), 该参数不传默认为: 7
			if (this.activeType == 3) {
				healthTrendsDays = 7;
			} else if (this.activeType == 4) {
				healthTrendsDays = 30;
			}
			var params = {
				bedId: this.typeId,
				date: this.activeDate,
				healthTrendsDays: healthTrendsDays,

				// bedId: 1220,
				// date: '2023-06-28',

				// bedId: 1057,
				// bedId: 1253,
				// date: "2022-12-31",
				// healthTrendsDays: 7,
			};
			this.$get(
				"/api/v3/report/getWebManyDaysReport",
				params,
				(res) => {
					this.isEmpty = false;
					this.spinning = false;
					let data = res.data;
					console.log(data);
					if (healthTrendsDays == -1) {
						this.InterfaceBack_healthTrendsDays = data.healthTrendsDays;
					}
					this.moreDayData = [];
					this.moreDayData = res.data;
					console.log(
						res.data.resultFlag,
						"res.data.resultFlagres.data.resultFlagres.data.resultFlag"
					);
					if (res.data.resultFlag) {
						this.isEmpty = true;
						// 详细解读是否显示
						let reportIndexList = this.moreDayData.reportIndexList;
						for (let i = 0; i < reportIndexList.length; i++) {
							this.moreDayData.reportIndexList[i].isShow_advise = false; //详细解读是否显示
						}
						let com_xAxis = data.reportIndexList[0].reportTrendsDataVo.xaxis; //通用x轴日期
						// 睡眠时长
						let sleepDurationChart = data.reportIndexList.filter(
							(item) => item.indexName == "睡眠时长"
						);
						sleepDurationChart[0].activeType = this.activeType;
						sleepDurationChart[0].com_xAxis = com_xAxis;
						// 深睡时长
						let ssscList = data.reportIndexList.filter(
							(item) => item.indexName == "深睡时长"
						);
						let deepSleepChart = {
							oldData: ssscList[0],
							xAxis: {
								data: com_xAxis,
							},
							series_data_data: ssscList[0].reportTrendsDataVo.data,
							activeType: this.activeType,
						};
						// 夜醒时长
						let yxscList = data.reportIndexList.filter(
							(item) => item.indexName == "夜醒时长"
						);
						let nightWakeChart = {
							oldData: yxscList[0],
							xAxis: {
								data: com_xAxis,
							},
							series_data_data: yxscList[0].reportTrendsDataVo.data,
							activeType: this.activeType,
						};
						// 离床次数
						let lccsList = data.reportIndexList.filter(
							(item) => item.indexName == "离床次数"
						);
						let outBedNumChart = {
							oldData: lccsList[0],
							xAxis: {
								data: com_xAxis,
							},
							series_data_data: lccsList[0].reportTrendsDataVo.data,
							activeType: this.activeType,
						};
						// 入睡时长
						let rsscList = data.reportIndexList.filter(
							(item) => item.indexName == "入睡时长"
						);
						let fallSleepChart = {
							oldData: rsscList[0],
							xAxis: {
								data: com_xAxis,
							},
							series_data_data: rsscList[0].reportTrendsDataVo.data,
							activeType: this.activeType,
						};
						// 睡眠效率
						let smxlList = data.reportIndexList.filter(
							(item) => item.indexName == "睡眠效率"
						);
						let sleepEffChart = {
							oldData: smxlList[0],
							xAxis: {
								data: com_xAxis,
							},
							series_data_data: smxlList[0].reportTrendsDataVo.data,
							activeType: this.activeType,
						};
						// 体动指数
						let tdcsList = data.reportIndexList.filter(
							(item) => item.indexName == "体动指数"
						);
						let bodyNumChart = {
							oldData: tdcsList[0],
							xAxis: {
								data: com_xAxis,
							},
							series_data_data: tdcsList[0].reportTrendsDataVo.data,
							activeType: this.activeType,
						};
						// AHI
						let ahiData = data.reportIndexList.filter(
							(item) => item.indexName == "AHI"
						);
						let ahiNumChart = {
							oldData: ahiData[0],
							xAxis: {
								data: com_xAxis,
							},
							series_data_data: ahiData[0].reportTrendsDataVo.data,
							activeType: this.activeType,
							indexVal: ahiData[0].indexVal,
						};
						// 吸呼比
						let repList = data.reportIndexList;
						for (let i = 0; i < repList.length; i++) {
							if (repList[i].indexName == "吸呼比") {
								// if (repList[i].normalFlag != 0) {
								if (repList[i].extendData) {
									for (let j = 0; j < repList[i].extendData.length; j++) {
										let xhArr = repList[i].extendData;
										for (let i = 0; i < xhArr.length; i++) {
											if (xhArr[i].isSelectedDate) {
												this.$nextTick(() => {
													this.breathScale(xhArr[i].inExRatioData);
												})
											}
										}
									}
								}
								// }
							}
						}
						// this.breathScale(xhData)

						// 睡眠规律
						let sleepRuleChart = {
							sleepRuleData: data.sleepLawVo.sleepLawDataList,
							minutes: this.minutes,
							activeDates: com_xAxis,
							type: this.activeType,
						};
						// 呼吸率
						let more_hxl = {
							xAxis: {
								data: com_xAxis,
							},
							series: [
								{
									data: [], //最小
								},
								{
									data: [], //最大
								},
								{
									data: [], //平均
								},
							],
							activeType: this.activeType,
						};
						let hxlLen = data.breathRateTrendsVo.dataList;
						for (let i = 0; i < hxlLen.length; i++) {
							more_hxl.series[0].data.push(hxlLen[i].min);
							more_hxl.series[1].data.push(hxlLen[i].max - hxlLen[i].min);
							more_hxl.series[2].data.push(hxlLen[i].avg);
						}
						// 心率
						let more_xl = {
							xAxis: {
								data: com_xAxis,
							},
							series: [
								{
									data: [], //最小
								},
								{
									data: [], //最大
								},
								{
									data: [], //平均
								},
							],
							activeType: this.activeType,
						};
						let xlLen = data.heartRateTrendsVo.dataList;
						for (let i = 0; i < xlLen.length; i++) {
							more_xl.series[0].data.push(xlLen[i].min);
							more_xl.series[1].data.push(xlLen[i].max - xlLen[i].min);
							more_xl.series[2].data.push(xlLen[i].avg);
						}

						// 睡眠得分
						let smdfList = data.scoreDetailList.filter(
							(item) => item.index == "score"
						);
						let sleepScoreChart = {
							xAxis: {
								data: com_xAxis,
							},
							series_data_data: smdfList[0].reportTrendsDataVo.data,
							activeType: this.activeType,
							avg: smdfList[0].indexValOriginal,
						};

						// 跌倒风险指数
						let fxzsList = data.scoreDetailList.filter(
							(item) => item.index == "fallIndex"
						);
						let fallRiskChart = {
							xAxis: {
								data: com_xAxis,
							},
							series_data_data: fxzsList[0].reportTrendsDataVo.data,
							activeType: this.activeType,
							avg: fxzsList[0].indexValOriginal,
						};

						// 活力值
						let hlzList = data.scoreDetailList.filter(
							(item) => item.index == "vitalityIndex"
						);
						let vigourValChart = {
							xAxis: {
								data: com_xAxis,
							},
							series_data_data: hlzList[0].reportTrendsDataVo.data,
							activeType: this.activeType,
							avg: hlzList[0].indexValOriginal,
						};

						// 情绪值
						let qxzList = data.scoreDetailList.filter(
							(item) => item.index == "moraleIndex"
						);
						let EmoValChart = {
							xAxis: {
								data: com_xAxis,
							},
							series_data_data: qxzList[0].reportTrendsDataVo.data,
							activeType: this.activeType,
							avg: qxzList[0].indexValOriginal,
						};

						setTimeout(() => {
							this.getMyChart6("more_smsc", sleepDurationChart[0]); // 睡眠时长
							if (ssscList[0].trendsDataFlag)
								this.getMyChart_optionBar(
									"more_sssc",
									"deepSleep",
									deepSleepChart
								); // 深睡时长
							if (yxscList[0].trendsDataFlag)
								this.getMyChart_optionBar(
									"more_yxsc",
									"nightWake",
									nightWakeChart
								); // 夜醒时长
							if (lccsList[0].trendsDataFlag)
								this.getMyChart_optionBar(
									"more_lccs",
									"outBedNum",
									outBedNumChart
								); // 离床次数
							if (rsscList[0].trendsDataFlag)
								this.getMyChart_optionBar(
									"more_rssc",
									"fallSleep",
									fallSleepChart
								); // 入睡时长
							if (smxlList[0].trendsDataFlag)
								this.getMyChart_optionBar(
									"more_smxl",
									"sleepEff",
									sleepEffChart
								); // 睡眠效率
							if (tdcsList[0].trendsDataFlag)
								this.getMyChart_optionBar("more_tdzs", "bodyNum", bodyNumChart); // 体动次数
							this.getMyChart_optionBar("more_ahi", "ahiNum", ahiNumChart); // AHI
							this.getMyChart_optionLine(
								"more_smdf",
								"sleepScore",
								sleepScoreChart
							); //睡眠得分
							this.getMyChart_optionLine(
								"more_dafxzs",
								"fallRisk",
								fallRiskChart
							);
							//跌到风险指数
							// this.getMyChart_optionLine("more_hlz","vigourVal",vigourValChart); 
							//活力值
							// this.getMyChart_optionLine("more_qxz", "EmoVal", EmoValChart); 
							//情绪值
							this.getMyChart_sleepRule("more_smgl", "sleepRule", sleepRuleChart);
							//睡眠规律
							this.getMyChart_BreathHeartRule("more_hxl", "breath", more_hxl); //呼吸率
							this.getMyChart_BreathHeartRule("more_xl", "heart", more_xl); //呼吸率
						}, 100);
					} else {
						this.resultImg = res.data.resultImg == 1 ? 12 : res.data.resultImg;
						console.log(res.data.resultImg);
						this.isEmpty = false;
					}
					this.$forceUpdate();
				},
				(data, code) => {
					this.spinning = false;
					console.log("fail" + JSON.stringify(data));
				}
			);
		},
		getMyChart_optionBar(idName, type, data) {
			this.myChart_Bar = this.$echarts.init(
				document.getElementById(idName),
				null,
				{ renderer: "svg" }
			);

			console.log(type, data);
			// type 深睡deepSleep  夜醒nightWake  离床次数outBedNum  入睡时长fallSleep  睡眠效率sleepEff  体动次数bodyNum  ahi ahiNum
			var that = this;
			let valueList = [];
			for (var i = 0; i < data.series_data_data.length; i++) {
				if (data.series_data_data[i]) {
					valueList.push({
						value: data.series_data_data[i],
						time: data.series_data_data[i].duration ? series_data_data : "",
						isEmpty: false,
					});
				} else {
					valueList.push({
						value: 0,
						time: "",
						isEmpty: true,
					});
				}
			}
			console.log(valueList);
			let grid_left = "1%";
			let markArea_data_yAxis;

			let markLine_yAxis = data.oldData.indexValOriginal; //警戒线平均值
			if (type == "deepSleep") {
				grid_left = "2%";
				markArea_data_yAxis = ["20", "60"];
				markLine_yAxis = data.oldData.indexValPct; //深睡平均值
			} else if (type == "nightWake") {
				grid_left = "2%";
				markArea_data_yAxis = ["0", "30"];
			} else if (type == "outBedNum") {
				grid_left = "2%";
				markArea_data_yAxis = ["0", "2"];
			} else if (type == "fallSleep") {
				markArea_data_yAxis = ["0", "30"];
			} else if (type == "sleepEff") {
				grid_left = "0.5%";
				markArea_data_yAxis = ["80", "100"];
			} else if (type == "bodyNum") {
				grid_left = "2%";
				markArea_data_yAxis = ["1.25", "15"];
				markLine_yAxis = data.oldData.indexVal; //体动平均值
			} else if (type == "ahiNum") {
				markArea_data_yAxis = ["0", "5"];
				markLine_yAxis = data.oldData.indexVal; //体动平均值
			}
			let markArea_data = [
				[
					{
						name: "",
						xAxis: data.xAxis.data[0],
						// xAxis: '12-24',
						yAxis: markArea_data_yAxis[0],
					},
					{
						xAxis: data.xAxis.data[data.xAxis.data.length - 1],
						// xAxis: '12-30',
						yAxis: markArea_data_yAxis[1],
					},
				],
			];
			console.log(markArea_data);
			var optionBar = {
				color: ["#1890FF"],

				// 临时注释，后期补
				tooltip: {
					trigger: "axis",
					backgroundColor: "rgba(255, 255, 255, 1)",
					borderColor: "rgba(24, 144, 255, 0.6)",
					borderWidth: 1,
					spanStyle: {
						color: "#fff",
					},
					confine: true,
					borderRadius: 5,
					formatter: function (params) {
						console.log(type);
						console.log(params);
						if (type == "deepSleep") {
							return (
								params[0].name +
								"<br/>" +
								'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>深睡' +
								(params[0].data.isEmpty ? "-" : params[0].data.value) +
								"%"
							);
						} else if (type == "nightWake") {
							return (
								params[0].name +
								"<br/>" +
								'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>夜醒' +
								(params[0].data.isEmpty ? "-" : params[0].data.value) +
								"分钟"
							);
						} else if (type == "outBedNum") {
							return (
								params[0].name +
								"<br/>" +
								'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>离床' +
								(params[0].data.isEmpty ? "-" : params[0].data.value) +
								"次"
							);
						} else if (type == "fallSleep") {
							// return params[0].name + "<br/>" + "入睡时长" + (params[0].data.isEmpty ? "-" : changeHour_Min(params[0].data.value));
							if (params[0].data.isEmpty) {
								return params[0].name + "<br/>" + "入睡时长" + "-" + "分钟";
							} else {
								let hourMin = params[0].data.value;
								if (hourMin == "-") {
									console.log("不存在params[0].data.value");
									return params[0].name + "<br/>" + "入睡时长" + "-" + "分钟";
								} else {
									console.log("存在params[0].data.value");
									if (hourMin < 60) {
										return (
											params[0].name +
											"<br/>" +
											'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>入睡时长' +
											(params[0].data.isEmpty ? "-" : hourMin) +
											"分钟"
										);
									} else {
										return (
											params[0].name +
											"<br/>" +
											'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>入睡时长' +
											(params[0].data.isEmpty
												? "-"
												: Math.floor(Number(hourMin) / 60) +
												"小时" +
												(hourMin % 60) +
												"分钟")
										);
									}
								}
							}
						} else if (type == "bodyNum") {
							return (
								params[0].name +
								"<br/>" +
								'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>体动指数' +
								(params[0].data.isEmpty ? "-" : params[0].data.value) +
								""
							);
						} else if (type == "ahiNum") {
							return (
								params[0].name +
								"<br/>" +
								'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>呼吸异常指数' +
								(params[0].data.isEmpty ? "-" : params[0].data.value) +
								""
							);
						} else if (type == "outBedDuration") {
							return (
								params[0].name +
								'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
								(params[0].data.isEmpty ? "-" : "离床" + params[0].data.time)
							);
						} else if (type == "turnOver") {
							return (
								params[0].name +
								"<br/>" +
								'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>体动' +
								(params[0].data.isEmpty ? "-" : params[0].data.value) +
								"次"
							);
						} else if (type == "sleepEff") {
							return (
								params[0].name +
								"<br/>" +
								'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>睡眠效率' +
								(params[0].data.isEmpty ? "-" : params[0].data.value) +
								"%"
							);
						} else if (type == "") {
							return (
								params[0].name +
								"<br/>" +
								'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>紊乱指数' +
								(params[0].data.isEmpty ? "-" : params[0].data.value)
							);
						}
					},
				},
				grid: {
					left: grid_left,
					// left: '0%',
					right: "1%",
					top: "15%",
					bottom: "1%",
					containLabel: true,
				},
				xAxis: [
					{
						type: "category",
						data: data.xAxis.data,
						// data: ["09-13", "09-14", "09-15", "09-16", "09-17", "09-18", "09-19"],
						axisLabel: {
							spanStyle: {
								color: "#c7c6c9", //坐标的字体颜色
							},
						},
						axisLine: {
							lineStyle: {
								color: "#c7c6c9",
							},
						},

						axisTick: {
							show: true,
							// alignWithLabel: true,
						},
					},
				],
				yAxis: [
					{
						max: type == "ahi" ? 5 : null,
						type: "value",
						splitLine: {
							show: true,
						},
						minInterval: 1, //设置最小间隔为1，防止出现小数
						axisLabel: {
							spanStyle: {
								color: "#c7c6c9", //坐标的字体颜色
							},
						},
						axisLine: {
							lineStyle: {
								color: "#c7c6c9",
							},
							show: false,
						},
						splitNumber: 2,
					},
				],
				series: [
					{
						name: type,
						type: "bar",
						barWidth: data.activeType == 2 ? "20" : "10",
						barCategoryGap: 1,
						itemStyle: {
							normal: {
								//柱形图圆角，初始化效果
								barBorderRadius: [4, 4, 0, 0],
								color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
									{
										offset: 0,
										color: "rgba(77, 142, 247, 1)",
									},
									{
										offset: 1,
										color: "rgba(195, 148, 254, 1)",
									},
								]),
							},
						},
						data: valueList,
						// markLine: type == "ahiNum" ? {
						markLine: {
							symbol: "none",
							show: true,
							emphasis: {
								lineStyle: {
									width: 1, // hover时的折线宽度
								},
							},

							data: [
								{
									silent: false, //鼠标悬停事件  true没有，false有

									lineStyle: {
										//警戒线的样式  ，虚实  颜色
										type: "dashed",
										color: "#63B2FB",
									},
									label: {
										position: "end",
										formatter: "",
									},
									yAxis: markLine_yAxis,
								},
								{
									silent: false, //鼠标悬停事件  true没有，false有
									lineStyle: {
										//警戒线的样式  ，虚实  颜色
										type: "dashed",
										color: "#FF4D4F",
									},
									label: {
										position: "end",
										formatter: "",
									},
									// 此处只给ahi用，其他不用
									yAxis: type == "ahiNum" ? 5 : "-10000000", // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
								},
							],
						},

						// markArea: {
						//   itemStyle: {
						//     color: '#F2FAFF',
						//   },
						//   data: markArea_data,
						// },
						markArea: {
							silent: true,
							data: [
								[
									{
										name: "",
										yAxis: markArea_data_yAxis[0],
										itemStyle: {
											color: "#F2FAFF",
										},
									},
									{
										yAxis: markArea_data_yAxis[1],
									},
								],
							],
						},
					},
				],
			};
			var optionBar2 = {
				color: ["#1890FF"],

				// 临时注释，后期补
				tooltip: {
					trigger: "axis",
					backgroundColor: "rgba(255, 255, 255, 1)",
					borderColor: "rgba(24, 144, 255, 0.6)",
					borderWidth: 1,
					spanStyle: {
						color: "#fff",
					},
					confine: true,
					borderRadius: 5,
					formatter: function (params) {
						console.log(type);
						console.log(params);
						if (type == "deepSleep") {
							return (
								params[0].name +
								"<br/>" +
								"深睡" +
								(params[0].data.isEmpty ? "-" : params[0].data.value) +
								"%"
							);
						} else if (type == "nightWake") {
							return (
								params[0].name +
								"<br/>" +
								"夜醒" +
								(params[0].data.isEmpty ? "-" : params[0].data.value) +
								"分钟"
							);
						} else if (type == "outBedNum") {
							return (
								params[0].name +
								"<br/>" +
								"离床" +
								(params[0].data.isEmpty ? "-" : params[0].data.value) +
								"次"
							);
						} else if (type == "fallSleep") {
							// return params[0].name + "<br/>" + "入睡时长" + (params[0].data.isEmpty ? "-" : changeHour_Min(params[0].data.value));
							if (params[0].data.isEmpty) {
								return params[0].name + "<br/>" + "入睡时长" + "-" + "分钟";
							} else {
								let hourMin = params[0].data.value;
								if (hourMin == "-") {
									console.log("不存在params[0].data.value");
									return params[0].name + "<br/>" + "入睡时长" + "-" + "分钟";
								} else {
									console.log("存在params[0].data.value");
									if (hourMin < 60) {
										return (
											params[0].name +
											"<br/>" +
											"入睡时长" +
											(params[0].data.isEmpty ? "-" : hourMin) +
											"分钟"
										);
									} else {
										return (
											params[0].name +
											"<br/>" +
											"入睡时长" +
											(params[0].data.isEmpty
												? "-"
												: Math.floor(Number(hourMin) / 60) +
												"小时" +
												(hourMin % 60) +
												"分钟")
										);
									}
								}
							}
						} else if (type == "bodyNum") {
							return (
								params[0].name +
								"<br/>" +
								"体动指数" +
								(params[0].data.isEmpty ? "-" : params[0].data.value) +
								""
							);
						} else if (type == "ahi") {
							return (
								params[0].name +
								"<br/>" +
								"AHI指数" +
								(params[0].data.isEmpty ? "-" : params[0].data.value) +
								""
							);
						} else if (type == "outBedDuration") {
							return (
								params[0].name +
								"<br/>" +
								(params[0].data.isEmpty ? "-" : "离床" + params[0].data.time)
							);
						} else if (type == "turnOver") {
							return (
								params[0].name +
								"<br/>" +
								"体动" +
								(params[0].data.isEmpty ? "-" : params[0].data.value) +
								"次"
							);
						} else if (type == "sleepEff") {
							return (
								params[0].name +
								"<br/>" +
								"睡眠效率" +
								(params[0].data.isEmpty ? "-" : params[0].data.value) +
								"%"
							);
						} else if (type == "") {
							return (
								params[0].name +
								"<br/>" +
								"紊乱指数" +
								(params[0].data.isEmpty ? "-" : params[0].data.value)
							);
						}
					},
				},
				grid: {
					left: grid_left,
					// left: '0%',
					right: "1%",
					top: "15%",
					bottom: "1%",
					containLabel: true,
				},
				xAxis: [
					{
						type: "category",
						data: data.xAxis.data,
						// data: ["09-13", "09-14", "09-15", "09-16", "09-17", "09-18", "09-19"],
						axisLabel: {
							spanStyle: {
								color: "#4D5EA1", //坐标的字体颜色
							},
						},
						axisLine: {
							lineStyle: {
								color: "#4D5EA1",
							},
						},
						axisTick: {
							show: false,
							// alignWithLabel: true,
						},
					},
				],
				yAxis: [
					{
						max: type == "ahi" ? 5 : null,
						type: "value",
						splitLine: {
							show: false,
						},
						minInterval: 1, //设置最小间隔为1，防止出现小数
						axisLabel: {
							spanStyle: {
								color: "#4D5EA1", //坐标的字体颜色
							},
						},
						axisLine: {
							lineStyle: {
								color: "#4D5EA1",
							},
							show: false,
						},
						splitNumber: 2,
					},
				],
				series: [
					{
						name: type,
						type: "bar",
						barWidth: data.activeType == 2 ? "20" : "10",
						barCategoryGap: 1,
						itemStyle: {
							normal: {
								//柱形图圆角，初始化效果
								barBorderRadius: [4, 4, 0, 0],
								color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
									{
										offset: 0,
										color: "rgba(77, 142, 247, 1)",
									},
									{
										offset: 1,
										color: "rgba(195, 148, 254, 1)",
									},
								]),
							},
						},
						data: valueList,
						// markLine: type == "ahiNum" ? {
						markLine: {
							symbol: "none",
							show: false,
							emphasis: {
								lineStyle: {
									width: 1, // hover时的折线宽度
								},
							},

							data: [
								{
									silent: false, //鼠标悬停事件  true没有，false有

									lineStyle: {
										//警戒线的样式  ，虚实  颜色
										type: "dashed",
										color: "#63B2FB",
									},
									label: {
										position: "end",
										formatter: "",
									},
									yAxis:
										type == "deepSleep"
											? data.oldData.indexValPct
											: data.oldData.indexValOriginal, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
								},
								{
									silent: false, //鼠标悬停事件  true没有，false有
									lineStyle: {
										//警戒线的样式  ，虚实  颜色
										type: "dashed",
										color: "#FF4D4F",
									},
									label: {
										position: "end",
										formatter: "",
									},
									// 此处只给ahi用，其他不用
									yAxis: type == "ahiNum" ? 5 : "-10000000", // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
								},
							],
						},

						// markArea: {
						//   itemStyle: {
						//     color: '#F2FAFF',
						//   },
						//   data: markArea_data,
						// },
						markArea: {
							silent: true,
							data: [
								[
									{
										name: "",
										yAxis: markArea_data_yAxis[0],
										itemStyle: {
											color: "#F2FAFF",
										},
									},
									{
										yAxis: markArea_data_yAxis[1],
									},
								],
							],
						},
					},
				],
			};

			this.myChart_Bar.setOption(optionBar, true);
			this.$forceUpdate();
			window.addEventListener("resize", () => {
				this.myChart_Bar.resize();
			});
		},
		getMyChart_optionLine(idName, type, data) {
			this.myChart_Line = this.$echarts.init(document.getElementById(idName));
			// console.log(type,data)
			// type 睡眠得分more_smdf   跌到风险fallRisk  活力值vigourVal  情绪值EmoVal
			let valueList = [];
			for (var i = 0; i < data.series_data_data.length; i++) {
				if (data.series_data_data[i]) {
					valueList.push({
						value: data.series_data_data[i],
						time: data.series_data_data[i].duration ? series_data_data : "",
						isEmpty: false,
					});
				} else {
					valueList.push({
						value: 0,
						time: "",
						isEmpty: true,
					});
				}
			}
			console.log(valueList);

			let optionLine = {
				color: ["#1890FF"],
				tooltip: {
					trigger: "axis",
					backgroundColor: "rgba(255, 255, 255, 0.9)",
					borderColor: "rgba(24, 144, 255, 0.8)",
					borderWidth: 1,
					borderRadius: 5,
					formatter: function (params) {
						console.log(params[0].data);
						return params[0].data;
					},
				},
				grid: {
					left: "0%",
					right: "0%",
					top: "10%",
					bottom: "0%",
					containLabel: true,
				},
				xAxis: [
					{
						type: "category",
						axisLabel: {
							spanStyle: {
								color: "#c7c6c9", //坐标的字体颜色
							},
						},
						axisLine: {
							lineStyle: {
								color: "#c7c6c9",
							},
						},
						data: data.xAxis.data,
					},
				],

				yAxis: [
					{
						type: "value",
						min: 0,
						max: 100,
						logBase: 10,
						interval: 100,
						splitLine: {
							show: false,
						},
						axisLabel: {
							formatter: "{value}",
							spanStyle: {
								color: "#c7c6c9", //坐标的字体颜色
							},
						},
						axisLine: {
							lineStyle: {
								color: "#c7c6c9",
							},
							show: false,
						},
					},
				],

				series: [
					{
						data: valueList,
						type: "line",
						smooth: true,
						symbol: "circle",
						symbolSize: 8,
						color: "#1890FF",
						areaStyle: {
							color: {
								type: "linear",
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [
									{
										offset: 0,
										color: "rgba(24, 144, 255, 0.4)", // 0% 处的颜色
									},
									{
										offset: 1,
										color: "rgba(24, 144, 255, 0.05)", // 100% 处的颜色
									},
								],
								global: false, // 缺省为 false
							},
						},
						markLine: {
							symbol: "none",
							emphasis: {
								lineStyle: {
									width: 1, // hover时的折线宽度
								},
							},
							data: [
								{
									silent: false, //鼠标悬停事件  true没有，false有
									lineStyle: {
										//警戒线的样式  ，虚实  颜色
										type: "dashed",
										color: "#63B2FB",
									},
									label: {
										position: "end",
										formatter: "",
									},
									yAxis: data.avg, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
								},
							],
						},
					},
				],
			};

			this.myChart_Line.setOption(optionLine, true);
			window.addEventListener("resize", () => {
				this.myChart_Line.resize();
			});
			this.$forceUpdate();
		},

		// 睡眠规律
		getMyChart_sleepRule(idName, type, data) {
			this.myChart_BarRule = this.$echarts.init(
				document.getElementById(idName)
			);
			let newData = JSON.parse(JSON.stringify(data.sleepRuleData));

			console.log(type, data, newData);
			//type 睡眠规律sleepRule
			var that = this;
			// let timeList = [];
			// console.log(data);
			var getBed = []; //上床时间对应的minutes角标
			var sleepStart = [];
			var sleepEnd = [];
			var leaveBed = [];
			var edatas = [];
			for (var i = 0; i < data.sleepRuleData.length; i++) {
				if (data.sleepRuleData[i].getBedIdx == "20:00前") {
					data.sleepRuleData[i].getBedIdx = "20:00";
				}
				if (data.sleepRuleData[i].sleepStIdx == "20:00前") {
					data.sleepRuleData[i].sleepStIdx = "20:00";
				}
				if (data.sleepRuleData[i].sleepEdIdx == "08:00后") {
					data.sleepRuleData[i].sleepEdIdx = "08:00";
				}
				if (data.sleepRuleData[i].leaveBedIdx == "08:00后") {
					data.sleepRuleData[i].leaveBedIdx = "08:00";
				}
				edatas.push(data.sleepRuleData[i]);
			}
			console.log(edatas);
			for (var i = 0; i < data.activeDates.length; i++) {
				sleepStart.push(
					data.minutes.indexOf(edatas[i].sleepStIdx) != -1
						? data.minutes.indexOf(edatas[i].sleepStIdx)
						: 0
				);
				sleepEnd.push(
					data.minutes.indexOf(edatas[i].sleepEdIdx) != -1
						? data.minutes.indexOf(edatas[i].sleepEdIdx)
						: 0
				);
				getBed.push(
					data.minutes.indexOf(edatas[i].getBedIdx) != -1
						? data.minutes.indexOf(edatas[i].getBedIdx)
						: 0
				);
				leaveBed.push(
					data.minutes.indexOf(edatas[i].leaveBedIdx) != -1
						? data.minutes.indexOf(edatas[i].leaveBedIdx)
						: 0
				);
			}

			// 原始index
			// console.log(getBed)       //上床
			// console.log(sleepStart)   //入睡
			// console.log(sleepEnd)     //醒来
			// console.log(leaveBed)     //起床

			var sleepEndChart = [];
			var leaveBedChart = [];
			for (var i = 0; i < data.activeDates.length; i++) {
				sleepEndChart.push(sleepEnd[i] - sleepStart[i]);
				leaveBedChart.push(leaveBed[i] - getBed[i]);
			}
			// console.log('空12')
			// 柱状图所需index
			// console.log(getBed)           //上床
			// console.log(sleepStart)       //入睡
			// console.log(sleepEndChart)    //醒来
			// console.log(leaveBedChart)    //起床

			var optionSleepRule = {
				color: "#1890ff",
				tooltip: {
					trigger: "axis",
					backgroundColor: "rgba(255, 255, 255, 1)",
					borderColor: "rgba(24, 144, 255, 0.6)",
					borderWidth: 1,
					spanStyle: {
						color: "#fff",
					},
					confine: true,
					borderRadius: 5,
					formatter: function (params) {
						console.log(params);
						if (params[3].value == 0) {
							return (
								params[0].axisValueLabel +
								'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>上床时间：-' +
								'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>入睡时间：-' +
								'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>醒来时间：-' +
								'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>起床时间：-'
							);
						}
						return (
							params[0].axisValueLabel +
							'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>上床时间：' +
							newData[params[0].dataIndex].getBedIdx +
							'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>入睡时间：' +
							newData[params[0].dataIndex].sleepStIdx +
							'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>醒来时间：' +
							newData[params[0].dataIndex].sleepEdIdx +
							'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>起床时间：' +
							newData[params[0].dataIndex].leaveBedIdx
						);
					},
				},
				grid: {
					left: "0%",
					right: "1%",
					top: "15%",
					bottom: "1%",
					containLabel: true,
				},
				xAxis: [
					{
						type: "category",
						data: data.activeDates,
						axisLine: {
							lineStyle: {
								color: "#c7c6c9",
							},
						},
						axisLabel: {
							spanStyle: {
								color: "#c7c6c9", //坐标的字体颜色
							},
						},
						axisTick: {
							show: false,
							alignWithLabel: true,
						},
						show: true,
					},
				],
				yAxis: [
					{
						max: 720,
						min: 0,
						minInterval: 240,
						type: "value",
						splitLine: {
							show: true,
						},
						axisLine: {
							lineStyle: {
								color: "#c7c6c9",
							},
							show: false,
						},
						axisLabel: {
							formatter: function (value) {
								// if(value === 0) return "0AM"
								// if(value === 240) return "4AM"
								// if(value === 480) return "8AM"
								// if(value === 720) return "8PM"
								let timeArr = data.minutes[value].split(":");
								// timeArr.forEach(item => {
								//   +item
								// })
								return +timeArr[0] > 12
									? +timeArr[0] - 12 + "PM"
									: +timeArr[0] + "AM";
							},
							spanStyle: {
								color: "#c7c6c9", //坐标的字体颜色
							},
						},
					},
				],
				series: [
					{
						stack: "float",
						type: "bar",
						barWidth: 10,
						barGap: "-100%",
						itemStyle: {
							normal: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
							emphasis: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
						},
						data: sleepStart, //入睡
					},
					{
						z: 5,
						stack: "float",
						type: "bar",
						barGap: "-100%",
						barWidth: 10,
						itemStyle: {
							normal: {
								barBorderRadius: [15, 15, 15, 15],
								barBorderColor: "rgba(0,0,0,0)",
								color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
									{
										offset: 0,
										color: "rgba(77, 142, 247, 1)",
									},
									{
										offset: 1,
										color: "rgba(195, 148, 254, 1)",
									},
								]),
							},
						},
						data: sleepEndChart, //醒来
					},
					{
						stack: "float1",
						type: "bar",
						barGap: "-100%",
						barWidth: 10,
						itemStyle: {
							normal: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
							emphasis: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
						},
						data: getBed, //上床
					},
					{
						z: 2,
						stack: "float1",
						type: "bar",
						barGap: "-100%",
						barWidth: 10,
						itemStyle: {
							normal: {
								barBorderRadius: [15, 15, 15, 15],
								barBorderColor: "rgba(0,0,0,0)",
								color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
									{
										offset: 0,
										color: "rgba(77, 142, 247, 0.5)",
									},
									{
										offset: 1,
										color: "rgba(195, 148, 254, 0.5)",
									},
								]),
							},
						},
						data: leaveBedChart, //起床
					},
				],
			};

			this.myChart_BarRule.setOption(optionSleepRule);
			window.addEventListener("resize", () => {
				this.myChart_BarRule.resize();
			});
		},

		// 多日呼吸率心率
		getMyChart_BreathHeartRule(idName, type, data) {
			this.myChart_BreathHeart = this.$echarts.init(
				document.getElementById(idName)
			);
			console.log(type, data);
			//type 呼吸率breath	心率heart
			let grid_left = "1%";
			if (type == "breath") {
				grid_left = "1%";
			} else if (type == "heart") {
				grid_left = "0%";
			}
			var optionBreathHeartRule = {
				color: "#1890ff",
				tooltip: {
					trigger: "axis",
					backgroundColor: "rgba(255, 255, 255, 1)",
					borderColor: "rgba(24, 144, 255, 0.6)",
					borderWidth: 1,
					spanStyle: {
						color: "#fff",
					},
					trigger: "axis",
					confine: true,
					borderRadius: 5,
					formatter: function (params) {
						console.log(params);
						if (params[2].value == "-") {
							return (
								params[0].axisValueLabel +
								'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>最高：-' +
								'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>最低：-' +
								'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>平均：-'
							);
						}
						return (
							params[0].axisValueLabel +
							'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>最高：' +
							(
								parseInt(params[0].value) + parseInt(params[1].value)
							).toString() +
							'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>最低：' +
							params[0].value +
							'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>平均：' +
							params[2].value
						);
					},
				},
				grid: {
					left: grid_left,
					right: "1%",
					top: "15%",
					bottom: "1%",
					containLabel: true,
				},
				xAxis: [
					{
						type: "category",
						data: data.xAxis.data,
						axisLine: {
							lineStyle: {
								color: "#c7c6c9",
							},
						},
						axisLabel: {
							spanStyle: {
								color: "#c7c6c9", //坐标的字体颜色
							},
						},
						axisTick: {
							show: false,
							alignWithLabel: true,
						},
						show: true,
					},
				],
				yAxis: [
					{
						min: idName == "more_xl" ? 40 : 0,
						type: "value",
						splitLine: {
							show: true,
						},
						axisLine: {
							lineStyle: {
								color: "#c7c6c9",
							},
							show: false,
						},
						axisLabel: {
							spanStyle: {
								color: "#c7c6c9", //坐标的字体颜色
							},
						},
						splitNumber: 2,
					},
				],
				series: [
					{
						stack: "float",
						type: "bar",
						barWidth: 10,
						barGap: "-100%",
						itemStyle: {
							normal: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
							emphasis: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
						},
						data: data.series[0].data,
					},
					{
						z: 5,
						stack: "float",
						type: "bar",
						barWidth: 10,
						barGap: "-100%",
						itemStyle: {
							normal: {
								barBorderRadius: [15, 15, 15, 15],
								barBorderColor: "rgba(0,0,0,0)",
								color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
									{
										offset: 0,
										color: "rgba(77, 142, 247, 1)",
									},
									{
										offset: 1,
										color: "rgba(195, 148, 254, 1)",
									},
								]),
							},
						},
						data: data.series[1].data,
					},
					{
						z: 0,
						type: "bar",
						barWidth: 10,
						barGap: "-100%",
						itemStyle: {
							normal: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
							emphasis: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
						},
						data: data.series[2].data,
					},
				],
			};

			this.myChart_BreathHeart.setOption(optionBreathHeartRule);
			window.addEventListener("resize", () => {
				this.myChart_BreathHeart.resize();
			});
		},
		// 点击详细解读
		clc_xxjd(index, type) {
			if (type == "xgbh") {
				//单日习惯变化
				this.oneDayData.potentialRiskVo.potentialRiskIndexList[
					index
				].isShow_advise =
					!this.oneDayData.potentialRiskVo.potentialRiskIndexList[index]
						.isShow_advise;
			} else if (type == "smzb") {
				//单日睡眠指标
				this.oneDayData.sleepIndexList[index].isShow_advise =
					!this.oneDayData.sleepIndexList[index].isShow_advise;
			} else if (type == "hxxq") {
				//单日呼吸详情
				this.oneDayData.breathIndexList[index].isShow_advise =
					!this.oneDayData.breathIndexList[index].isShow_advise;
			} else if (type == "more_smzb") {
				//多日睡眠指标
				this.moreDayData.reportIndexList[index].isShow_advise =
					!this.moreDayData.reportIndexList[index].isShow_advise;
			}
			this.$forceUpdate();
		},
		// 多日点击某个吸呼比日期
		cli_more_xh_date(e) {
			let time = e;
			let bList = this.moreDayData.reportIndexList;
			for (let i = 0; i < bList.length; i++) {
				if (bList[i].indexName == "吸呼比") {
					// iIndex = i
					for (let j = 0; j < bList[i].extendData.length; j++) {
						//把所有的isSelectedDate属性值全部归false
						this.moreDayData.reportIndexList[i].extendData[j].isSelectedDate = false;
						// 当前选中日期isSelectedDate改为true
						if (time == bList[i].extendData[j].date) {
							this.moreDayData.reportIndexList[i].extendData[j].isSelectedDate = true;
							let xhData = this.moreDayData.reportIndexList[i].extendData[j].inExRatioData;
							this.breathScale(xhData); //吸呼比柱状图
						}
					}
				}
			}
			console.log(time);
		},


		// 吸呼比柱状图未落在正常区间
		breathScale(data) {
			console.log(132)
			let myCharts_xhb = this.$echarts.init(document.getElementById('myCharts_xhb'));
			console.log(myCharts_xhb)
			console.log(data)


			if (data.data && data.data.length == 0) {
				this.isHave_xhb = false
			} else {
				this.isHave_xhb = true
			}

			let everyOpacityArr = this.getBarMaxAlphaArr(data.data); //吸呼比柱状图透明度
			console.log(everyOpacityArr)


			// 参数获取
			let name = this.name || "";
			let xAxisArr = data.xaxis;
			let seriesArr = data.data || [];
			if (seriesArr.length > 20) {
				let tempSeriesArr = JSON.parse(JSON.stringify(seriesArr));
				for (let i = 0; i < seriesArr.length; i++) {
					let item = seriesArr[i];
					tempSeriesArr[i] = {
						value: item,
						itemStyle: {
							normal: {
								color: '#4D8EF7',
								opacity: everyOpacityArr[i]
							},
						},
					};
				}
				seriesArr = tempSeriesArr;
			}

			// 设置 tooltip
			let tooltip = {
				trigger: "axis",
				backgroundColor: "#FFFFFF",
				borderColor: "rgba(24, 144, 255, 0.6)",
				borderWidth: 1,
				borderRadius: 5,
				textStyle: {
					color: "#8c8c8c",
				},
				confine: true,
				formatter: function (val) {
					if (!val || val.length == 0) {
						return;
					}
					console.log(val)
					let value = val[0].value;
					let sty = '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>'
					if (value) {
						let res = Math.floor(value * 100);
						return sty + res + '%吸呼比' + '<br/>' + '集中在' + val[0].axisValue;
					} else {
						return sty + '0%吸呼比' + '<br/>' + '集中在' + val[0].axisValue;
					}
				},
			};

			let yFormatter = function (val) {
				return Math.floor(val * 100) + '%';
			};

			// let singleW = (DefineTool.width - 42 - 28) / xAxisArr.length;
			// let needX1 = 42 + 7 * singleW - singleW / 2.0;
			// let needX2 = 42 + 15 * singleW - singleW / 2.0 - 6.0;

			let markArea = {
				//  提示图表标域，常用于标记图表中某个范围的数据
				silent: true,
				itemStyle: {
					color: 'rgba(77,142,247,0.05)',
					borderColor: "#4D8EF7",
					borderWidth: 1,
					borderType: "dashed",
				},
				data: [
					[
						{ xAxis: "0.8", x: 257 },
						{ xAxis: "1.5", x: 507 },
						// { x: 257 },
						// { x: 507 },
					],
				],
			};

			let option = {
				// Tip
				tooltip: tooltip,
				// x 轴配置项
				xAxis: {
					data: xAxisArr,
					axisTick: {
						show: false,
					},
					axisLine: {
						lineStyle: {
							color: "#A5A9BC",
						},
					},
					axisLabel: {
						textStyle: {
							color: "#A5A9BC", //坐标的字体颜色
						},
						formatter: function (val) {
							if (val == '0.5' || val == '1' || val == '1.5' || val == '2' || val == '2.5' || val == '0.1') {
								return val;
							}
							return '';
						},
						interval: 0,
					},
				},
				yAxis: {
					// y 轴配置项
					axisTick: {
						show: false,
					},
					axisLine: {
						show: false, // 显示y轴的线
						lineStyle: {
							color: "#A5A9BC",
						},
					},
					axisLabel: {
						formatter: yFormatter,
						textStyle: {
							color: "#A5A9BC", //坐标的字体颜色
						},
					},
				},
				// 内边距
				grid: {
					x: 42,
					y: 20,
					x2: 16,
					y2: 20,
				},
				// 系列的设置：绘制什么类型的图表type、数据在这里展示
				series: [
					{
						name: name,
						type: "bar", // 图标类型的设置
						data: seriesArr, // 图标的数据
						color: "#1890FF",
						itemStyle: {
							normal: {
								barBorderRadius: [5, 5, 0, 0],
								color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{ offset: 0, color: "#C394FE" },
									{ offset: 1, color: "#B84DF7" },
								]),
							},
						},
						markArea: markArea,
						barWidth: 10,
					},
				],
			};
			myCharts_xhb.setOption(option);

		},
		breathSca(data) {
			// console.log('算法数据')
			console.log(data);

			if (data.length == 0) {
				this.isHave_xhb = false
			} else {
				this.isHave_xhb = true
			}



			let everyOpacityArr = this.getBarMaxAlphaArr(data); //吸呼比柱状图透明度
			this.everyOpacityArr = everyOpacityArr;

			let nowProportion = [];
			for (let i = 0; i < data.length; i++) {
				nowProportion.push(data[i] * 100);
			}
			console.log(nowProportion);
			let maxVal = Math.max(...nowProportion); //柱最大百分比
			let everyHeight = []; //每个柱高度
			// console.log('柱最大百分比' + maxVal)
			if (maxVal == 20 || maxVal < 20) {
				// console.log('进入20以下')
				this.posAb_Y_arr = [0, "5%", "10%", "15%", "20%"];
				for (let i = 0; i < nowProportion.length; i++) {
					everyHeight.push((nowProportion[i] / 20) * 160);
				}
			} else if ((maxVal > 20 && maxVal < 40) || maxVal == 40) {
				this.posAb_Y_arr = [0, "10%", "20%", "30%", "40%"];
				for (let i = 0; i < nowProportion.length; i++) {
					everyHeight.push((nowProportion[i] / 40) * 160);
				}
			} else if ((maxVal > 40 && maxVal < 60) || maxVal == 60) {
				// console.log('进入40-60')
				this.posAb_Y_arr = [0, "15%", "30%", "45%", "60%"];
				for (let i = 0; i < nowProportion.length; i++) {
					everyHeight.push((nowProportion[i] / 60) * 160);
				}
			} else if ((maxVal > 60 && maxVal < 80) || maxVal == 80) {
				// console.log('进入60-80')
				console.log(23423423);
				this.posAb_Y_arr = [0, "20%", "40%", "60%", "80%"];
				for (let i = 0; i < nowProportion.length; i++) {
					everyHeight.push((nowProportion[i] / 80) * 160);
				}
			} else if (maxVal > 80) {
				// console.log('进入80-1 00')
				this.posAb_Y_arr = [0, "25%", "50%", "75%", "100%"];
				for (let i = 0; i < nowProportion.length; i++) {
					everyHeight.push((nowProportion[i] / 100) * 160);
				}
			}
			// console.log(this.data.posAb_Y_arr)
			this.everyHeight = everyHeight;
			console.log(everyHeight);
			// console.log('每个柱高度')
			// console.log(everyHeight)
		},
		// 吸呼比柱状图透明度
		getBarMaxAlphaArr(arr) {
			// 从小到大
			// let arr[] = [1, 2, 3, 4, 5, 5, 6, 7, 4, 3, 2, 1, 1, 1, , 1, 1, 1, 1, '-', 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];

			// 将undefined、-、''转为0的有效数组
			let targetArr = [];
			for (let i = 0; i < arr.length; i++) {
				if (arr[i] && arr[i] != "" && arr[i] != "-" && arr[i] != 0) {
					targetArr.push(arr[i]);
				} else {
					targetArr.push(0);
				}
			}

			// 数组去重
			let duplicateRemovalArr = [
				...new Set(JSON.parse(JSON.stringify(targetArr))),
			];

			// 有效柱子个数
			let effective = 0;
			for (let i = 0; i < duplicateRemovalArr.length; i++) {
				effective++;
			}

			// 递减透明度
			let differenceAlpha = 0.15;
			if (effective > 15) {
				differenceAlpha = 0.1;
			}

			// 数组排序
			let sortArr = JSON.parse(JSON.stringify(duplicateRemovalArr)).sort(
				function (a, b) {
					return a - b; // 升序
				}
			);

			// 数组倒序
			let reverseArr = sortArr.reverse();

			// 透明度字典对标
			let alphaDict = {};
			for (let i = 0; i < reverseArr.length; i++) {
				let value = String(reverseArr[i]);
				alphaDict[value] = Number((1 - i * differenceAlpha).toFixed(2));
				if (1 - i * differenceAlpha < 0.2) {
					alphaDict[value] = 0.2;
				}
			}

			let alphaArr = [];
			for (let i = 0; i < arr.length; i++) {
				if (arr[i] && arr[i] != "" && arr[i] != "-" && arr[i] != 0) {
					alphaArr.push(alphaDict[arr[i]]);
				} else {
					alphaArr.push(0.2);
				}
			}
			return alphaArr;
		},

		carouselChage(data) {
			console.log(data);
			this.currentCar = data + 1;
			// 如果图片为两张时，多补两张图
			if (this.oneDayData.ycEvent.abnData.sliceNum == 2) {
				if (data == 2) {
					this.currentCar = 1;
				} else if (data == 3) {
					this.currentCar = 2;
				}
			}
		},
		getMinutes() {
			var day = new Date();
			for (var i = 0; i < 751; i++) {
				var ms = 12 * 3600 * 1000 + 60000 * i;
				day.setTime(parseInt(ms));
				var h = day.getHours().toString();
				if (h.length <= 1) h = "0" + h;
				var m = day.getMinutes().toString();
				if (m.length <= 1) m = "0" + m;
				this.minutes[i] = h + ":" + m;
			}
			// console.log(this.minutes);
		},
		getDayData(value) {
			console.log("udududududududdu");
			for (var i = 0; i < this.effeDates.length; i++) {
				var m = parseInt(this.effeDates[i].slice(5, 7)) - 1;
				var d = parseInt(this.effeDates[i].slice(8, 10));
				if (value.month() == m && value.date() == d) return true;
			}
		},
		getInvalidDates: function (value) {
			for (var i = 0; i < this.invalidDates.length; i++) {
				var m = parseInt(this.invalidDates[i].slice(5, 7)) - 1;
				var d = parseInt(this.invalidDates[i].slice(8, 10));
				if (value.month() == m && value.date() == d) return false;
			}
		},
		next() {
			this.$refs.abnormal.next();
			// if(this.currentPage >= this.abnLength) this.currentPage = 1;
			// else this.currentPage++;
		},
		pre() {
			this.$refs.abnormal.prev();
			// if(this.currentPage <= 1) this.currentPage = this.abnLength;
			// else this.currentPage--;
		},
		getDates() {
			var day = new Date();
			var time = day.getTime();
			for (var i = 0; i <= 7; i++) {
				var ms = 24 * 3600 * 1000 * i;
				day.setTime(parseInt(time - ms));
				var m = (day.getMonth() + 1).toString();
				//if(m.length <= 1) m = "0" + m;
				var d = day.getDate().toString();
				this.dates[i] = m + "月" + d + "日";
			}
		},
		getActiveDates() {
			var day = new Date();
			var time = day.getTime();
			for (var i = 0; i <= 366; i++) {
				var ms = 24 * 3600 * 1000 * i;
				day.setTime(parseInt(time - ms));
				var y = day.getFullYear().toString();
				var m = (day.getMonth() + 1).toString();
				if (m.length <= 1) m = "0" + m;
				var d = day.getDate().toString();
				if (d.length <= 1) d = "0" + d;
				this.activeDates[i] = y + "-" + m + "-" + d;
			}
			console.log(this.activeDates);
		},
		changeDates(value) {
			this.btnClick(1, this.activeDates[value], 2);
		},
		panelChange(date) {
			var dd = date._d;
			var y = dd.getFullYear().toString();
			var m = (dd.getMonth() + 1).toString();
			if (m.length <= 1) m = "0" + m;
			var d = dd.getDate().toString();
			if (d.length <= 1) d = "0" + d;
			var ad = y + "-" + m + "-" + d;
			//console.log(ad);
			if (this.activeDates.indexOf(ad) == -1) {
				var adn = ad;
				adn = parseInt(adn.split("-").join(""));
				var adsn = this.activeDate;
				adsn = parseInt(adsn.split("-").join(""));
				if (adn > adsn) {
					this.btnClick(1, this.activeDates[0], 2);
				} else {
					this.btnClick(1, this.activeDates[this.activeDates.length - 1], 2);
				}
			} else {
				this.btnClick(1, ad, 2);
			}
		},
		changeDate(date) {
			var dd = date._d;
			var y = dd.getFullYear().toString();
			var m = (dd.getMonth() + 1).toString();
			if (m.length <= 1) m = "0" + m;
			var d = dd.getDate().toString();
			if (d.length <= 1) d = "0" + d;
			var ad = y + "-" + m + "-" + d;
			//console.log(ad);
			this.btnClick(1, ad, 2);
		},
		AHI() {
			var string = "指数<5";
			var string1 = "5≤指数<15";
			var string2 = "15≤指数<30 ";
			return (
				<span slot="AHI">
					呼吸异常指数
					<a-popover placement="bottom" overlayClassName="breath-popover">
						<template slot="content">
							<p>呼吸异常指数是医学上用于确定</p>
							<p>确定呼吸异常严重程度的重要指</p>
							<p>标，是指平均每小时睡眠中出现</p>
							<p>呼吸暂停+低通气的次数。呼吸暂</p>
							<p>停医学评级标准：{string} 为健康</p>
							<p>{string1} 疑似低风险</p>
							<p>{string2} 疑似中风险</p>
							<p>AHI≥30 疑似高风险</p>
						</template>

						<div class="question-icon">?</div>
					</a-popover>
				</span>
			);
		},
		AI() {
			return (
				<span slot="AHI">
					呼吸暂停指数(AI)
					<a-popover placement="bottom" overlayClassName="breath-popover">
						<template slot="content">
							<p>呼吸暂停指数是指平均每小时</p>
							<p>睡眠中出现呼吸暂停的次数</p>
						</template>

						<div class="question-icon">?</div>
					</a-popover>
				</span>
			);
		},
		HI() {
			return (
				<span slot="AHI">
					低通气指数(HI)
					<a-popover placement="bottom" overlayClassName="breath-popover">
						<template slot="content">
							<p>低通气指数是指平均每小时睡眠中</p>
							<p>出现低通气的次数</p>
						</template>

						<div class="question-icon">?</div>
					</a-popover>
				</span>
			);
		},
		checkscroll(event) {
			//console.log("###", event);
		},

		// 分页
		pageChange(e) {
			//console.log(e);
			this.pageNum = e;
			this.getTableData();
		},
		// 筛选页面数据
		btnClick(val, valDate, num) {
			console.log(val, valDate, num);
			this.activeType = val;
			this.activeDate = valDate;
			if (val == 3 || val == 4) this.date = valDate;
			if (this.detailsPopup) {
				this.clearCharts();
				if (val == 1) {
					this.getDetailsDataSingle(valDate.slice(0, 7));
				} else {
					this.getH5ManyDaysReport();
				}
			}
		},
		clearCharts() {
			if (this.myChart0) this.myChart0.clear();
			if (this.myChart2) this.myChart2.clear();
			if (this.myChart1) this.myChart1.clear();
			if (this.myChart3) this.myChart3.clear();
			if (this.myChart4) this.myChart4.clear();
			if (this.myChart5) this.myChart5.clear();
			if (this.myChart6) this.myChart6.clear();
			if (this.myChart7) this.myChart7.clear();
			if (this.myChart8) this.myChart8.clear();
			if (this.myChart9) this.myChart9.clear();
			if (this.myChart10) this.myChart10.clear();
			for (var i = 0; i < this.myChartAbns.length; i++) {
				if (this.myChartAbns[i]) this.myChartAbns[i].clear();
			}
			for (var i = 0; i < this.myChartAbnHeats.length; i++) {
				if (this.myChartAbnHeats[i]) this.myChartAbnHeats[i].clear();
			}
		},
		// 外界调用这个组件
		details(scope) {
			this.currentScopeModel = scope;
			this.sn = scope.sn;
			// console.log(this.detailsData);
			this.detailsPopup = true;
			this.activeType = scope.activeType;
			this.activeDate = scope.activeDate;
			this.$nextTick(function () {
				this.box = document.getElementsByClassName("ant-modal-wrap")[0];
				this.box.addEventListener(
					"scroll",
					() => {
						this.scrollTop = this.box.scrollTop;
						var shareP = document.getElementsByClassName("ant-popover")[0];
						if (shareP) {
							shareP.style.top = this.popoverTop - this.box.scrollTop + "px";
						}
					},
					false
				);
			});
			// 通过$refs获取dom元素
			this.typeId = scope.bedId;
			this.bedName = scope.bedName;
			if (this.activeType == 1) {
				this.getDetailsDataSingle();
			} else {
				this.getH5ManyDaysReport();
			}
		},
		getTime(value) {
			var theTime = parseInt(value); // 秒
			var middle = 0; // 分
			var hour = 0; // 小时
			if (theTime > 60) {
				middle = parseInt(theTime / 60);
				theTime = parseInt(theTime % 60);
				if (middle > 60) {
					hour = parseInt(middle / 60);
					middle = parseInt(middle % 60);
				}
			}
			var result = "" + parseInt(theTime) + "秒";
			if (middle > 0) {
				result = "" + parseInt(middle) + "分" + result;
			}
			if (hour > 0) {
				result = "" + parseInt(hour) + "小时" + result;
			}
			return result;
		},
		parseTestdata() {
			// console.log(this.detailsData.hrrpSection);
			if (this.detailsData.hrrpSection) {
				this.testData0 = {
					hrrp_multiLine: this.detailsData.hrrpSection,
					breathPhaseFIR_Line_all: this.detailsData.breathPhaseSection,
					pow_thr1: this.detailsData.powThr1,
				};
				this.abnLength = this.testData0.hrrp_multiLine.length / 2400;
				this.testData = [];
				var len = this.abnLength;
				var breathPhase = [];
				for (var k = 0; k < len; k++) {
					var breathPhaseItem = [];
					for (var i = 600 * k; i < 600 * (k + 1); i++) {
						var item = [
							i + 1 - 600 * k,
							this.testData0.breathPhaseFIR_Line_all[i],
						];
						breathPhaseItem.push(item);
					}
					breathPhase.push(breathPhaseItem);
				}
				var hrrpMultiLine = [];
				for (var k = 0; k < len; k++) {
					var hrrp2d = [];
					for (var i = 2400 * k; i < 2400 * (k + 1); i += 60) {
						var item2 = [];
						for (var j = 0; j < 60; j++) {
							item2.push(this.testData0.hrrp_multiLine[i + j]);
						}
						hrrp2d.push(item2);
					}
					var hrrpMultiLineItem = [];
					for (var i = 0; i < 40; i++) {
						for (var j = 0; j < 60; j++) {
							hrrpMultiLineItem.push([j, i, hrrp2d[i][j]]);
						}
					}
					hrrpMultiLine.push(hrrpMultiLineItem);
				}
				this.testData.push(breathPhase);
				this.testData.push(hrrpMultiLine);
			}
		},
		getIdList() {
			this.abnIds = [];
			this.abnHeatIds = [];
			for (var i = 0; i < this.abnLength; i++) {
				this.abnIds[i] = "myChartsAbn" + i.toString();
				this.abnHeatIds[i] = "myChartsAbnHeat" + i.toString();
			}
		},

		// 获取单天详情数据
		getDetailsDataSingle(mouth) {
			this.getHealthPageV1All(mouth); //获取日历接口
			var that = this;
			this.spinning = true;
			this.actionReport = false;
			// let param = {
			//   bedId: this.typeId, // 当前页
			//   type: this.activeType, // 每页默认20条
			//   date: this.activeDate,
			// };
			// 新加
			// let obj = {
			//   sn: this.sn,

			//   sourceType: 1, //1web 2小程序
			// };
			let obj = {
				bedId: this.typeId,
				date: this.activeDate,
				// bedId: 1220,
				// date: '2023-06-28',
				reportType: 0,
			};
			console.log('=======waca', obj)
			this.$get(
				"/api/v3/report/getWebOneDayReport",
				obj,
				(res) => {
					if (res.code == 0) {
						this.isEmpty = res.data.resultFlag;
						if (res.data) {
							this.resultImg = res.data.resultImg;
						}
						this.actionReport = true;
						this.disabled = false;
						this.snCode = res.data.snCode;
						if (
							res.data.fallImgVo &&
							res.data.fallImgVo.fallPicDataVoList.length > 0
						) {
							this.isShowPic = true;
							// res.data.fallImgVo.fallPicDataVoList[
							//   res.data.fallImgVo.fallPicDataVoList.length - 1
							// ].data.data.splice(0, 1, 0);
						} else {
							this.isShowPic = false;
						}
						if (res.data.fallImgVo && res.data.fallImgVo.hasFallPicData) {
							setTimeout(() => {
								this.hasFallPicData = true;
							});
						} else {
							setTimeout(() => {
								this.hasFallPicData = false;
							});
						}

						that.oneDayData = res.data;
						// 睡眠指标循环部分
						let smzbObj = {
							smsc: null,
							sssc: null,
							yxsc: null,
							lc: null,
							rssc: null,
							smxl: null,
							td: null,
							tdzs: null,
							hxl: null,
							xl: null,
							ddfxzs: {},
						};
						let sleepIndexList = this.oneDayData.sleepIndexList;
						for (let i = 0; i < sleepIndexList.length; i++) {
							if (sleepIndexList[i].index == "sleepDuration") {
								//睡眠
								smzbObj.smsc = sleepIndexList[i];
							} else if (sleepIndexList[i].index == "deepSleepDuration") {
								//深睡
								smzbObj.sssc = sleepIndexList[i];
							} else if (sleepIndexList[i].index == "wakeUpDuration") {
								//夜醒
								smzbObj.yxsc = sleepIndexList[i];
							} else if (sleepIndexList[i].index == "outBedNum") {
								//离床
								smzbObj.lc = sleepIndexList[i];
							} else if (sleepIndexList[i].index == "sleepStDuration") {
								//入睡
								smzbObj.rssc = sleepIndexList[i];
							} else if (sleepIndexList[i].index == "sleepEff") {
								//睡眠效率
								smzbObj.smxl = sleepIndexList[i];
							} else if (sleepIndexList[i].index == "turnOverIndex") {
								//体动、体动指数
								smzbObj.td = sleepIndexList[i];
							}
						}
						if (res.data.userIndexList && res.data.userIndexList.length > 0) {
							for (let i = 0; i < res.data.userIndexList.length; i++) {
								if (res.data.userIndexList[i].index == "fall") {
									smzbObj.ddfxzs = res.data.userIndexList[i];
								}
							}
						} else {
							smzbObj.ddfxzs.comment = '正常'
							smzbObj.ddfxzs.value = 0
						}
						console.log(smzbObj)
						this.smzbObj = smzbObj;
						console.log("smzbObj", this.smzbObj);

						// 睡眠指标环形图
						this.sleepProportion = res.data.sleepProportion;
						this.scoreLabel = res.data.scoreLabel;
						this.$nextTick((resVal) => {
							this.getChartScore(res.data.score);
						});

						// 睡眠周期上方时间数组字段
						that.sleepTableTimeList = [];
						if (res.data.fallImgVo && res.data.fallImgVo.fallPicDataVoList) {
							this.timeArr = that.oneDayData.fallImgVo.fallPicDataVoList;
						}

						let sArr = that.oneDayData.sleepCycleVo.minutesList;
						// console.log(sArr)
						let sTimeStr =
							"20:00,21:00,22:00,23:00,00:00,01:00,02:00,03:00,04:00,05:00,06:00,07:00,08:00";
						for (let i = 0; i < sArr.length; i++) {
							if (sTimeStr.indexOf(sArr[i]) != -1) {
								that.sleepTableTimeList.push(sArr[i]);
							}
						}
						that.sleepTableTimeList =
							that.oneDayData.sleepCycleVo.sleepTableTimeList;
						that.sleepTableTimeList[0] = " ";
						that.sleepTableTimeList[
							Number(that.sleepTableTimeList.length - 1)
						] = " ";
						that.sleepTableTimeList[
							Number(that.sleepTableTimeList.length - 2)
						] = " ";
						// 睡眠详情
						let smxq = {
							//深睡，浅睡，清醒，离床
							series: [
								{
									name: "深睡",
									data: [
										this.oneDayData.sleepIndexCommonList.deepSleepDuration
											.ratio,
									],
								},
								{
									name: "浅睡",
									data: [
										this.oneDayData.sleepIndexCommonList.lightSleepDuration
											.ratio,
									],
								},
								{
									name: "清醒",
									data: [
										this.oneDayData.sleepIndexCommonList.clearSleepDuration
											.ratio,
									],
								},
								{
									name: "离床",
									data: [
										this.oneDayData.sleepIndexCommonList.outBedDuration.ratio,
									],
								},
							],
						};
						// 睡眠周期
						let smzq = {
							xAxis: {
								data: this.oneDayData.sleepCycleVo.minutesList,
							},
							series: [
								{
									name: "辅助",
									data: this.oneDayData.sleepCycleVo.sleepDataVoList[4]
										.dataList,
								},
								{
									name: "深睡",
									data: this.oneDayData.sleepCycleVo.sleepDataVoList[0]
										.dataList,
								},
								{
									name: "浅睡",
									data: this.oneDayData.sleepCycleVo.sleepDataVoList[1]
										.dataList,
								},
								{
									name: "清醒",
									data: this.oneDayData.sleepCycleVo.sleepDataVoList[2]
										.dataList,
								},
								{
									name: "离床",
									data: this.oneDayData.sleepCycleVo.sleepDataVoList[3]
										.dataList,
								},
							],
						};
						// 呼吸率
						let hxl = {
							xAxis: {
								data: this.oneDayData.sleepCycleVo.minutesList, //X轴通用呼吸周期
								min: "",
								max: "",
							},
							yAxis: {
								min:
									this.oneDayData.breathRateVo.min <= 0
										? this.oneDayData.breathRateVo.min
										: 0,
								max:
									this.oneDayData.breathRateVo.max >= 30
										? this.oneDayData.breathRateVo.max
										: 30,
							},
							series: {
								data: this.oneDayData.breathRateVo.dataList,
							},
							axisLabel: {
								margin: 18,
							},
							markLine: {
								data: [{ yAxis: 8 }, { yAxis: 24 }],
							},
						};
						// 心率
						let xl = {
							xAxis: {
								data: this.oneDayData.sleepCycleVo.minutesList, //X轴通用呼吸周期
								min: "",
								max: "",
							},
							yAxis: {
								min:
									this.oneDayData.heartRateVo.min <= 0
										? this.oneDayData.heartRateVo.min
										: 0,
								max:
									this.oneDayData.heartRateVo.max >= 110
										? this.oneDayData.heartRateVo.max
										: 110,
							},
							series: {
								data: this.oneDayData.heartRateVo.dataList,
							},
							axisLabel: {
								margin: 12,
							},
							markLine: {
								data: [{ yAxis: 90 }, { yAxis: 45 }],
							},
						};
						// 体动详情
						let turnOverData = {};
						this.oneDayData.sleepIndexList.forEach((item) => {
							if (item.index == "turnOverIndex") {
								turnOverData = item.extendData;
							}
						});
						let tdxq = {
							xAxis: {
								data: turnOverData.xtimeAxis, //X轴通用呼吸周期
								min: "",
								max: "",
							},
							yAxis: {
								min: "",
								max:
									turnOverData.max % 2 == 0
										? turnOverData.max
										: turnOverData.max + 1,
							},
							series: {
								data: turnOverData.data,
							},
						};
						// // 呼吸事件
						// let hxsj = {
						//   xAxis: {
						//     data: this.oneDayData.sleepCycleVo.minutesList, //X轴通用呼吸周期			//X轴通用呼吸周期
						//     min: '',
						//     max: '',
						//   },
						//   yAxis: {},
						//   series: {
						//     data: this.oneDayData.hxEvent.ahiData.data,
						//   },
						// };

						this.$nextTick(() => {
							this.getMyChart0("myCharts0", smxq); //睡眠详情
							// this.$refs.comment.getChartScore(
							//   this.oneDayData.sleepIndexCommonList.sleepScore
							// );

							this.getMyChart2("myCharts2", smzq); // 睡眠周期
							this.getMyChart3("myCharts3", hxl); // 呼吸率
							this.getMyChart3("myCharts4", xl); // 心率
							this.getMyChart5("myCharts5", tdxq); // 体动详情
							// this.getMyChartAHI('myChartsAHI', hxsj); // 呼吸事件
						});
					} else {
						this.resultTitle = res.msg;
						this.disabled = true;

						// this.$message.error(res.msg);
					}
					this.spinning = false;
				},
				(err) => {
					console.log(err);
					this.spinning = false;
				}
			);
			// 新加结束
		},
		// 获取日历接口
		getHealthPageV1All(month = "") {
			let param2 = {
				bedId: this.typeId, // 当前页
				month: month,
			};
			this.$get(
				"/api/health/getHealthPageV1All",
				param2,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.effeDatesData = res.data.data;
							// console.log(this.effeDatesData);
							this.effeDates = [];
							var vdates = [];
							for (var i = 0; i < this.effeDatesData.length; i++) {
								for (var key in this.effeDatesData[i]) {
									if (key != "reason") {
										vdates.push(key);
									}
								}
								if (this.effeDatesData[i].reason === "数据解析成功") {
									for (var key in this.effeDatesData[i]) {
										if (key != "reason") {
											this.effeDates.push(key);
										}
									}
								}
							}
							this.invalidDates = [];
							for (var i = 0; i < this.activeDates.length; i++) {
								if (!vdates.includes(this.activeDates[i])) {
									this.invalidDates.push(this.activeDates[i]);
								}
							}
							console.log("##", this.activeDates, this.invalidDates);
							console.log(this.effeDates);
						} else {
						}
					} else {
						this.$message.error(res.msg);
					}
					this.spinning = false;
				},
				(err) => {
					//console.log(err);
					this.spinning = false;
					// // this.$message.error("服务端发生异常");
				}
			);
		},
		// 获取多天详情数据
		getDetailsData() {
			this.spinning = true;
			let param = {
				bedId: this.typeId, // 当前页
				type: this.activeType, // 每页默认20条
			};
			this.$get(
				"/api/health/moreDay",
				param,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.detailsManyData = res.data;
							console.log(this.detailsManyData);
							this.disabled = false;
							setTimeout((e) => {
								this.getMyChart7(); // 离床次数
								this.getMyChart8(); // 离床时长
								this.getMyChart9(); // 体动次数
							}, 200);
						} else {
							this.detailsManyData = {};
							this.disabled = true;
						}
					} else {
						this.$message.error(res.msg);
					}
					this.spinning = false;
				},
				(err) => {
					this.spinning = false;
					//console.log(err);
					// // this.$message.error("服务端发生异常");
				}
			);
			let param2 = {
				bedId: this.typeId, // 当前页
				endTime: this.activeDates[0],
				startTime:
					this.activeType == 3 ? this.activeDates[6] : this.activeDates[29],
			};
			this.$get(
				"/api/health/getBreathDataRule",
				param2,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.detailsManyData2 = res.data;
							this.disabled = false;
							// console.log(this.detailsManyData2);
							setTimeout((e) => {
								// this.getMyChart11();
							}, 200);
						} else {
							this.detailsManyData2 = {};
							this.disabled = true;
						}
					} else {
						this.$message.error(res.msg);
					}
					this.spinning = false;
				},
				(err) => {
					this.spinning = false;
					//console.log(err);
					// // this.$message.error("服务端发生异常");
				}
			);

			this.$get(
				"/api/health/getSleepRuleAndHeartData",
				param2,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.detailsManyData3 = res.data;
							this.disabled = false;
							// console.log("##", this.detailsManyData3)
							setTimeout((e) => {
								// this.getMyChart10();
								// this.getMyChart12();
							}, 200);
						} else {
							this.detailsManyData3 = {};
							this.disabled = true;
						}
					} else {
						this.$message.error(res.msg);
					}
					this.spinning = false;
				},
				(err) => {
					this.spinning = false;
					//console.log(err);
					// // this.$message.error("服务端发生异常");
				}
			);
			if (this.activeType == 4) {
				this.$get(
					"/api/health/getReportInterpretation",
					param2,
					(res) => {
						if (res.code == 0) {
							if (res.data) {
								this.detailsManyDataSug = res.data;
								// console.log("hello", this.detailsManyDataSug);
								// console.log("hello", this.detailsManyDataSug.SleepEvaluation.slice(38));
								this.disabled = false;
							} else {
								this.detailsManyDataSug = {};
								this.disabled = true;
							}
						} else {
							this.$message.error(res.msg);
						}
						this.spinning = false;
					},
					(err) => {
						this.spinning = false;
						//console.log(err);
						// // this.$message.error("服务端发生异常");
					}
				);
			}
		},

		// 睡眠详情（id名称，所需数据）
		getMyChart0(idName, data) {
			console.log(data);
			let that = this;
			let myChart0 = this.$echarts.init(document.getElementById(idName));
			var option0 = {
				tooltip: {
					borderColor: "#1890FF",
					borderColor: "rgba(24, 144, 255, 0.6)",
					borderWidth: 1,
					spanStyle: {
						color: "#8c8c8c",
					},
					formatter: function (params) {
						// console.log(params);
						let nowBgColor = "";
						if (params.seriesName == "深睡") {
							nowBgColor = "#4d8ef7";
						} else if (params.seriesName == "浅睡") {
							nowBgColor = "#c394fe";
						} else if (params.seriesName == "清醒") {
							nowBgColor = "#f8b4e7";
						} else {
							nowBgColor = "#ffb5b5";
						}
						var msg =
							"<div style='display:flex;justify-content: center;align-items: center;'>";
						msg +=
							"<div style='width:10px;height:10px;background:" +
							nowBgColor +
							";display:block;margin-right:4px;'></div>";
						msg += params.seriesName;
						msg += "   ";
						msg += params.value;
						msg += "%";
						if (params.seriesName == "深睡") {
							if (parseInt(params.value) <= 60 && parseInt(params.value) >= 20)
								msg += "<span style='color: #1890FF'>&nbsp;正常</span>";
							else if (parseInt(params.value) < 20)
								msg += "<span style='color: #FF4D4F'>&nbsp;偏少</span>";
							else msg += "<span style='color: #FF4D4F'>&nbsp;偏多</span>";
						} else if (params.seriesName == "浅睡") {
							if (parseInt(params.value) <= 80)
								msg += "<span style='color: #1890FF'>&nbsp;正常</span>";
							else msg += "<span style='color: #FF4D4F'>&nbsp;偏多</span>";
						} else if (params.seriesName == "清醒") {
							if (parseInt(params.value) <= 5)
								msg += "<span style='color: #1890FF'>&nbsp;正常</span>";
							else msg += "<span style='color: #FF4D4F'>&nbsp;偏多</span>";
						} else {
							console.log(params);
							if (
								that.oneDayData.sleepIndexCommonList.outBedDuration.comment ==
								"正常"
							)
								msg += "<span style='color: #1890FF'>&nbsp;正常</span>";
							else msg += "<span style='color: #FF4D4F'>&nbsp;偏多</span>";
						}
						msg += "</div>";
						return msg;
					},
				},
				color: ["#1890FF", "#c394fe", "#f8b4e7", "#f8b5b5", "#000000"],
				grid: {
					left: "0%",
					right: "0%",
					top: "100%",
					bottom: "0%",
					containLabel: true,
				},
				xAxis: [
					{
						max: 100,
						type: "value",
						show: false,
						axisLabel: {
							margin: 0,
							padding: [100, 100, 0, 0],
						},
					},
				],
				yAxis: [
					{
						type: "category",
						show: false,
						axisLabel: {
							margin: 0,
							//padding:[0,0,0,0],
						},
					},
				],
				series: [
					{
						name: "深睡",
						type: "bar",
						stack: "1",
						barWidth: 50,
						data: [data.series[0].data],
					},
					{
						name: "浅睡",
						type: "bar",
						stack: "1",
						barWidth: 50,
						data: [data.series[1].data],
					},
					{
						name: "清醒",
						type: "bar",
						stack: "1",
						barWidth: 50,
						data: [data.series[2].data],
					},
					{
						name: "离床",
						type: "bar",
						stack: "1",
						barWidth: 50,
						data: [data.series[3].data],
					},
				],
			};
			myChart0.setOption(option0);
		},
		//呼吸暂停和低通气图表
		getMyChartAHI(idName, data) {
			var apnea = data.series.data; //呼吸暂停新加
			if (this.myChartAHI) {
				this.myChartAHI.dispose();
			}
			this.myChartAHI = this.$echarts.init(document.getElementById(idName));

			// var apnea = JSON.parse(this.healthReport.apneaFrequencyStr); //呼吸暂停
			// console.log(this.healthReport)
			// var hyponea = JSON.parse(this.healthReport.hyponeaFrequencyStr); //低通气
			// var alldata = [];
			// var apneaOnes = [];
			// var hyponeaOnes = [];
			// for (var i = 0; i < apnea.length; i++) {
			//   if (apnea[i] >= 1) apneaOnes[i] = 1;
			//   else apneaOnes[i] = 0;
			//   if (hyponea[i] >= 1) hyponeaOnes[i] = 1;
			//   else hyponeaOnes[i] = 0;
			// }
			// for (var i = 0; i < apneaOnes.length; i++) {
			//   if (apneaOnes[i] == 1) {
			//     if (hyponeaOnes[i] == 1) {
			//       alldata.push(0);
			//     } else {
			//       alldata.push(1);
			//     }
			//   } else {
			//     alldata.push(0);
			//   }
			// }
			var option2 = {
				tooltip: {
					backgroundColor: "rgba(255, 255, 255, 0.9)",
					borderColor: "rgba(24, 144, 255, 0.8)",
					borderWidth: 1,
					borderRadius: 5,
					trigger: "axis",
					position: function (point, params, dom, rect, size) {
						//其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
						var x = point[0];
						var y = point[1];
						var viewWidth = size.viewSize[0];
						var viewHeight = size.viewSize[1];
						var boxWidth = size.contentSize[0];
						var boxHeight = size.contentSize[1];
						var posX = 0; //x坐标位置
						var posY = 0; //y坐标位置

						if (x < boxWidth) {
							//左边放不开
							posX = 5;
						} else {
							//左边放的下
							posX = x - boxWidth;
						}

						if (y < boxHeight) {
							//上边放不开
							posY = 5;
						} else {
							//上边放得下
							posY = y - boxHeight;
						}
						return [posX, posY];
					},
					formatter: function (params) {
						if (params[0].data != 0) {
							return (
								params[0].axisValue +
								"发生" +
								// apnea[params[0].dataIndex] +
								apnea[params[0].dataIndex] / 2 +
								"次呼吸暂停"
							);
						} else {
							return params[0].axisValue;
						}
					},
				},
				grid: {
					left: "1%",
					right: "2%",
					top: "8%",
					bottom: "0%",
					containLabel: true,
				},
				color: ["#1890FF"],
				xAxis: [
					{
						type: "category",
						max: this.leaveBedTime != "暂无" ? this.leaveBedTime : this.endTime,
						min: this.getBedTime != "暂无" ? this.getBedTime : this.beginTime,
						axisTick: {
							//y轴刻度线
							show: false,
						},
						axisLabel: {
							//x坐标轴刻度标签
							spanStyle: {
								color: "rgba(0,0,0,0.35)", //坐标的字体颜色
							},
							interval: 59,
						},
						axisLine: {
							//x坐标轴轴线
							lineStyle: {
								color: "rgba(0,0,0,0.15)",
								type: "solid",
							},
						},
						// data: this.minutes,
						data: data.xAxis.data,
					},
				],
				yAxis: [
					{
						type: "value",
						max: 2,
						axisLine: {
							//坐标轴轴线相关设置。
							lineStyle: {
								color: "rgba(0,0,0,0.15)",
							},
							show: true,
						},
						splitLine: {
							//坐标轴在 grid 区域中的分隔线设置。
							show: true,
							lineStyle: {
								type: "dashed",
								color: ["transparent", "#fff", "#ddd", "#fff", "#fff", "#fff"],
							},
						},
						axisTick: {
							//坐标轴刻度相关设置
							//y轴刻度线
							show: false,
						},
						axisLabel: {
							//坐标轴刻度标签的相关设置。
							formatter: function (value) {
								var spans = [];
								if (value == 1) {
									let words = "呼吸" + "<br/>" + "暂停";
									// let words = '呼吸暂停'
									spans.push(words);
								}
								return spans;
							},
							spanStyle: {
								color: "rgba(0,0,0,0.35)", //坐标的字体颜色
							},
							show: true,
						},
					},
				],
				series: [
					{
						// data: apneaOnes,
						// data: [0,0,0,1,1,1,0,0,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
						data: data.series.data,
						type: "bar",
						showBackground: true,
						backgroundStyle: {
							color: "rgba(0,0,0,0)",
						},
					},
				],
			};
			this.myChartAHI.setOption(option2);
		},
		//典型呼吸异常事件
		getMyChartAbn() {
			for (var k = 0; k < this.abnLength; k++) {
				if (
					this.myChartAbns[k] != null &&
					this.myChartAbns[k] != "" &&
					this.myChartAbns[k] != undefined
				) {
					this.myChartAbns[k].dispose();
				}
			}
			for (var k = 0; k < this.abnLength; k++) {
				var myChartAbn = this.$echarts.init(
					document.getElementById(this.abnIds[k])
				);
				this.myChartAbns[k] = myChartAbn;
				var breathSection = [];
				for (var i = 0; i < 600; i++) {
					breathSection.push(this.testData[0][k][i][1]);
				}
				var optionAbn = {
					color: ["#1890FF"],
					grid: {
						left: "0%",
						right: "0%",
						top: "100%",
					},
					xAxis: {
						show: true,
						axisLabel: {
							formatter: function () {
								return "";
							},
						},
						axisLine: {
							lineStyle: {
								color: "#d9d9d9",
							},
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: "#d9d9d9",
								type: "solid",
								with: 1,
							},
						},
					},
					yAxis: {
						// min: Math.min(...breathSection) - 10,
						// max: Math.max(...breathSection) + 30,
						show: true,
						axisLine: {
							lineStyle: {
								color: "#d9d9d9",
							},
						},
						axisLabel: {
							formatter: function () {
								return "";
							},
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: "#d9d9d9",
								type: "solid",
								with: 1,
							},
						},
					},
					series: [
						{
							data: this.testData[0][k],
							type: "line",
							smmoth: true,
							silent: true,
							symbol: "none",
						},
					],
				};

				this.myChartAbns[k].setOption(optionAbn);
				this.myChartAbns[k].resize();
			}
		},
		getMyChartAbnHeat() {
			console.log("hwllo", this.testData);
			for (var k = 0; k < this.abnLength; k++) {
				if (
					this.myChartAbnHeats[k] != null &&
					this.myChartAbnHeats[k] != "" &&
					this.myChartAbnHeats[k] != undefined
				) {
					this.myChartAbnHeats[k].dispose();
				}
			}
			for (var k = 0; k < this.abnLength; k++) {
				var myChartAbnHeat = this.$echarts.init(
					document.getElementById(this.abnHeatIds[k])
				);
				this.myChartAbnHeats[k] = myChartAbnHeat;
				var hrrpSection = [];
				for (var i = 0; i < 2400; i++) {
					hrrpSection.push(this.testData[1][k][i][2]);
				}
				var optionAbn = {
					backgroundColor: "#000e6b",
					grid: {
						left: "1%",
						right: "1%",
						top: "100%",
					},
					xAxis: {
						type: "category",
						show: false,
					},
					yAxis: {
						type: "category",
						show: false,
					},
					visualMap: [
						// {
						// 	show: false,
						// 	//type: 'continuous',
						// 	type: 'piecewise',
						// 	min: Math.min(...hrrpSection),
						// 	max: this.testData0.pow_thr1[0],
						// 	// pieces: [
						// 	// 	{min: Math.min(...hrrpSection), max: this.testData0.pow_thr1[0]}
						// 	// ],
						// 	left: 'right',
						// 	top: 'center',
						// 	calculable: false,
						// 	realtime: false,
						// 	splitNumber: 1,
						// 	inRange:{
						// 		color: ['#000000'],
						// 		symbolSize: [30, 30]
						// 	},
						// },
						{
							border: "none",
							show: false,
							type: "continuous",
							//type: 'piecewise',
							min: this.testData0.pow_thr1[k],
							//min: Math.min(...hrrpSection),
							max: Math.max(...hrrpSection),
							// pieces: [
							// 	{min: Math.min(...hrrpSection), max: this.testData0.pow_thr1[0]}
							// ],
							left: "right",
							top: "center",
							calculable: false,
							realtime: false,
							splitNumber: 100,
							inRange: {
								color: ["#000e6b", "#ff60be"],
								symbolSize: [30, 30],
							},
						},
					],

					series: [
						{
							edgeColor: "none",
							data: this.testData[1][k],
							type: "heatmap",
							symbol: "none",
							silent: true,
							animation: false,
						},
					],
				};
				this.myChartAbnHeats[k].setOption(optionAbn);
				this.myChartAbnHeats[k].resize();
			}
		},
		getMyChart2(idName, data) {
			console.log(data);
			let myChart2 = this.$echarts.init(document.getElementById(idName));

			var that = this;
			var option2 = {
				tooltip: {
					trigger: "axis",
					backgroundColor: "rgba(255, 255, 255, 0.9)",
					borderColor: "rgba(24, 144, 255, 0.8)",
					// borderWidth: 1,
					borderRadius: 5,
					position: function (point, params, dom, rect, size) {
						//其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
						var x = point[0]; //
						var y = point[1];
						var viewWidth = size.viewSize[0];
						var viewHeight = size.viewSize[1];
						var boxWidth = size.contentSize[0];
						var boxHeight = size.contentSize[1];
						var posX = 0; //x坐标位置
						var posY = 0; //y坐标位置

						if (x < boxWidth) {
							//左边放不开
							posX = 5;
						} else {
							//左边放的下
							posX = x - boxWidth;
						}

						if (y < boxHeight) {
							//上边放不开
							posY = 5;
						} else {
							//上边放得下
							posY = y - boxHeight;
						}

						return [posX, posY];
					},
					formatter: function (params) {
						// console.log(params)
						// console.log(data)
						//params[index]  1234 代表深睡  浅睡 清醒 离床
						var message = "";
						var index = null;
						var beginTime = "";
						var endTime = "";
						var indexJ = 0;
						var indexI = 0;
						if (params[1].data !== "-") {
							message += "深睡";
							index = 1;
						} else if (params[2].data !== "-") {
							message += "浅睡";
							index = 2;
						} else if (params[3].data !== "-") {
							message += "清醒";
							index = 3;
						} else if (params[4].data !== "-") {
							message += "离床";
							index = 4;
						} else {
							return;
						}
						let nowIndex = params[index].dataIndex; //当前划过位置下标
						if (index != null) {
							for (let i = nowIndex; i >= 0; i--) {
								if (data.series[index].data[i] == "-") {
									beginTime = data.xAxis.data[i + 1];
									indexI = i + 1;
									break;
								}
								if (i == 0) {
									beginTime = data.xAxis.data[i];
									indexI = i;
								}
							}
							for (let j = nowIndex; j < data.series[index].data.length; j++) {
								if (data.series[index].data[j] == "-") {
									endTime = data.xAxis.data[j - 1];
									indexJ = j;
									break;
								}
								if (j == data.series[index].data.length - 1) {
									endTime = data.xAxis.data[j - 1];
									indexJ = j;
								}
							}
						}
						if (Math.floor((indexJ - indexI) / 60) == 0) {
							message +=
								"<span style='font-size:20px;font-weight: bold;'> " +
								((indexJ - indexI) % 60) +
								"</span>" +
								"分钟</br>";
						} else {
							message +=
								"<span style='font-size:20px;font-weight: bold;'> " +
								Math.floor((indexJ - indexI) / 60) +
								"</span>" +
								"小时" +
								"<span style='font-size:20px;font-weight: bold;'>" +
								((indexJ - indexI) % 60) +
								"</span>" +
								"分钟</br>";
						}
						message += beginTime + "-" + endTime; //12:23-04:14
						if (indexJ - indexI == 0) return null;
						return message;
					},
				},
				grid: {
					left: "0%",
					right: "0%",
					top: "0%",
					bottom: "0%",
					containLabel: true,
				},
				color: ["#1890FF", "#c394fe", "#f8b4e7", "#f8b5b5", "#000000"],
				xAxis: [
					{
						position: "top",
						type: "category",
						axisLabel: {
							show: false,
							showMaxLabel: false,
							showMinLabel: false,
							spanStyle: {
								color: "rgba(0,0,0,0.35)", //坐标的字体颜色
							},
							// formatter: function(params) {
							//   let time = ''
							//   time = params.substr(params.length-2,2) === '00' ? params : ''
							//   return time.substr(0,2) !== '07' ? time : ''
							// },
							// interval: 59,
							// interval: 0,
						},
						axisLine: {
							lineStyle: {
								color: "rgba(0,0,0,0.15)",
							},
						},
						axisTick: {
							show: false,
						},
						// data: this.minutes,
						data: data.xAxis.data,
					},
				],
				yAxis: [
					{
						type: "value",
						max: 4,
						maxInterval: 0.5,
						splitLine: {
							show: false,
						},
						z: 10,

						axisLine: {
							lineStyle: {
								color: "rgba(0,0,0,0.15)",
							},
							show: true,
						},
						axisTick: {
							//y轴刻度线
							// show: false,
						},
						axisLabel: {
							formatter: function (value) {
								var spans = [];
								//console.log('shuimian:',value)
								if (value == 0) {
									spans.push("");
								} else if (value == 0.5) {
									spans.push("深睡");
								} else if (value == 1.5) {
									spans.push("浅睡");
								} else if (value == 2.5) {
									spans.push("清醒");
								} else if (value == 3.5) {
									spans.push("离床");
								} else {
									spans.push("");
								}
								return spans;
							},
							spanStyle: {
								color: "rgba(0,0,0,0.35)", //坐标的字体颜色
							},
							show: true,
						},
					},
				],
				series: [
					{
						name: "辅助",
						type: "bar",
						stack: "总量",
						xAxisIndex: 0,
						itemStyle: {
							barBorderColor: "rgba(0,0,0,0)",
							color: "rgba(0,0,0,0)",
						},
						emphasis: {
							itemStyle: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
						},
						// data: this.detailsData.sleepData
						//   ? this.detailsData.sleepData[4].datas
						//   : [],
						data: data.series[0].data,
					},
					{
						name: "深睡",
						type: "bar",
						barCategoryGap: -1,
						stack: "总量",
						xAxisIndex: 0,
						// data: this.detailsData.sleepData
						//   ? this.detailsData.sleepData[0].datas
						//   : [],
						data: data.series[1].data,
					},
					{
						name: "浅睡",
						type: "bar",
						stack: "总量",
						xAxisIndex: 0,
						// data: this.detailsData.sleepData
						//   ? this.detailsData.sleepData[1].datas
						//   : [],
						data: data.series[2].data,
					},
					{
						name: "清醒",
						type: "bar",
						stack: "总量",
						xAxisIndex: 0,
						// data: this.detailsData.sleepData
						//   ? this.detailsData.sleepData[2].datas
						//   : [],
						data: data.series[3].data,
					},
					{
						name: "离床",
						type: "bar",
						stack: "总量",
						xAxisIndex: 0,
						// data: this.detailsData.sleepData
						//   ? this.detailsData.sleepData[3].datas
						//   : [],
						data: data.series[4].data,
					},
				],
			};
			myChart2.setOption(option2);
		},
		// 呼吸率，心率图表
		getMyChart3(idName, data) {
			let myChart3 = this.$echarts.init(document.getElementById(idName));
			var option3 = {
				tooltip: {
					backgroundColor: "rgba(255, 255, 255, 0.9)",
					borderColor: "rgba(24, 144, 255, 0.8)",
					// borderWidth: 1,
					borderRadius: 5,
					show: true,
					trigger: "axis",
				},
				color: ["#1890FF"],
				grid: {
					left: "0%",
					right: "0%",
					top: "8%",
					bottom: "0%",
					containLabel: true,
				},
				xAxis: {
					type: "category",
					max: data.xAxis.min,
					min: data.xAxis.max,
					// max: this.leaveBedTime != "暂无" ? this.leaveBedTime : this.endTime,
					// min: this.getBedTime != "暂无" ? this.getBedTime : this.beginTime,
					show: false,
					axisLabel: {
						spanStyle: {
							color: "rgba(0,0,0,0.35)", //坐标的字体颜色
						},
						interval: 59,
					},
					axisLine: {
						lineStyle: {
							color: "rgba(0,0,0,0.15)",
						},
					},
					boundaryGap: false,
					// data: this.minutes ? this.minutes : [],
					data: data.xAxis.data,
				},
				yAxis: {
					min: idName == "myCharts4" ? 40 : data.yAxis.min,
					max: data.yAxis.max,
					interval: 20,
					z: 10,
					splitLine: {
						show: false,
					},
					axisLine: {
						lineStyle: {
							color: "rgba(0,0,0,0.15)",
						},
						show: true,
					},
					axisTick: {
						//y轴刻度线
						show: false,
					},
					axisLabel: {
						spanStyle: {
							color: "rgba(0,0,0,0.35)", //坐标的字体颜色
						},
						margin: data.axisLabel.margin,
					},
				},
				series: [
					{
						// data: [157,165,193,194,167,194,211,200,201,180,119,115,101,94,94,111,99,74,63,54,57,49,64,66,44,44,45,25,23,24,240,215,222,248,239,227,231,238,241,232,263,238,235,257,276,248,253,256,250,256,53,39,20,39,64,36,15,39,21,13,221,229,212,207,218,201,229,201,185,177,154,155,170,161,179,197,194,207,235,256,218,204,199,187,163,178,191,216,220,210,290,267,253,224,252,234,230,240,246,226,291,263,249,260,286,280,254,233,216,233,159,145,165,159,167,139,143,165,194,175,110,104,105,82,53,37,13,0,0,0,57,77,54,54,65,42,31,10,0,0,235,262,272,247,244,249,263,251,242,252,163,147,172,166,143,149,124,152,150,151,245,241,238,211,188,176,163,184,165,150,204,189,192,164,170,159,140,162,136,145,73,50,28,49,47,54,37,53,63,65,111,103,127,150,129,122,96,121,121,140],
						// data: bd ? bd : [],
						data: data.series.data,
						type: "line",
						smooth: true,
						symbol: "none",
						emphasis: {
							lineStyle: {
								width: 1,
							},
						},
						itemStyle: {
							normal: {
								color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
									{
										offset: 0,
										color: "#4D8EF7",
									},
									{
										offset: 1,
										color: "#C394FE",
									},
								]),
								lineStyle: {
									width: 1, //设置线条粗细
								},
							},
						},
						markLine: {
							symbol: "none",
							emphasis: {
								lineStyle: {
									width: 1, // hover时的折线宽度
								},
							},
							data: [
								{
									silent: false, //鼠标悬停事件  true没有，false有
									lineStyle: {
										//警戒线的样式  ，虚实  颜色
										type: "dashed",
										color: "#C394FE",
									},
									label: {
										position: "end",
										formatter: "",
									},
									// yAxis: 8, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
									yAxis: data.markLine.data[0].yAxis, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
								},
								{
									silent: false, //鼠标悬停事件  true没有，false有
									lineStyle: {
										//警戒线的样式  ，虚实  颜色
										type: "dashed",
										color: "#C394FE",
									},
									label: {
										position: "end",
										formatter: "",
										fontSize: "8",
									},
									// yAxis: 24, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
									yAxis: data.markLine.data[1].yAxis, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
								},
							],
						},
					},
				],
			};
			myChart3.setOption(option3);
		},
		// 体动详情图表
		getMyChart5(idName, data) {
			// console.log(this.detailsData.turnOverData)
			if (this.myChart5) {
				this.myChart5.dispose();
			}
			let myChart5 = this.$echarts.init(document.getElementById(idName));
			var option5 = {
				color: ["#1890FF"],
				tooltip: {
					backgroundColor: "rgba(255, 255, 255, 0.9)",
					borderColor: "rgba(24, 144, 255, 0.8)",
					borderRadius: 5,
					show: true,
					trigger: "axis",
					formatter: function (params) {
						console.log(params)
						console.log(data)
						var msg = "";
						msg += params[0].axisValue;
						msg += "～";
						var msg2 = "";
						if (parseInt(params[0].axisValue.slice(3)) < 45) {
							msg2 =
								params[0].axisValue.slice(0, 2) +
								":" +
								(parseInt(params[0].axisValue.slice(3)) + 15).toString();
						} else {
							if (parseInt(params[0].axisValue.slice(0, 2)) < 9) {
								msg2 +=
									"0" +
									(parseInt(params[0].axisValue.slice(0, 2)) + 1).toString() +
									":" +
									"00";
							} else if (parseInt(params[0].axisValue.slice(0, 2)) == 23) {
								msg2 += "00:00";
							} else {
								msg2 +=
									(parseInt(params[0].axisValue.slice(0, 2)) + 1).toString() +
									":" +
									"00";
							}
						}
						msg += msg2 + "<br>";
						msg += "体动" + params[0].data + "次";
						return msg;
					},
				},
				grid: {
					left: "1%",
					right: "1%",
					top: "8%",
					bottom: "4%",
					containLabel: true,
				},
				xAxis: [
					{
						type: "category",
						axisTick: { show: false },
						axisLabel: {
							show: false,
							spanStyle: {
								color: "rgba(0,0,0,0.35)", //坐标的字体颜色
							},
							interval: 3,
						},
						axisLine: {
							lineStyle: {
								color: "rgba(0,0,0,0.15)",
							},
							show: false,
						},
						data: data.xAxis.data,
					},
				],
				yAxis: [
					{
						max: data.yAxis.max,
						type: "value",
						splitLine: {
							show: false,
						},
						z: 10,
						minInterval: 1, //设置最小间隔为1，防止出现小数
						axisLine: {
							lineStyle: {
								color: "rgba(0,0,0,0.15)",
							},
							show: true,
						},
						axisTick: {
							//y轴刻度线
							show: false,
						},
						axisLabel: {
							spanStyle: {
								color: "rgba(0,0,0,0.35)", //坐标的字体颜色
							},
							margin: 18,
							show: true,
						},
					},
				],
				series: [
					{
						// name: "1",
						type: "bar",
						barGap: 0,
						barCategoryGap: 1,
						barMinHeight: 1,
						itemStyle: {
							normal: {
								barBorderRadius: [4, 4, 0, 0],
								color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
									{
										offset: 0,
										color: "#4D8EF7",
									},
									{
										offset: 1,
										color: "#C394FE",
									},
								]),
							},
						},
						// data: this.detailsData.turnOverData
						//   ? this.detailsData.turnOverData
						//   : [],
						data: data.series.data,
					},
				],
			};
			myChart5.setOption(option5);
		},
		// 睡眠平均时长图表
		getMyChart6(idName, data) {
			this.myChart6 = this.$echarts.init(document.getElementById(idName));
			console.log(data);
			let hh = data.indexValHour > 0 ? data.indexValHour * 60 : 0;
			let mm = data.indexValMinute > 0 ? data.indexValMinute : 0;
			let sleepAvg = ((hh + mm) / 60).toFixed(1); //平均值

			// 模拟后端返回数据
			// let qs = ["300", "272", "264", "285", "-", "-", "-"]    //浅睡
			// let ss = ["60", "233", "314", "211", "-", "-", "-"]    //深睡
			// let ss2 = ["60", "20", "264", "300", "-", "-", "-"]    //睡眠
			let qs = data.reportTrendsDataVo.lightData; //浅睡
			let ss = data.reportTrendsDataVo.deepData; //深睡
			let ss2 = data.reportTrendsDataVo.data; //睡眠
			let comLen = qs.length; //公共长度

			let lightSleepList = []; // 浅睡新数据
			let deepSleepList = []; // 深睡新数据

			for (let i = 0; i < comLen; i++) {
				if (qs[i] == "-") {
					lightSleepList.push({
						value: 0,
						timeFonts: 0,
						timeFonts2: 0,
					});
					deepSleepList.push({
						value: 0,
						timeFonts: 0,
						timeFonts2: 0,
					});
				} else {
					lightSleepList.push({
						value: qs[i] / 60,
						timeFonts: this.formaTime(qs[i]),
						timeFonts2: this.formaTime(ss2[i]),
					});
					deepSleepList.push({
						value: ss[i] / 60,
						timeFonts: this.formaTime(ss[i]),
						timeFonts2: this.formaTime(ss2[i]),
					});
				}
			}

			// console.log(deepSleepList)
			// console.log(lightSleepList)
			// console.log(sleepAvg)
			var optionSleepDuration = {
				color: ["#1890FF", "#c394fe", "#f8b4e7", "#f8b5b5"],
				tooltip: {
					confine: true,
					trigger: "axis",
					backgroundColor: "rgba(255, 255, 255, 1)",
					borderColor: "rgba(24, 144, 255, 0.6)",
					borderWidth: 1,
					spanStyle: {
						color: "#fff",
					},
					formatter: function (params) {
						console.log(params);
						for (var x = 0; x < params.length; i++) {
							if (params[x].data.timeFonts2 == "0") {
								return (
									params[x].name +
									'<br/>睡眠时长：-<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>深睡时长：-<br/><span style="background:#c394fe;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>浅睡时长：-'
								);
							} else {
								return (
									params[x].name +
									"<br/>睡眠时长：" +
									params[x].data.timeFonts2 +
									'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>深睡时长：' +
									params[0].data.timeFonts +
									'<br/><span style="background:#c394fe;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>浅睡时长：' +
									params[1].data.timeFonts
								);
							}
						}
					},
				},
				grid: {
					left: "1%",
					right: "1%",
					top: "15%",
					bottom: "1%",
					containLabel: true,
				},
				xAxis: [
					{
						type: "category",
						data: data.com_xAxis,
						axisLabel: {
							spanStyle: {
								color: "#c7c6c9", //坐标的字体颜色
							},
							// formatter: function (params) {
							//   return params.replace("-", "<br/>");
							// },
						},
						axisLine: {
							lineStyle: {
								color: "#c7c6c9",
							},
						},
						axisTick: {
							show: false,
							alignWithLabel: true,
						},
					},
				],
				yAxis: [
					{
						type: "value",
						min: 0,
						// max: 12,
						logBase: 10,
						splitLine: {
							show: true,
						},
						axisLine: {
							lineStyle: {
								color: "#c7c6c9",
							},
							show: false, //显示y轴，新版本默认没显示
						},
						axisLabel: {
							formatter: "{value}h",
							spanStyle: {
								color: "#c7c6c9", //坐标的字体颜色
							},
						},
						splitNumber: 3,
					},
				],
				series: [
					{
						name: "深睡",
						type: "bar",
						stack: "1",
						barWidth: data.activeType == 2 ? "20" : "10",
						// barWidth: comLen.length > 7 ? "" : 20, //柱图宽度
						data: deepSleepList,
					},

					{
						name: "浅睡",
						type: "bar",
						stack: "1",
						barWidth: data.activeType == 2 ? "20" : "10",
						// barWidth: comLen.length > 7 ? "" : 20, //柱图宽度
						data: lightSleepList,
						itemStyle: {
							normal: {
								//柱形图圆角，初始化效果
								barBorderRadius: [4, 4, 0, 0],
							},
						},
					},
					{
						name: "总计",
						type: "line", // 平均值
						data: [sleepAvg],
						// color: "#C394FE",
						itemStyle: {
							opacity: 0,
						},
						lineStyle: {
							opacity: 0,
						},
						markLine: {
							symbol: "none",
							data: [
								{
									type: "average",
									name: "平均数",
									label: {
										normal: {
											show: false,
										},
									},
									lineStyle: {
										//警戒线的样式  ，虚实  颜色
										type: "dashed",
										color: "#63B2FB",
									},
								},
							],
						},
						// markArea: [
						//   [
						//     {
						//       name: '',
						//       xAxis: data.com_xAxis[0],
						//       yAxis: '6',
						//     },
						//     {
						//       xAxis: data.com_xAxis[data.com_xAxis.length - 1],
						//       yAxis: '10',
						//     },
						//   ],
						// ],
						markArea: {
							silent: true,
							data: [
								[
									{
										name: "",
										yAxis: 6,
										itemStyle: {
											color: "#F2FAFF",
										},
									},
									{
										yAxis: 10,
									},
								],
							],
						},
					},
				],
			};

			var optionSleepDuration2 = {
				color: ["#1890FF", "#c394fe", "#f8b4e7", "#f8b5b5"],
				tooltip: {
					confine: true,
					trigger: "axis",
					backgroundColor: "rgba(255, 255, 255, 1)",
					borderColor: "rgba(24, 144, 255, 0.6)",
					borderWidth: 1,
					spanStyle: {
						color: "#fff",
					},
					formatter: function (params) {
						console.log(params);
						for (var x = 0; x < params.length; i++) {
							if (params[x].data.timeFonts2 == "0") {
								return (
									params[x].name +
									"<br/>睡眠时长：-<br/>深睡时长：-<br/>浅睡时长：-"
								);
							} else {
								return (
									params[x].name +
									"<br/>睡眠时长：" +
									params[x].data.timeFonts2 +
									"<br/>深睡时长：" +
									params[0].data.timeFonts +
									"<br/>浅睡时长：" +
									params[1].data.timeFonts
								);
							}
						}
					},
				},
				grid: {
					left: "1%",
					right: "1%",
					top: "15%",
					bottom: "1%",
					containLabel: true,
				},
				xAxis: [
					{
						type: "category",
						data: data.com_xAxis,
						axisLabel: {
							spanStyle: {
								color: "#4D5EA1", //坐标的字体颜色
							},
							// formatter: function (params) {
							//   return params.replace("-", "<br/>");
							// },
						},
						axisLine: {
							lineStyle: {
								color: "#4D5EA1",
							},
						},
						axisTick: {
							show: false,
							alignWithLabel: true,
						},
					},
				],
				yAxis: [
					{
						type: "value",
						min: 0,
						max: 12,
						logBase: 10,
						splitLine: {
							show: false,
						},
						axisLine: {
							lineStyle: {
								color: "#4D5EA1",
							},
							show: false, //显示y轴，新版本默认没显示
						},
						axisLabel: {
							formatter: "{value}h",
							spanStyle: {
								color: "#4D5EA1", //坐标的字体颜色
							},
						},
						splitNumber: 3,
					},
				],
				series: [
					{
						name: "深睡",
						type: "bar",
						stack: "1",
						barWidth: data.activeType == 2 ? "20" : "10",
						// barWidth: comLen.length > 7 ? "" : 20, //柱图宽度
						data: deepSleepList,
					},

					{
						name: "浅睡",
						type: "bar",
						stack: "1",
						barWidth: data.activeType == 2 ? "20" : "10",
						// barWidth: comLen.length > 7 ? "" : 20, //柱图宽度
						data: lightSleepList,
						itemStyle: {
							normal: {
								//柱形图圆角，初始化效果
								barBorderRadius: [4, 4, 0, 0],
							},
						},
					},
					{
						name: "总计",
						type: "line", // 平均值
						data: [sleepAvg],
						// color: "#C394FE",
						itemStyle: {
							opacity: 0,
						},
						lineStyle: {
							opacity: 0,
						},
						markLine: {
							symbol: "none",
							data: [
								{
									type: "average",
									name: "平均数",
									label: {
										normal: {
											show: false,
										},
									},
									lineStyle: {
										//警戒线的样式  ，虚实  颜色
										type: "dashed",
										color: "#63B2FB",
									},
								},
							],
						},
						markArea_data: [
							[
								{
									name: "",
									xAxis: data.com_xAxis[0],
									yAxis: "6",
								},
								{
									xAxis: data.com_xAxis[data.com_xAxis.length - 1],
									yAxis: "10",
								},
							],
						],
					},
				],
			};

			this.myChart6.setOption(optionSleepDuration);
			window.addEventListener("resize", () => {
				this.myChart6.resize();
			});
		},
		//y轴对齐4位方法
		checkY(value) {
			value = value.toString();
			var maxlength = 4;
			var spaceString = "\v\v\v\v";
			//console.log(spaceString.substring(0, maxlength - value.length) + value);
			if (value.length < maxlength) {
				return spaceString.substring(0, maxlength - value.length) + value;
			} else {
				return value;
			}
		},
		// 离床次数图表
		getMyChart7() {
			let timeList = [];
			let valueList1 = [];
			let valueList = [];
			this.outBedSum = 0;
			for (let i = 0; i < this.detailsManyData.outBedNum.length; i++) {
				timeList.push(
					this.detailsManyData.outBedNum[i].statisticsDate.slice(5)
				);
				valueList1.push(
					this.detailsManyData.outBedNum[i].outBedNum
						? this.detailsManyData.outBedNum[i].outBedNum
						: 0
				);
				if (
					this.detailsManyData.outBedNum[i].outBedNum ||
					this.detailsManyData.outBedNum[i].outBedNum == 0
				) {
					if (this.detailsManyData.outBedNum[i].outBedNum == 0) {
						valueList.push(-1);
					} else {
						valueList.push(this.detailsManyData.outBedNum[i].outBedNum);
					}
				} else {
					valueList.push("-");
				}
				this.outBedSum += this.detailsManyData.outBedNum[i].outBedNum
					? this.detailsManyData.outBedNum[i].outBedNum
					: 0;
			}
			if (this.outBedSum == 0) {
				return;
			}
			let maxValue = Math.max(...valueList1);
			for (var i = 0; i < valueList.length; i++) {
				if (valueList[i] == -1) {
					valueList[i] = maxValue / 100 + 0.001;
				}
			}
			setTimeout(() => {
				if (
					this.myChart7 != null &&
					this.myChart7 != "" &&
					this.myChart7 != undefined
				) {
					this.myChart7.dispose();
				}
				this.myChart7 = this.$echarts.init(
					document.getElementById("myCharts7")
				);
				var option7 = {
					color: ["#1890FF"],

					tooltip: {
						trigger: "axis",
						backgroundColor: "rgba(255, 255, 255, 0.9)",
						borderColor: "rgba(24, 144, 255, 0.8)",
						// borderWidth: 1,
						borderRadius: 5,
						formatter: function (params) {
							return (
								params[0].name +
								"</br>" +
								"离床" +
								(params[0].data == maxValue / 100 + 0.001
									? 0
									: params[0].data) +
								"次"
							);
						},
					},
					grid: {
						left: "1%",
						right: "1%",
						top: "8%",
						bottom: "0%",
						containLabel: true,
					},
					xAxis: [
						{
							type: "category",
							data: timeList,
							axisLabel: {
								spanStyle: {
									color: "rgba(0,0,0,0.35)", //坐标的字体颜色
								},
							},
							axisLine: {
								lineStyle: {
									color: "rgba(0,0,0,0.15)",
								},
							},
							axisTick: {
								alignWithLabel: true,
							},
						},
					],
					yAxis: [
						{
							type: "value",
							splitLine: {
								show: false,
							},
							minInterval: 1, //设置最小间隔为1，防止出现小数
							axisLabel: {
								spanStyle: {
									color: "rgba(0,0,0,0.35)", //坐标的字体颜色
								},
								formatter: function (value) {
									if (value == 0) return value;
									else if (value == 1) return value + "次";
									else return value + "次";
								},
							},
							axisLine: {
								lineStyle: {
									color: "rgba(0,0,0,0.15)",
								},
								show: true,
							},
						},
					],
					series: [
						{
							name: "离床",
							type: "bar",
							barWidth: valueList.length > 7 ? "20" : "30",
							barCategoryGap: 1,
							itemStyle: {
								normal: {
									//柱形图圆角，初始化效果
									barBorderRadius: [4, 4, 0, 0],
									color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
										{
											offset: 0,
											color: "rgba(77, 142, 247, 1)",
										},
										{
											offset: 1,
											color: "rgba(195, 148, 254, 1)",
										},
									]),
								},
							},
							data: valueList,
						},
					],
				};
				this.myChart7.setOption(option7);
				window.addEventListener("resize", () => {
					this.myChart7.resize();
				});
			}, 0);
		},
		// 离床时长图表
		getMyChart8() {
			let timeList = [];
			let valueList = [];
			this.outBedTimeSum = 0;
			for (let i = 0; i < this.detailsManyData.outBedDuration.length; i++) {
				timeList.push(
					this.detailsManyData.outBedDuration[i].statisticsDate.slice(5)
				);
				valueList.push({
					value:
						this.detailsManyData.outBedDuration[i].outBedMinute == 0
							? 0.5
							: this.detailsManyData.outBedDuration[i].outBedMinute
								? this.detailsManyData.outBedDuration[i].outBedMinute
								: 0,
					time: this.detailsManyData.outBedDuration[i].outBedDuration
						? this.detailsManyData.outBedDuration[i].outBedDuration
						: "-",
				});
				this.outBedTimeSum += this.detailsManyData.outBedDuration[i]
					.outBedMinute
					? this.detailsManyData.outBedDuration[i].outBedMinute
					: 0;
			}
			if (this.outBedTimeSum == 0) {
				return;
			}
			setTimeout(() => {
				if (
					this.myChart8 != null &&
					this.myChart8 != "" &&
					this.myChart8 != undefined
				) {
					this.myChart8.dispose();
				}
				this.myChart8 = this.$echarts.init(
					document.getElementById("myCharts8")
				);
				var option8 = {
					color: ["#1890FF"],
					// dataZoom: dataZooms,
					tooltip: {
						trigger: "axis",
						backgroundColor: "rgba(255, 255, 255, 0.9)",
						borderColor: "rgba(24, 144, 255, 0.8)",
						// borderWidth: 1,
						borderRadius: 5,
						formatter: function (params) {
							return (
								params[0].name + "</br>" + "离床时长：" + params[0].data.time
							);
						},
					},
					grid: {
						left: "1%",
						right: "1%",
						top: "8%",
						bottom: "0%",
						containLabel: true,
					},
					xAxis: [
						{
							type: "category",
							data: timeList,
							axisLine: {
								lineStyle: {
									color: "rgba(0,0,0,0.15)",
								},
							},
							axisLabel: {
								spanStyle: {
									color: "rgba(0,0,0,0.35)", //坐标的字体颜色
								},
							},
							axisTick: {
								alignWithLabel: true,
							},
						},
					],
					yAxis: [
						{
							type: "value",
							splitLine: {
								show: false,
							},
							axisLabel: {
								formatter: function (value) {
									if (value == 0) return value;
									else if (value == 1) return value + "m";
									else return value + "m";
								},
								margin: 5,
								spanStyle: {
									color: "rgba(0,0,0,0.35)", //坐标的字体颜色
								},
								// formatter: "{value}",
								show: true,
							},
							axisLine: {
								lineStyle: {
									color: "rgba(0,0,0,0.15)",
								},
								show: true,
							},
						},
					],
					series: [
						{
							name: "离床",
							type: "bar",
							barWidth: valueList.length > 7 ? "20" : "30",
							barCategoryGap: 1,
							itemStyle: {
								normal: {
									//柱形图圆角，初始化效果
									barBorderRadius: [4, 4, 0, 0],
									color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
										{
											offset: 0,
											color: "rgba(77, 142, 247, 1)",
										},
										{
											offset: 1,
											color: "rgba(195, 148, 254, 1)",
										},
									]),
								},
							},
							// barMinHeight: 1,
							data: valueList,
						},
					],
				};
				this.myChart8.setOption(option8);
				window.addEventListener("resize", () => {
					this.myChart8.resize();
				});
			}, 0);
		},
		// 体动次数图表
		getMyChart9() {
			let timeList = [];
			let valueList = [];
			this.turnSum = 0;
			for (let i = 0; i < this.detailsManyData.turnOverMoreNums.length; i++) {
				timeList.push(
					this.detailsManyData.turnOverMoreNums[i].statisticsDate.slice(5)
				);
				valueList.push({
					value:
						this.detailsManyData.turnOverMoreNums[i].turnOverNum == 0
							? 1
							: this.detailsManyData.turnOverMoreNums[i].turnOverNum
								? this.detailsManyData.turnOverMoreNums[i].turnOverNum
								: -1,
					num:
						this.detailsManyData.turnOverMoreNums[i].turnOverNum == 0
							? 0
							: this.detailsManyData.turnOverMoreNums[i].turnOverNum
								? this.detailsManyData.turnOverMoreNums[i].turnOverNum
								: "-",
				});
				this.turnSum += this.detailsManyData.turnOverMoreNums[i].turnOverNum
					? this.detailsManyData.turnOverMoreNums[i].turnOverNum
					: 0;
			}
			if (this.turnSum == 0) {
				return;
			}
			setTimeout(() => {
				if (
					this.myChart9 != null &&
					this.myChart9 != "" &&
					this.myChart9 != undefined
				) {
					this.myChart9.dispose();
				}
				this.myChart9 = this.$echarts.init(
					document.getElementById("myCharts9")
				);
				var option9 = {
					color: ["#1890FF"],
					// dataZoom: dataZooms,
					tooltip: {
						trigger: "axis",
						backgroundColor: "rgba(255, 255, 255, 0.9)",
						borderColor: "rgba(24, 144, 255, 0.8)",
						// borderWidth: 1,
						borderRadius: 5,
						formatter: function (params) {
							if (params[0].data == -1)
								return params[0].name + "</br>" + "体动-次";
							return (
								params[0].name + "</br>" + "体动" + params[0].data.num + "次"
							);
						},
					},
					grid: {
						left: "1%",
						right: "1%",
						top: "8%",
						bottom: "0%",
						containLabel: true,
					},
					xAxis: [
						{
							type: "category",
							data: timeList,
							axisLine: {
								lineStyle: {
									color: "rgba(0,0,0,0.15)",
								},
							},
							axisLabel: {
								spanStyle: {
									color: "rgba(0,0,0,0.35)", //坐标的字体颜色
								},
							},
							axisTick: {
								alignWithLabel: true,
							},
						},
					],
					yAxis: [
						{
							min: 0,
							type: "value",
							splitLine: {
								show: false,
							},
							minInterval: 1, //设置最小间隔为1，防止出现小数
							axisLine: {
								lineStyle: {
									color: "rgba(0,0,0,0.15)",
								},
								show: true,
							},
							axisLabel: {
								spanStyle: {
									color: "rgba(0,0,0,0.35)", //坐标的字体颜色
								},
							},
						},
					],
					series: [
						{
							name: "离床",
							type: "bar",
							barWidth: valueList.length > 7 ? "20" : "30",
							barCategoryGap: 1,
							itemStyle: {
								normal: {
									//柱形图圆角，初始化效果
									barBorderRadius: [4, 4, 0, 0],
									color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
										{
											offset: 0,
											color: "rgba(77, 142, 247, 1)",
										},
										{
											offset: 1,
											color: "rgba(195, 148, 254, 1)",
										},
									]),
								},
							},
							data: valueList,
						},
					],
				};
				this.myChart9.setOption(option9);
				window.addEventListener("resize", () => {
					this.myChart9.resize();
				});
			}, 0);
		},
		// 睡眠规律图表
		getMyChart10() {
			if (
				this.myChart10 != null &&
				this.myChart10 != "" &&
				this.myChart10 != undefined
			) {
				this.myChart10.dispose();
			}
			this.myChart10 = this.$echarts.init(
				document.getElementById("myCharts10")
			);
			let timeList = [];
			let activeLen = this.activeType == 3 ? 7 : 30;
			for (let i = 0; i < activeLen; i++) {
				timeList.push(this.activeDates[activeLen - 1 - i].slice(5));
			}
			var getBed = [];
			var sleepStart = [];
			var sleepEnd = [];
			var leaveBed = [];
			var edates = [];
			var edatas = [];
			for (var i = 0; i < this.detailsManyData3.sleepRule.length; i++) {
				if (this.detailsManyData3.sleepRule[i].get_bed_idx) {
					if (this.detailsManyData3.sleepRule[i].get_bed_idx == "12:00")
						this.detailsManyData3.sleepRule[i].get_bed_idx = "20:00";
					if (this.detailsManyData3.sleepRule[i].sleep_st_idx == "12:00")
						this.detailsManyData3.sleepRule[i].sleep_st_idx = "20:00";
					if (this.detailsManyData3.sleepRule[i].sleep_ed_idx == "13:00")
						this.detailsManyData3.sleepRule[i].sleep_ed_idx = "08:00";
					if (this.detailsManyData3.sleepRule[i].leave_bed_idx == "13:00")
						this.detailsManyData3.sleepRule[i].leave_bed_idx = "08:00";
					edates.push(this.detailsManyData3.sleepRule[i].statistics_date);
					edatas.push(this.detailsManyData3.sleepRule[i]);
				}
			}
			for (var i = activeLen - 1; i >= 0; i--) {
				if (edates.indexOf(this.activeDates[i]) != -1) {
					getBed.push(
						this.minutes.indexOf(
							edatas[edates.indexOf(this.activeDates[i])].get_bed_idx.slice(
								0,
								2
							) +
							":" +
							edatas[edates.indexOf(this.activeDates[i])].get_bed_idx.slice(
								3,
								5
							)
						) != -1
							? this.minutes.indexOf(
								edatas[edates.indexOf(this.activeDates[i])].get_bed_idx.slice(
									0,
									2
								) +
								":" +
								edatas[
									edates.indexOf(this.activeDates[i])
								].get_bed_idx.slice(3, 5)
							)
							: 0
					);
					sleepStart.push(
						this.minutes.indexOf(
							edatas[edates.indexOf(this.activeDates[i])].sleep_st_idx.slice(
								0,
								2
							) +
							":" +
							edatas[edates.indexOf(this.activeDates[i])].sleep_st_idx.slice(
								3,
								5
							)
						) != -1
							? this.minutes.indexOf(
								edatas[
									edates.indexOf(this.activeDates[i])
								].sleep_st_idx.slice(0, 2) +
								":" +
								edatas[
									edates.indexOf(this.activeDates[i])
								].sleep_st_idx.slice(3, 5)
							)
							: 0
					);
					sleepEnd.push(
						this.minutes.indexOf(
							edatas[edates.indexOf(this.activeDates[i])].sleep_ed_idx.slice(
								0,
								2
							) +
							":" +
							edatas[edates.indexOf(this.activeDates[i])].sleep_ed_idx.slice(
								3,
								5
							)
						)
					);
					leaveBed.push(
						this.minutes.indexOf(
							edatas[edates.indexOf(this.activeDates[i])].leave_bed_idx.slice(
								0,
								2
							) +
							":" +
							edatas[edates.indexOf(this.activeDates[i])].leave_bed_idx.slice(
								3,
								5
							)
						)
					);
				} else {
					getBed.push(0);
					sleepStart.push(0);
					sleepEnd.push(0);
					leaveBed.push(0);
				}
			}
			var sleepEndChart = [];
			var leaveBedChart = [];
			for (var i = 0; i < activeLen; i++) {
				sleepEndChart.push(sleepEnd[i] - sleepStart[i]);
				leaveBedChart.push(leaveBed[i] - getBed[i]);
			}
			var that = this;
			var option10 = {
				color: "#1890ff",
				tooltip: {
					trigger: "axis",
					backgroundColor: "rgba(255, 255, 255, 0.9)",
					borderColor: "rgba(24, 144, 255, 0.8)",
					// borderWidth: 1,
					borderRadius: 5,
					formatter: function (params) {
						// console.log(params);
						if (params[3].value == 0) {
							return (
								params[0].axisValueLabel +
								"<br>上床时间：-" +
								"<br>入睡时间：-" +
								"<br>醒来时间：-" +
								"<br>起床时间：-"
							);
						}
						return (
							params[0].axisValueLabel +
							"<br>上床时间：" +
							that.minutes[params[2].value] +
							"<br>入睡时间：" +
							that.minutes[params[0].value] +
							"<br>醒来时间：" +
							that.minutes[params[1].value + params[0].value] +
							"<br>起床时间：" +
							that.minutes[params[3].value + params[2].value]
						);
					},
				},
				grid: {
					left: "1%",
					right: "1%",
					top: "8%",
					bottom: "0%",
					containLabel: true,
				},
				xAxis: [
					{
						type: "category",
						data: timeList,
						axisLine: {
							lineStyle: {
								color: "rgba(0,0,0,0.15)",
							},
						},
						axisLabel: {
							spanStyle: {
								color: "rgba(0,0,0,0.35)", //坐标的字体颜色
							},
						},
						axisTick: {
							alignWithLabel: true,
						},
						show: true,
					},
				],
				yAxis: [
					{
						max: 720,
						min: 0,
						minInterval: 240,
						type: "value",
						splitLine: {
							show: false,
						},
						axisLine: {
							lineStyle: {
								color: "rgba(0,0,0,0.15)",
							},
							show: true,
						},
						axisLabel: {
							formatter: function (value) {
								// if(value === 0) return "0AM"
								// if(value === 240) return "4AM"
								// if(value === 480) return "8AM"
								// if(value === 720) return "8PM"
								let timeArr = that.minutes[value].split(":");
								// timeArr.forEach(item => {
								//   +item
								// })
								console.log();
								return +timeArr[0] > 12
									? +timeArr[0] - 12 + "PM"
									: +timeArr[0] + "AM";
							},
							spanStyle: {
								color: "rgba(0,0,0,0.35)", //坐标的字体颜色
							},
						},
					},
				],
				series: [
					{
						stack: "float",
						type: "bar",
						barWidth: 10,
						barGap: "-100%",
						itemStyle: {
							normal: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
							emphasis: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
						},
						data: sleepStart,
					},
					{
						z: 5,
						stack: "float",
						type: "bar",
						barGap: "-100%",
						barWidth: 10,
						itemStyle: {
							normal: {
								barBorderRadius: [15, 15, 15, 15],
								barBorderColor: "rgba(0,0,0,0)",
								color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
									{
										offset: 0,
										color: "rgba(77, 142, 247, 1)",
									},
									{
										offset: 1,
										color: "rgba(195, 148, 254, 1)",
									},
								]),
							},
						},
						data: sleepEndChart,
					},
					{
						stack: "float1",
						type: "bar",
						barGap: "-100%",
						barWidth: 10,
						itemStyle: {
							normal: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
							emphasis: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
						},
						data: getBed,
					},
					{
						z: 2,
						stack: "float1",
						type: "bar",
						barGap: "-100%",
						barWidth: 10,
						itemStyle: {
							normal: {
								barBorderRadius: [15, 15, 15, 15],
								barBorderColor: "rgba(0,0,0,0)",
								color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
									{
										offset: 0,
										color: "rgba(77, 142, 247, 0.5)",
									},
									{
										offset: 1,
										color: "rgba(195, 148, 254, 0.5)",
									},
								]),
							},
						},
						data: leaveBedChart,
					},
				],
			};
			this.myChart10.setOption(option10);
			window.addEventListener("resize", () => {
				this.myChart10.resize();
			});
		},
		// 多日呼吸率图表
		getMyChart11() {
			if (
				this.myChart11 != null &&
				this.myChart11 != "" &&
				this.myChart11 != undefined
			) {
				this.myChart11.dispose();
			}
			this.myChart11 = this.$echarts.init(
				document.getElementById("myCharts11")
			);
			let timeList = [];
			let activeLen = this.activeType == 3 ? 7 : 30;
			for (let i = 0; i < activeLen; i++) {
				timeList.push(this.activeDates[activeLen - 1 - i].slice(5));
			}
			var maxDatas = [];
			var avgDatas = [];
			var minDatas = [];
			var maxChartDatas = [];
			var edates = [];
			var edatas = [];
			for (var i = 0; i < this.detailsManyData2.breathData.length; i++) {
				edates.push(this.detailsManyData2.breathData[i].date);
				edatas.push(this.detailsManyData2.breathData[i]);
			}
			for (var i = activeLen - 1; i >= 0; i--) {
				if (edates.indexOf(this.activeDates[i]) != -1) {
					maxDatas.push(edatas[edates.indexOf(this.activeDates[i])].max);
					avgDatas.push(edatas[edates.indexOf(this.activeDates[i])].avg);
					minDatas.push(edatas[edates.indexOf(this.activeDates[i])].min);
					maxChartDatas.push(
						edatas[edates.indexOf(this.activeDates[i])].max -
						edatas[edates.indexOf(this.activeDates[i])].min
					);
				} else {
					maxDatas.push(0);
					avgDatas.push(0);
					minDatas.push(0);
					maxChartDatas.push(0);
				}
			}

			var option11 = {
				color: "#1890ff",
				tooltip: {
					trigger: "axis",
					backgroundColor: "rgba(255, 255, 255, 0.9)",
					borderColor: "rgba(24, 144, 255, 0.8)",
					// borderWidth: 1,
					borderRadius: 5,
					formatter: function (params) {
						// console.log(params);
						if (params[2].value == 0) {
							return (
								params[0].axisValueLabel +
								"<br>最高：-" +
								"<br>最低：-" +
								"<br>平均：-"
							);
						}
						return (
							params[0].axisValueLabel +
							"<br>最高：" +
							(
								parseInt(params[0].value) + parseInt(params[1].value)
							).toString() +
							"<br>最低：" +
							params[0].value +
							"<br>平均：" +
							params[2].value
						);
					},
				},
				grid: {
					left: "1%",
					right: "1%",
					top: "8%",
					bottom: "0%",
					containLabel: true,
				},
				xAxis: [
					{
						type: "category",
						data: timeList,
						axisLine: {
							lineStyle: {
								color: "rgba(0,0,0,0.15)",
							},
						},
						axisLabel: {
							spanStyle: {
								color: "rgba(0,0,0,0.35)", //坐标的字体颜色
							},
						},
						axisTick: {
							alignWithLabel: true,
						},
						show: true,
					},
				],
				yAxis: [
					{
						min: 0,
						type: "value",
						splitLine: {
							show: false,
						},
						axisLine: {
							lineStyle: {
								color: "rgba(0,0,0,0.15)",
							},
							show: true,
						},
						axisLabel: {
							margin: 10,
							spanStyle: {
								color: "rgba(0,0,0,0.35)", //坐标的字体颜色
							},
						},
					},
				],
				series: [
					{
						stack: "float",
						type: "bar",
						barWidth: 10,
						barGap: "-100%",
						itemStyle: {
							normal: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
							emphasis: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
						},
						data: minDatas,
					},
					{
						z: 5,
						stack: "float",
						type: "bar",
						barWidth: 10,
						barGap: "-100%",
						itemStyle: {
							normal: {
								barBorderRadius: [15, 15, 15, 15],
								barBorderColor: "rgba(0,0,0,0)",
								color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
									{
										offset: 0,
										color: "rgba(77, 142, 247, 1)",
									},
									{
										offset: 1,
										color: "rgba(195, 148, 254, 1)",
									},
								]),
							},
						},
						data: maxChartDatas,
					},
					{
						z: 0,
						type: "bar",
						barWidth: 10,
						barGap: "-100%",
						itemStyle: {
							normal: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
							emphasis: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
						},
						data: avgDatas,
					},
				],
			};
			this.myChart11.setOption(option11);
			window.addEventListener("resize", () => {
				this.myChart11.resize();
			});
		},
		// 多日心率图表
		getMyChart12() {
			if (
				this.myChart12 != null &&
				this.myChart12 != "" &&
				this.myChart12 != undefined
			) {
				this.myChart12.dispose();
			}
			this.myChart12 = this.$echarts.init(
				document.getElementById("myCharts12")
			);
			let timeList = [];
			let activeLen = this.activeType == 3 ? 7 : 30;
			for (let i = 0; i < activeLen; i++) {
				timeList.push(this.activeDates[activeLen - 1 - i].slice(5));
			}
			var maxDatas = [];
			var avgDatas = [];
			var minDatas = [];
			var maxChartDatas = [];
			var edates = [];
			var edatas = [];
			for (var i = 0; i < this.detailsManyData3.heartData.length; i++) {
				edates.push(this.detailsManyData3.heartData[i].date);
				edatas.push(this.detailsManyData3.heartData[i]);
			}
			for (var i = activeLen - 1; i >= 0; i--) {
				if (edates.indexOf(this.activeDates[i]) != -1) {
					maxDatas.push(edatas[edates.indexOf(this.activeDates[i])].max);
					avgDatas.push(edatas[edates.indexOf(this.activeDates[i])].avg);
					minDatas.push(edatas[edates.indexOf(this.activeDates[i])].min);
					maxChartDatas.push(
						edatas[edates.indexOf(this.activeDates[i])].max -
						edatas[edates.indexOf(this.activeDates[i])].min
					);
				} else {
					maxDatas.push(0);
					avgDatas.push(0);
					minDatas.push(0);
					maxChartDatas.push(0);
				}
			}
			var option12 = {
				color: "#1890ff",
				tooltip: {
					trigger: "axis",
					backgroundColor: "rgba(255, 255, 255, 0.9)",
					borderColor: "rgba(24, 144, 255, 0.8)",
					// borderWidth: 1,
					borderRadius: 5,
					formatter: function (params) {
						// console.log(params);
						if (params[2].value == 0) {
							return (
								params[0].axisValueLabel +
								"<br>最高：-" +
								"<br>最低：-" +
								"<br>平均：-"
							);
						}
						return (
							params[0].axisValueLabel +
							"<br>最高：" +
							(
								parseInt(params[0].value) + parseInt(params[1].value)
							).toString() +
							"<br>最低：" +
							params[0].value +
							"<br>平均：" +
							params[2].value
						);
					},
				},
				grid: {
					left: "1%",
					right: "1%",
					top: "8%",
					bottom: "0%",
					containLabel: true,
				},
				xAxis: [
					{
						type: "category",
						data: timeList,
						axisLine: {
							lineStyle: {
								color: "rgba(0,0,0,0.15)",
							},
						},
						axisLabel: {
							spanStyle: {
								color: "rgba(0,0,0,0.35)", //坐标的字体颜色
							},
						},
						axisTick: {
							alignWithLabel: true,
						},
						show: true,
					},
				],
				yAxis: [
					{
						min: 0,
						type: "value",
						splitLine: {
							show: false,
						},
						axisLine: {
							lineStyle: {
								color: "rgba(0,0,0,0.15)",
							},
							show: true,
						},
						axisLabel: {
							spanStyle: {
								color: "rgba(0,0,0,0.35)", //坐标的字体颜色
							},
						},
					},
				],
				series: [
					{
						stack: "float",
						type: "bar",
						barWidth: 10,
						barGap: "-100%",
						itemStyle: {
							normal: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
							emphasis: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
						},
						data: minDatas,
					},
					{
						z: 5,
						stack: "float",
						type: "bar",
						barWidth: 10,
						barGap: "-100%",
						itemStyle: {
							normal: {
								barBorderRadius: [15, 15, 15, 15],
								barBorderColor: "rgba(0,0,0,0)",
								color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
									{
										offset: 0,
										color: "rgba(77, 142, 247, 1)",
									},
									{
										offset: 1,
										color: "rgba(195, 148, 254, 1)",
									},
								]),
							},
						},
						data: maxChartDatas,
					},
					{
						z: 0,
						type: "bar",
						barWidth: 10,
						barGap: "-100%",
						itemStyle: {
							normal: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
							emphasis: {
								barBorderColor: "rgba(0,0,0,0)",
								color: "rgba(0,0,0,0)",
							},
						},
						data: avgDatas,
					},
				],
			};
			this.myChart12.setOption(option12);
			window.addEventListener("resize", () => {
				this.myChart12.resize();
			});
		},
		// 查看关闭
		detailsOff() {
			this.detailsPopup = false;
			this.hasFallPicData = false;
			this.clearCharts();
		},
		// 二维码气泡
		QRCodeBtn(num, scope) {
			//console.log(scope);
			if (scope.popoverVisible) {
				return;
			}
			let param = {
				baseUrl: "1",
				bedId: scope.bedId,
				type: this.activeType, // 1-昨天 2-前天 3-7天 4-30天
				date: this.activeDate,
			};
			this.loading1 = false;
			if (this.activeType == 1) {
				this.$get("/api/health/shareV1", param, (res) => {
					if (res.code == 0) {
						this.shareUrl = res.msg;
					}
				});
			} else {
				this.$get("/api/health/share", param, (res) => {
					if (res.code == 0) {
						this.shareUrl = res.msg;
					}
				});
			}
			this.$nextTick(function () {
				this.bindQRCode1();
			});
		},
		// 分享
		shareBtn() {
			if (this.popoverVisible) {
				return;
			}

			let baseUrl = this.$store.state.baseUrl;
			let activeType = 1; //1日 2周 3月 4三月或六月
			if (this.activeType == 1) {
				activeType = 1;
			} else if (this.activeType == 3) {
				activeType = 2;
			} else if (this.activeType == 4) {
				activeType = 3;
			}
			let allParam =
				"?bedId=" +
				this.typeId +
				"&activeType=" +
				activeType +
				"&date=" +
				this.activeDate;
			this.shareUrl = baseUrl + "/h5/#/index" + allParam;
			console.log(this.shareUrl);
			this.$nextTick(function () {
				this.bindQRCode2();
			});
		},
		formaTime(minutes) {
			return Math.floor(minutes / 60) + "小时" + (minutes % 60) + "分钟";
		},
		// 生成二维码
		bindQRCode1: function () {
			setTimeout((e) => {
				new QRCode(this.$refs.qrCodeDiv, {
					span: this.shareUrl,
					width: 100,
					height: 100,
					colorDark: "#333333", //二维码颜色
					colorLight: "#ffffff", //二维码背景色
					correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
				});
				this.loading1 = true;
			}, 1000);
		},
		bindQRCode2: function () {
			setTimeout((e) => {
				new QRCode(this.$refs.qrCodeDetails, {
					text: this.shareUrl,
					width: 100,
					height: 100,
					colorDark: "#333333", //二维码颜色
					colorLight: "#ffffff", //二维码背景色
					correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
				});
				this.loading = false;
			}, 1000);

			setTimeout(() => {
				//判断二维码的距离实际顶部的距离
				var shareP = document.getElementsByClassName("ant-popover")[0];
				//console.log(shareP)
				this.popoverTop =
					parseInt(shareP.style.top.replace("px", "")) + this.scrollTop;
			}, 0);
		},

		getChartScore(nowScore) {
			console.log(nowScore);
			if (this.myChartScore) {
				this.myChartScore.dispose();
			}
			this.myChartScore = this.$echarts.init(
				document.getElementById("myChartsScore"),
				null,
				{ devicePixelRatio: 2.5 }
			);
			var optionScore = {
				title: {
					bottom: "10%",
					left: "center",
				},
				grid: {
					// 让图表占满容器
					top: "0px",
					left: "0px",
					right: "0px",
					bottom: "0px",
				},
				series: [
					// 是否正常
					{
						type: "gauge",
						radius: "100%",
						pointer: {
							show: false,
						},
						axisLine: {
							show: false,
						},
						axisTick: {
							show: false,
						},
						splitLine: {
							show: false,
						},
						axisLabel: {
							show: false,
						},
						detail: {
							fontSize: 12,
							color: "#5A5A89",
							offsetCenter: ["0", "5%"],
							formatter: (value) => {
								// return value;
							},
						},
						data: [
							{
								value: 100,
							},
						],
					},
					// 主图
					{
						type: "gauge",
						radius: "100%",
						startAngle: 200,
						endAngle: -20,
						min: 0,
						max: 100,
						splitNumber: 12,
						itemStyle: {
							normal: {
								color:
									this.scoreLabel == "一般"
										? new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
											{
												offset: 0,
												color: "#FF7188",
											},
											{
												offset: 1,
												color: "#FF7FB6",
											},
										])
										: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
											{
												offset: 0,
												color: "#35C3FF",
											},
											{
												offset: 0.5,
												color: "#1890FF",
											},
										]),
							},
						},
						progress: {
							show: true,
							roundCap: true,
							width: 10,
						},
						pointer: {
							show: false,
						},
						axisLine: {
							roundCap: true,
							lineStyle: {
								width: 10,
							},
						},
						axisTick: {
							show: false,
						},
						splitLine: {
							show: false,
						},
						axisLabel: {
							show: false,
						},
						title: {
							show: false,
						},
						detail: {
							fontSize: 32,
							fontFamily: "DINAlternate-Bold",
							fontWeight: 900,
							color: this.scoreLabel == "一般" ? "#FF7186" : "#1890FF",
							offsetCenter: ["0%", "-24%"],
							formatter: (value) => {
								return `${value}`;
							},
						},
						data: [
							{
								value: nowScore,
							},
						],
					},
					// 总回款比例
					{
						type: "gauge",
						radius: "100%",
						pointer: {
							show: false,
						},
						axisLine: {
							show: false,
						},
						axisTick: {
							show: false,
						},
						splitLine: {
							show: false,
						},
						axisLabel: {
							show: false,
						},
						detail: {
							fontSize: 14,
							color: "#5A5A89",
							offsetCenter: ["0", "70%"],
							formatter: () => {
								return "";
							},
						},
						data: [
							{
								value: 45.5,
							},
						],
					},
				],
			};
			this.myChartScore.clear();
			this.myChartScore.setOption(optionScore);
			window.addEventListener("resize", () => {
				this.myChartScore.resize();
			});
			//模拟得分仪表盘
		},
		clickAiReport() {
			let model = JSON.parse(JSON.stringify(this.currentScopeModel));
			model.paramDate = this.activeDate;
			this.$store.commit("changeAiSingleReportData", model);
		}
	},
};
</script>
<style lang="scss" scoped>
.nodata-report {
	background: #f7f2ff;
	box-shadow: 0px 4px 6px 0px rgba(217, 198, 255, 0.3);
	border-radius: 24px;
	border: 2px solid #d9c6ff;
	margin: 16px;

	padding: 20px;
	position: relative;
}

.nodata-text1 {
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #5e6779;
}

.nodata-text1::before {
	content: "";
	display: inline-block;
	width: 6px;
	height: 6px;
	background: #d9c6ff;
	border-radius: 50%;
}

.nodata-text2-item {
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #5e6779;
}

.nodata-text1-mr::before {
	content: "";
	display: inline-block;
	width: 6px;
	height: 6px;
	background: #d9c6ff;
	border-radius: 50%;
	margin-right: 5px;
}

.nodata-text2-phone {
	color: #a42eff;
}

.nodata-img-box {
	display: flex;
	align-items: center;
	justify-content: center;
}

.nodata-img1 {
	width: 555px;
	height: 210px;
	margin: 5px 0;
}

.nodata-img2 {
	width: 303px;
	height: 280px;
	margin-bottom: 5px;
}

.nodata-line {
	width: 6px;
	height: 28px;
	background: linear-gradient(180deg, #f3edff 0%, #ffffff 100%);
	box-shadow: 0px 0px 2px 0px rgba(217, 198, 255, 0.5);
	border-radius: 3px;
	position: absolute;
	top: -24px;
	left: 50px;
}

.nodata-line2 {
	width: 6px;
	height: 28px;
	background: linear-gradient(180deg, #f3edff 0%, #ffffff 100%);
	box-shadow: 0px 0px 2px 0px rgba(217, 198, 255, 0.5);
	border-radius: 3px;
	position: absolute;
	top: -24px;
	right: 50px;
}

.tips-img {
	position: relative;
	margin-bottom: 10px;
}

.tips-img-1 {
	position: relative;
	width: 30px;
	height: 26px;
	z-index: 1;
}

.tips-img-2 {
	position: relative;
	width: 77px;
	height: 30px;
	left: -15px;
	top: 10px;
	z-index: 2;
}
</style>
<style lang="scss">
.ant-modal-content {
	background: #000;
}

.mb {
	margin-bottom: 15px;
}

.mt {
	margin-top: 15px;
}

.opinion {
	margin-bottom: 15px;
	background-color: rgb(240, 240, 240);
	padding: 15px;
	border-radius: 4px;
}

.moreDay-none {
	text-align: center;
	color: #8c8c8c;
	margin-top: 20px;
}

.sleep-begin {
	margin-left: 0px;
	width: 10px;
	height: 10px;
	background: #4d8ef7;
	border-radius: 50%;
	display: inline-block;
}

.sleep-begin1 {
	background: #4d8ef7;
}

.sleep-begin2 {
	background: #c394fe;
}

.sleep-begin3 {
	background: #f8b4e7;
}

.sleep-begin4 {
	background: #ffb5b5;
}

.sleep-div {
	width: 100%;
	height: 25px;
	margin-top: 12px;
	display: flex;
	align-items: center;

	.sleep1 {
		width: 0%;
		height: 25px;
		background: #4d8ef7;
		float: left;
	}

	.sleep2 {
		width: 0%;
		height: 25px;
		background: #c394fe;
		float: left;
	}

	.sleep3 {
		width: 0%;
		height: 25px;
		background: #f8b4e7;
		float: left;
	}

	.sleep4 {
		width: 0%;
		height: 25px;
		background: #ffb5b5;
		float: left;
	}

	.sleep-item {
		display: inline-block;
	}

	.sleep-item-slipe {
		width: 2px;
		height: 15px;
		background: #1f2635;
		opacity: 0.1;
		margin: 0 12px;
	}

	.sleep-title {
		height: 20px;
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #8c8c8c;
		display: inline-block;
		margin-left: 4px;
	}

	.sleep-title-bg {
		color: #fff;
		background: #4d8ef7;
		padding: 0 6px;
		height: 19px;
		line-height: 19px;
		border-radius: 10px 10px 10px 2px;
	}
}

.sleep-title-bg {
	display: inline-block;
	color: #fff;
	background: #4d8ef7;
	padding: 0 6px;
	height: 19px;
	line-height: 19px;
	border-radius: 10px 10px 10px 2px;
}

.ant-modal-body {
	padding: 24px 24px 14px 24px;
	background: linear-gradient(180deg, #f3f4f7 0%, #ffffff 100%);
}

.result-title {
	font-size: 14px;
	text-align: center;
	// margin-left: 10px;
}

.question-icon {
	width: 18px;
	font-size: 16px;
	display: inline-block;
	height: 18px;
	background-color: #1890ff;
	color: white;
	line-height: 18px;
	border-radius: 9px;
	position: relative;
	top: 1px;
	left: 5px;
}

.result-span {
	display: inline-block;
	width: 100%;
	text-align: left;
}

.red-span {
	color: #ff5757 !important;
	text-align: center;
}

.great-content {
	width: 100%;
	height: auto;
	display: flex;
	padding: 14px 0;
	flex-direction: row;
	align-items: flex-end;
	justify-content: center;

	img {
		width: 20px;
	}

	div {
		margin-left: 10px;
	}
}

.healthy-main {
	background: #FFFFFF;
	display: flex;
	justify-content: center;

	.ant-card {
		padding: 15px 20px;
		border-radius: 8px;

		.ant-card-body {
			padding: 0;
		}
	}

	.ant-table-thead>tr>th {
		background: #f0f0f0;
	}

	.ant-table-row:nth-child(even) {
		background: #fafafa;
	}

	.topList {
		display: flex;
		justify-content: space-between;
		margin-bottom: 16px;

		.topleft {
			display: flex;

			.group {
				display: flex;
				margin-right: 20px;

				.title {
					font-size: 14px;
					color: #262626;
					line-height: 32px;
					margin-right: 10px;
				}
			}
		}
	}

	.operation {
		display: flex;
		align-items: center;
		justify-content: center;

		.tableBtn {
			cursor: pointer;
			color: #1890ff;
			margin-right: 10px;
		}

		.share {
			margin-right: 10px;

			.imgIcon {
				cursor: pointer;
				width: 16px;
				height: 16px;
			}
		}
	}
}

.begin-end {
	padding: 3px 10px 3px 0px;
	white-space: nowrap;
	background: rgba(24, 144, 255, 0.2);
	border-radius: 10px 10px 10px 1px;
	position: absolute;
	z-index: 1;
	top: 6px;
	//left: 0px;
	margin-top: -6px;
	margin-bottom: 13px;
	font-size: 12px;
	display: inline-block;

	img {
		width: 14px !important;
		margin-left: 10px;
		position: relative;
		top: 0px;
	}

	.sleep-end {
		margin-left: 12px;
	}
}

.report :global(.ant-descriptions-item-label) {
	background: white;
}

.topright {
	display: flex;
	justify-content: space-between;

	.saiBtn {
		display: flex;
	}

	.hoverBtns {
		background: #f3f4f7 !important;
	}

	.hoverBtns:hover {
		background: #ffffff !important;
		color: #1890ff !important;
		border: 1px solid #1890ff !important;
	}

	.actives {
		background: #e6f7ff !important;
		color: #1890ff !important;
		border: 1px solid #1890ff !important;
	}

	.on {
		transition: color 0.3s, background 0.3s, border-color 0.3s;
		border-radius: 2px;
		padding: 6px 12px;
		cursor: pointer;
		margin-right: 10px;
		color: #262626;
		background: #ffffff;
		border: 1px solid #d9d9d9;
	}
}

.shareBox {
	p {
		margin-bottom: 0;
		margin-top: 7px;
		display: flex;
		justify-content: space-between;
		align-items: center;

		span {
			margin-left: 4px;
		}
	}
}

.content {
	margin-top: -12px;

	.comTop {
		.reData {
			width: 686px;
			height: 112px;
			background: #c0dffb;
			box-shadow: 0px 8px 12px 0px rgba(175, 214, 251, 0.2);
			border-radius: 8px;
			border: 4px solid #a5d3fe;
			padding: 0 24px;
			box-sizing: border-box;
			font-size: 28px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #1890ff;
			display: flex;
			align-items: center;
			margin: 0 auto;
		}
	}

	.empty-div {
		width: 686px;
		height: 566px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin: 12px auto 0;

		.empty-img {
			margin-top: 100px;
			width: 166px;
			height: 133px;
			display: block;
		}

		.empty-title {
			width: 544px;
			font-size: 16px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #a5a9bc;
			line-height: 22px;
			margin-top: 18px;
			text-align: center;
		}
	}

	.comNameTitWrap {
		padding: 0;
		display: flex;
		align-items: center;

		.leCircle {
			width: 19px;
			height: 19px;
			border: 4px solid #1890ff;
			border-radius: 50%;
			box-sizing: border-box;
		}

		.riFontWrap {
			margin-left: 16px;
			display: flex;
			align-items: flex-end;
			z-index: 99;

			.fontName {
				font-size: 24px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #1f2635;
			}

			.engName {
				font-size: 16px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #cacdd9;
				margin-left: 4px;
				position: relative;
				top: -5px;
			}
		}
	}

	.report-plate {
		display: flex;
		align-items: flex-end;
		justify-content: flex-start;
		margin: 20px 0 12px;

		.report-plate-title1 {
			height: 33px;
			font-size: 24px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #1f2635;
			line-height: 37px;
		}

		.report-plate-title1::before {
			content: "";
			display: inline-block;
			width: 19px;
			height: 19px;
			border: 4px solid #1890ff;
			border-radius: 50%;
			margin-right: 8px;
		}

		.report-plate-title2 {
			margin-left: 4px;
			height: 22px;
			font-size: 16px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #cacdd9;
			line-height: 22px;
		}
	}

	.dataTitle {
		margin-top: 10px;
		display: flex;
		margin-bottom: 20px;
		justify-content: flex-start;
		position: relative;
		height: auto;

		.dataContent {
			width: 100%;
			position: absolute;
			top: 0px;
			left: 0px;

			.dataTitleItem {
				display: flex;
				align-items: center;
				height: 28px;
				background: #e6f7ff;
				border-radius: 4px;
				padding: 2px 30px 2px 10px;
				margin-right: 10px;
				border-radius: 30px;
				width: auto;
				display: inline-block;
				position: absolute;
				top: 0px;
				left: 0px;
				line-height: 22px;

				.firstImg {
					text-align: center;
					margin-right: 5px;
					display: inline-block;

					.firstRect {
						width: 8px;
						height: 8px;
						border-radius: 4px;
						background-color: #1890ff;
						display: inline-block;
					}

					img {
						width: 36px;
						margin-bottom: 2px;
					}

					p {
						font-size: 10px;
						// color: #1890ff;
						margin-bottom: 0;
						display: inline-block;
						margin-left: 7px;
					}
				}
			}

			.dataTitleItem0 {
				left: 12%;
				top: 40px;
			}

			.dataTitleItem1 {
				left: 62%;
				top: 30px;
			}

			.dataTitleItem2 {
				left: 8%;
				top: 100px;
			}

			.dataTitleItem3 {
				left: 67%;
				top: 70px;
			}

			.dataTitleItem4 {
				left: 72%;
				top: 110px;
			}

			.dataTitleItemStatus2,
			.dataTitleItemStatus3,
			.dataTitleItemStatus4 {
				background: rgb(255, 181, 181);

				.firstRect {
					background-color: rgb(255, 81, 81) !important;
				}
			}
		}

		.span {
			color: #262626;
			font-size: 12px;
			margin-bottom: 0;
			display: inline-block;

			.large {
				font-size: 16px;
			}
		}
	}

	.myCharts {
		margin-bottom: 20px;
		position: relative;

		.bt {
			color: #262626;
			font-size: 12px;
			display: flex;
			align-items: flex-end;
			margin-bottom: 10px;

			span {}

			img {
				width: 22px;
				margin-right: 5px;
			}
		}

		.pic {
			margin-left: -10px;
			margin-top: 20px;
			width: 900px;
			height: 140px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-direction: column;

			.no-picdata {
				width: 900px;
				height: 140px;
				display: flex;
				align-items: center;
				color: #b4b4b4;

				.mins {
					width: 41px;
					height: 140px;
					display: flex;
					align-items: center;
					flex-direction: column;
					justify-content: space-between;
					border-right: 1px solid #e0e0e0;
					font-size: 12px;
				}

				.picdata-content {
					flex: 1;
					text-align: center;
				}
			}

			.content {
				width: 900px;
				height: 190px;
				display: flex;
				position: relative;
				left: -5px;

				.timeX {
					text-align: center;
					font-size: 12px;
					display: flex;
					flex-direction: column;
					flex-wrap: wrap;
					justify-content: space-between;

					p {
						width: 50px;
					}
				}

				.box {
					position: relative;
					width: 800px;
					overflow: auto;
				}

				.box-column {
					height: 180px;
					position: relative;

					.column-con {
						height: 150px;
						display: flex;
						align-items: center;
						justify-content: space-between;
					}

					.column {
						flex-shrink: 0;
						width: 10px;
						background: #f5f5f5;
						height: 150px;
						margin-left: 1px;
						float: left;
						border-top-left-radius: 5px;
						border-top-right-radius: 5px;
						overflow: hidden;

						.item {
							height: 15px;
						}

						.has-people-item {
							background: #52c41a;
						}
					}
				}

				.time-column {
					font-size: 12px;
					display: flex;
					align-items: center;
					margin-left: -15px;
					justify-content: space-between;

					.times {
						margin-left: -10px;
					}
				}

				.time-column-point {
					font-size: 12px;
					display: flex;
					position: relative;

					div {
						display: inline-block;
					}

					div:first-of-type {
						.Xtime {
							margin-left: 0;
							opacity: 0;
						}
					}

					.time-start {
						font-size: 12px;
						position: absolute;
						bottom: -10px;
						left: 0;
					}

					.time-end {
						font-size: 12px;
						position: absolute;
						bottom: -10px;
						right: -75px;
					}

					.time-start::before {
						position: absolute;
						top: -10px;
						left: 0;
						content: "";
						height: 10px;
						width: 1px;
						background: #262626;
					}

					.time-start::after {
						position: absolute;
						top: -10px;
						left: 33px;
						content: "";
						height: 10px;
						width: 1px;
						background: #262626;
					}

					.time-end::after {
						position: absolute;
						top: -10px;
						left: 17px;
						content: "";
						height: 10px;
						width: 1px;
						background: teal;
					}

					.Xtime {
						position: relative;
						top: 10px;
						left: -15px;
						display: inline-block;
						width: 30px;
						margin-left: 36px;
					}

					.Xtime::before {
						position: absolute;
						top: -10px;
						left: 15px;
						content: "";
						height: 10px;
						width: 1px;
						background: #262626;
					}

					.Xtime::after {
						position: absolute;
						top: -10px;
						left: 50px;
						content: "";
						height: 10px;
						width: 1px;
						background: teal;
					}
				}
			}
		}

		.el-carousel__indicators--outside {
			display: none;
		}

		.num {
			text-align: center;
			color: #000;
			font-size: 16px;
		}

		.bt2 {
			color: #262626;
			font-size: 12px;

			//display: flex;
			//align-items: flex-end;
			img {
				width: 22px;
				margin-right: 5px;
			}
		}

		.rightList {
			list-style: none;
			color: #8c8c8c;
			font-size: 14px;
			position: absolute;
			top: 50%;
			right: 4%;
			z-index: 10000;
			transform: translate(-0, -40%);
			margin-bottom: 0;

			li {
				margin-bottom: 10px;

				.Dot {
					display: inline-block;
					width: 10px;
					height: 10px;
					border-radius: 50%;
					margin-right: 5px;
				}
			}

			li:last-child {
				margin-bottom: 0;
			}
		}
	}

	.myCharts:last-child {
		margin-bottom: 0;
	}
}

.breath-table {
	width: 100%;
	height: 120px;
	height: 60px;
	margin: 10px 0 8px 0;
	border-collapse: collapse;
	/*表格的边框合并，如果相邻，则共用一个边框*/
	border-spacing: 0;
	border: 1px solid #d9d9d9;

	td {
		//width: 50%;
		color: #262626;
		// border: 0.1px solid #d9d9d9;
		text-align: center;
		padding: 8px 10px;

		word-break: break-all;
		/*允许在字内换行,即单词可分*/
		word-wrap: break-word;
		/*允许长单词或URL地址换行*/
		border-right: 1px solid #d9d9d9;
		border-bottom: 1px solid #d9d9d9;
	}

	.left-td {
		width: 60%;
	}
}

.ant-fullcalendar-header .ant-radio-group {
	display: none;
}

.calDot {
	width: 7px;
	height: 7px;
	border-radius: 10px;
	background-color: #1890ff;
	display: inline-block;
	position: relative;
	top: -5px;
}

.sugTitle {
	font-weight: 900;
	color: #000000;
	display: inline-block;
}

.sugComment {
	padding: 0 13px 0 13px;
	display: inline-block;
}

.zqTopArr {
	width: 814px;
	color: rgba(0, 0, 0, 0.35);
	position: absolute;
	top: -25px;
	right: 0;
	display: flex;

	.zqTipTime {
		justify-content: center;
		align-items: center;
		flex: 1;
		text-align: center;
	}
}

.dxhxEvent {
	.dxlbWrap {
		margin-top: 5px;
		position: relative;

		.imgWrap {
			width: 100%;
			height: 75px;
			border: 1px solid #d9d9d9;

			.img {
				width: 100%;
				height: 100%;
			}
		}

		.btnWrap {
			width: 100%;
			height: 40px;
			position: absolute;
			left: 0;
			top: 47px;
		}

		.left-btn-abn,
		.right-btn-abn {
			position: absolute;
			top: 0;
			z-index: 10;
			width: 40px;
			display: inline-block;

			img {
				width: 40px;
			}
		}

		.left-btn-abn {
			left: -20px;
		}

		.right-btn-abn {
			right: -20px;
		}

		.left-btn-abn,
		.right-btn-abn:hover {
			cursor: pointer;
		}
	}
}

.moreDays {
	.nowListWrap {
		width: 100%;
		height: auto;
	}

	.nowListWrap .deExplain {
		width: 100%;
		height: auto;
		background: #f3f4f7;
		border-radius: 4px;
		padding: 0 12px;
		box-sizing: border-box;
		margin: 0 auto;

		.deExTop {
			width: 100%;
			height: 45px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.deExTopTip {
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #9094a6;
			}

			.deExTop_iconWrap {
				width: 20px;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: flex-end;
				margin-left: auto;

				.deExTop_icon {
					width: 14px;
				}
			}
		}
	}

	.nowListWrap .nowList {
		height: auto;
		background: #fff;
		border-radius: 4px;
		border: 1px solid #fff;
		margin: 8px auto 0;
		padding: 16px 10px;
		box-sizing: border-box;
		font-size: 12px;
	}

	.nowListWrap .nowList_Ques {
		border: 1px solid #ff7186;
	}

	.nowList .nowTop {
		display: flex;
		align-items: center;
	}

	.nowList .nowTop .goodImg {
		width: 10px;
		height: 20px;
	}

	.nowList .nowTop .titName {
		width: 307px;
		font-size: 20px;
		color: #1f2635;
		display: flex;

		flex-wrap: wrap;
	}

	.nowList .nowTop .titName .sleepTime {
		display: flex;
	}

	.nowList .referVal {
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #9094a6;
		margin-top: 4px;
		margin-left: 30px;
		margin-bottom: 8px;
		display: flex;
	}

	.nowList .referVal .referValRight {
		display: flex;
		align-items: center;
		margin-left: auto;
	}

	.nowList .referVal .referValRight .gangWrap {
		display: flex;
		align-items: center;
	}

	.nowList .referVal .referValRight .gangWrap .gang {
		width: 4px;
		height: 1px;
		background: #cd8aff;
		margin-left: 3px;
	}

	.nowList .referVal .referValRight .gangKuai {
		width: 16px;
		height: 12px;
		background: #e7f3ff;
	}

	.nowList .referVal .referValRight .gantTip {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #a5a9bc;
		margin-left: 4px;
	}

	.nowList .quesCont {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #9094a6;
		margin-top: 8px;
		position: relative;

		.title-left-dian {
			width: 3px;
			height: 3px;
			display: inline-block;
			border-radius: 50%;
			background: #9094a6;
			position: relative;
			top: -3px;
		}
	}

	.nowList .lx_list_data {
		display: flex;
		flex-wrap: wrap;
	}

	.nowList .lx_list_data .lx_list {
		width: 60px;
		display: flex;
		align-items: center;
		margin-left: 24px;
		margin-top: 12px;
		// min-width: 57px;
		cursor: pointer;
	}

	.nowList .lx_list_data .lx_list:nth-of-type(10n + 1) {
		margin-left: 0;
	}

	.nowList .lx_list_data .lx_list .cirIcon {
		width: 20px;
		height: 20px;
		background: #ffffff;
		border: 3px solid #ff4d4f;
		border-radius: 50%;
		box-sizing: border-box;
	}

	.nowList .lx_list_data .lx_list .cirIconSel {
		background: #ff4d4f;
	}

	.nowList .lx_list_data .lx_list .nowDay {
		margin-left: 3px;
	}

	.nowList .yxsc {}

	.nowList .yxsc .yxscList {
		height: 38px;
		margin-top: 8px;
		display: flex;
		align-items: center;
	}

	.nowList .yxsc .yxscList .yxIcon {
		width: 32px;
		height: 32px;
	}

	.nowList .yxsc .yxscList .yxCont {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #9094a6;
		margin-left: 4px;
	}

	.nowList .myCharts5_topWrap {
		display: flex;
		align-items: center;

		.tdxqIcon_img {
			width: 20px;
			height: 20px;
		}

		.tdxqIcon_tit {
			font-size: 16px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #1f2635;
			margin-left: 4px;
		}

		.tdxqIcon_tit2 {
			font-size: 12px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #a5a9bc;
			margin-left: auto;
		}
	}

	.wenhaoImg {
		width: 20px;
		margin-left: 4px;
		vertical-align: middle;
    border-style: none;
	}

	// 睡眠解读
	.sleepReadWrap {
		height: auto;
		background: #f1f8ff;
		box-shadow: 0px 4px 6px 0px rgba(175, 214, 251, 0.2);
		border-radius: 24px;
		border: 2px solid #b6dcff;
		box-sizing: border-box;
		padding: 20px;
		margin: 20px auto 0;

		.sReadTopImg {
			width: 179px;
			height: 34px;
			display: block;
		}
	}

	.smTypeWrap {
		margin-top: 12px;
	}

	.smTopName {
		display: flex;
		align-items: center;
	}

	.smTopName .smTopNamePoint {
		width: 6px;
		height: 6px;
		background: #72b8f8;
		border-radius: 50%;
	}

	.smTopName .name {
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #1890ff;
		margin-left: 8px;
	}

	.smTopName .nameEx {
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #5e6779;
		margin-left: 8px;
	}

	.n_exPlainWrap {
		margin-left: 12px;
		margin-top: 5px;
	}

	.blueCir {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		// background: #1890FF;
		float: left;
		margin-right: 4px;
	}

	.n_exPlain {
		width: auto;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #9094a6;
		line-height: 20px;
	}

	.content,
	.nodata-con {
		position: relative;

		.comTop {
			.reData {
				width: 686px;
				height: 112px;
				background: #c0dffb;
				box-shadow: 0px 8px 12px 0px rgba(175, 214, 251, 0.2);
				border-radius: 8px;
				border: 4px solid #a5d3fe;
				padding: 0 24px;
				box-sizing: border-box;
				font-size: 28px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #1890ff;
				display: flex;
				align-items: center;
				margin: 0 auto;
			}
		}

		.empty-div {
			width: 686rem;
			height: 1132rem;
			background: #f7f2ff;
			box-shadow: 0rem 8rem 12rem 0rem rgba(217, 198, 255, 0.3);
			border-radius: 8rem;
			border: 4rem solid #d9c6ff;

			display: flex;
			flex-direction: column;
			// align-items: center;
			justify-content: center;
			margin: 24rem auto 0;

			.empty-img {
				margin-top: 200rem;
				width: 332rem;
				height: 266rem;
				display: block;
			}

			.empty-title {
				width: 544rem;
				font-size: 30rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #a5a9bc;
				line-height: 44rem;
				margin-top: 32rem;
				text-align: center;
			}
		}

		.comNameTitWrap {
			padding: 0;
			display: flex;
			align-items: center;

			.leCircle {
				width: 19px;
				height: 19px;
				border: 4px solid #1890ff;
				border-radius: 50%;
				box-sizing: border-box;
			}

			.riFontWrap {
				margin-left: 16px;
				display: flex;
				align-items: flex-end;
				z-index: 99;

				.fontName {
					font-size: 24px;
					font-family: PingFangSC-Semibold, PingFang SC;
					font-weight: 600;
					color: #1f2635;
				}

				.engName {
					font-size: 16px;
					font-family: PingFangSC-Semibold, PingFang SC;
					font-weight: 600;
					color: #cacdd9;
					margin-left: 4px;
					position: relative;
					top: -5px;
				}
			}
		}

		.echarts3 {
			height: auto;
		}

		.echarts4 {
			height: auto;
			padding-top: 0;
		}

		.echarts5 {
			height: auto;
			padding-top: 0;
		}

		.rightList {
			list-style: none;
			color: #8c8c8c;
			font-size: 12px;
			position: absolute;
			top: 50%;
			right: 10%;
			z-index: 1;
			transform: translate(-0, -40%);
			margin-bottom: 0;

			li {
				margin-bottom: 10px;

				.Dot {
					display: inline-block;
					width: 10px;
					height: 10px;
					border-radius: 50%;
					margin-right: 5px;
				}
			}

			li:last-child {
				margin-bottom: 0;
			}
		}
	}

	.content-chart {}

	.noVal {
		height: 148px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #9094a6;
		// border: 1px solid #e4e6ec;
		background: #f8f8f9;
		margin-top: 30px;
	}

	.nowList .nowTop {
		display: flex;
		align-items: center;
	}

	.nowList .nowTop .goodImg {
		width: 20px;
		height: 20px;
	}

	.nowList .nowTop .titName {
		width: 614px;
		font-size: 20px;
		color: #1f2635;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.nowList .nowTop .titName .sleepTime {
		display: flex;
	}
}

.clear {
	zoom: 1;
}

.clear:after {
	content: "";
	display: block;
	clear: both;
}

.flex_alignCen {
	display: flex;
	align-items: center;
}

.posRela {
	position: relative;
}

.ml5 {
	margin-left: 5px !important;
}

.ml8 {
	margin-left: 8px !important;
}

.ml10 {
	margin-left: 10px !important;
}

.ml15 {
	margin-left: 15px !important;
}

.ml24 {
	margin-left: 24px !important;
}

.ml32 {
	margin-left: 32px !important;
}

.ml40 {
	margin-left: 40px !important;
}

.ml48 {
	margin-left: 48px !important;
}

.ml68 {
	margin-left: 68px !important;
}

.ml80 {
	margin-left: 80px !important;
}

.mr10 {
	margin-right: 10px !important;
}

.mr20 {
	margin-right: 20px !important;
}

.mr24 {
	margin-right: 24px !important;
}

.mr40 {
	margin-right: 45px !important;
}

.mt10 {
	margin-top: 10px !important;
}

.mt15 {
	margin-top: 15px !important;
}

.mt20 {
	margin-top: 20px !important;
}

.mt24 {
	margin-top: 24px !important;
}

.mt25 {
	margin-top: 25px !important;
}

.mt30 {
	margin-top: 30px !important;
}

.mt32 {
	margin-top: 32px !important;
}

.mt40 {
	margin-top: 40px !important;
}

.mt45 {
	margin-top: 45px !important;
}

.mt50 {
	margin-top: 50px !important;
}

.mt55 {
	margin-top: 55px !important;
}

.pl0 {
	padding-left: 0 !important;
}

.pb20 {
	padding-bottom: 20px !important;
}

.color1890FF {
	color: #1890ff !important;
}

.colorFF7186 {
	color: #ff7186 !important;
}

.colorFFA54D {
	color: #ffa54d !important;
}

.color5E6779 {
	color: #5e6779 !important;
}

.bgFFA54D {
	background: #ffa54d !important;
}

.bgFF7186 {
	background: #ff7186 !important;
}

.bgC394FE {
	background: #c394fe !important;
}

.bgF8B4E7 {
	background: #f8b4e7 !important;
}

.bgFFB5B5 {
	background: #ffb5b5 !important;
}

.bg63B2FB {
	background: #63b2fb !important;
}

.bgB67FFA {
	background: #b67ffa !important;
}

.bg1890FF {
	background: #1890ff !important;
}

.marLeftAuto {
	margin-left: auto !important;
}

.posRela {
	position: relative;
}

.flex {
	display: flex;
}

.spanCenter {
	text-align: center;
}

.alignItemStart {}

.heiAuto {
	height: auto !important;
}

.comment-box-more {
	.tooltip {
		height: 34px;
		margin-left: 5px;
		position: relative;
		display: inline-block;
		border-bottom: 1px dotted #fff;
	}

	.tooltip .tooltiptext {
		visibility: hidden;
		width: 375px;
		background: #ffffff;
		box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.2);
		border-radius: 8px;
		color: #ccc;
		border-radius: 6px;
		padding: 20px 20px;

		/* 定位 */
		position: absolute;
		z-index: 9999;
		top: -5px;
		left: 105%;
	}

	.tooltip .tooltiptext {
		top: -240px;
		left: -182px;
	}

	.tooltip:hover .tooltiptext {
		visibility: visible;
	}

	.tooltip .tooltiptext::after {
		content: "";
		position: absolute;
		top: 100%;
		left: 50%;
		margin-left: -5px;
		border-width: 8px;
		border-style: solid;
		border-color: white transparent transparent transparent;
	}

	.ahi-title {
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #1f2635;
	}

	.ahi-title::before {
		content: "";
		display: inline-block;
		width: 3px;
		height: 18px;
		background: #4d8ef7;
		border-radius: 2px;
		position: absolute;
		top: 21px;
		left: 0;
	}

	.ahi-item {
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #5e6779;
		margin: 10px 0;
	}

	.ahi-item::before {
		content: "";
		display: inline-block;
		width: 8px;
		height: 8px;
		background: #4d8ef7;
		border-radius: 50%;
		margin-right: 8px;
	}

	.ahi-item2::before {
		background: #ffc471;
	}

	.ahi-item3::before {
		background: #ff7186;
	}
}

.zb_topWrap {
	display: flex;

	.leCont {
		width: 635px;
		height: auto;
		background: #ffffff;
		border-radius: 2px;
		border: 1px solid #ffffff;
		padding: 15px;
		box-sizing: border-box;
		display: flex;
		flex-wrap: wrap;

		.leList {
			width: 297px;
			height: 67px;
			background: #f3f4f7;
			border-radius: 2px;
			position: relative;
			padding: 10px 0;

			.lePoint {
				width: 8px;
				height: 8px;
				background: #1890ff;
				border-radius: 50%;
			}

			.lePointRed {
				background: #ff7186;
			}

			.leName {
				font-size: 16px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #262626;
			}

			.leTime {
				font-size: 16px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #1890ff;
			}

			.leTimeRed {
				color: #ff7186;
			}

			.leCkz {
				width: 100%;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #9094a6;
				display: flex;
				margin-left: 23px;
				box-sizing: border-box;
				padding-right: 10px;
			}

			.tag {
				width: 48px;
				height: 20px;
				background: #1890ff;
				border-radius: 10px 0px 0px 10px;

				font-size: 14px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #ffffff;
				margin-left: auto;
				position: relative;
				left: 2px;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.tag::after {
				width: 2px;
				height: 4px;
				content: "";
				background: url("../assets/sjAfter.png") no-repeat;
				background-size: cover;
				position: absolute;
				right: 0;
				top: 20px;
			}

			.tagRed {
				background: #ff7186;
			}

			.tagRed::after {
				background: url("../assets/sjAfter2.png") no-repeat;
				background-size: cover;
			}
		}

		.leList:nth-of-type(2n) {
			margin-left: auto;
		}

		.leListRed {
			background: #fff1f3;
			border: 1px solid #ffb8c3;
		}
	}

	.riCont {
		width: 209px;
		height: 397px;
		background: url("../assets/repeTopBg.png") no-repeat;
		background-size: cover;
		margin-left: auto;
		position: relative;

		.banCir {
			width: 23px;
			height: 34px;
			position: absolute;
			top: -23px;
			right: 0;
		}

		.botTime {
			width: 189px;
			height: auto;
			background: #e2f1ff;
			border-radius: 2px;
			backdrop-filter: blur(4px);
			margin: 20px auto 0;
			box-sizing: border-box;
			padding: 6px 10px;

			.tCont {
				width: 169px;
				height: auto;
				padding: 10px 0;
				border-bottom: 1px solid #cce6ff;

				.tPoint {
					width: 8px;
					height: 8px;
					background: #1890ff;
					opacity: 0.2;
					border-radius: 50%;
				}

				.tTime {
					font-size: 16px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #51a8f6;
				}

				.tTip {
					width: 128px;
					height: 20px;
					background: #e4e0ed;
					border-radius: 2px 10px 10px 10px;

					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #ff7186;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-left: 13px;
				}
			}
		}
	}
}

.tooltip {
	margin-left: 5px;
	position: relative;
	display: inline-block;
	border-bottom: 1px dotted #fff;
}

.tooltip .tooltiptext {
	visibility: hidden;
	width: 375px;
	background: #ffffff;
	box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.2);
	border-radius: 8px;
	color: #ccc;
	border-radius: 6px;
	padding: 20px 20px;

	/* 定位 */
	position: absolute;
	z-index: 1;
	top: -5px;
	left: 105%;
}

.tooltip .tooltiptext {
	top: -165px;
	left: -182px;
}

.tooltip:hover .tooltiptext {
	visibility: visible;
}

.tooltip .tooltiptext::after {
	content: "";
	position: absolute;
	top: 100%;
	left: 50%;
	margin-left: -5px;
	border-width: 8px;
	border-style: solid;
	border-color: white transparent transparent transparent;
}

.core-ranking-div {
	position: relative;
	padding-top: 20px;

	.score-ranking-tips {
		position: absolute;
		top: 58%;
		left: 50%;
		transform: translate(-50%, -45%);
		font-size: 14px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #ffffff;
		background: #1890ff;
		padding: 0 8px;
		border-radius: 15px;
	}

	.score-ranking-tips-red {
		background: #ff7186;
	}

	.score-ranking {
		display: inline-block;

		background: #e4ecf5;
		border-radius: 13px;
		position: relative;
		padding: 2px 10px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #5e6779;
		white-space: nowrap;
		font-size: 14px;

		position: relative;
		top: -10px;
		left: 50%;
		transform: translateX(-50%);
	}

	.score-ranking::after {
		position: absolute;
		content: "";
		display: inline-block;
		border: 8px solid transparent;
		border-bottom-color: #e4ecf5;
		top: -15px;
		left: 50%;
		transform: translateX(-50%);
	}
}

/* 柱状图 */
.moreDays {
	.colPicWrap {
		width: 100%;
		height: auto;
		/* background: #F5F5F5; */
		border-radius: 8px;
		margin-top: 10px;
		padding: 0;
		position: relative;
		left: 0;
	}

	.colPicWrap .colTop {
		display: flex;
		align-items: center;
		padding: 0 3px;
		box-sizing: border-box;
	}

	.colPicWrap .colTop .topIcon {
		width: 16px;
		height: 5px;
		background: #f6f9fe;
		border: 1px dashed #1890ff;
	}

	.colPicWrap .colTop .topTit {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #1890ff;
		margin-left: 8px;
	}

	.colChartWrap {
		height: 190px;
	}

	.colPicWrap .colChart {
		width: 797px;
		height: 160px;
		border-bottom: 1px solid #9094a6;
		position: relative;
		left: 34px;
		top: 15px;
	}

	.colPicWrap .colChart .posAb_X {
		width: 100%;
		display: flex;
		position: absolute;
		left: 0;
		bottom: -25px;
	}

	.colPicWrap .colChart .posAb_X .num {
		font-size: 10px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #a5a9bc;
		margin-left: 144px;
	}

	.colPicWrap .colChart .posAb_X .num:nth-of-type(1) {
		margin-left: 5px;
	}

	.colPicWrap .colChart .posAb_Y {
		height: 155px;
		display: flex;
		flex-direction: column-reverse;
		text-align: right;
		position: absolute;
		left: -33px;
		bottom: -10px;
	}

	.colPicWrap .colChart .posAb_Y .num {
		display: flex;
		align-items: center;
		font-size: 10px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #a5a9bc;
		margin-bottom: 20px;
	}

	.colPicWrap .colChart .posAb_Y .num:nth-of-type(1) {
		margin-bottom: 0;
	}

	.colPicWrap .colChart .posAb_Green {
		width: 225px;
		height: 165px;
		/* background: #EDFFF0;
background: rgba(237, 255, 240, 1); */

		background: rgba(77, 142, 247, 0.05);
		border: 1px dashed #4d8ef7;
		border-bottom: 0;
		position: absolute;
		left: 257px;
		bottom: 0;
	}

	.colPicWrap .colChart .posAb_cont {
		width: 100%;
		height: 160px;
		position: absolute;
		left: 0;
		bottom: 0;
	}

	.colPicWrap .colChart .posAb_cont .cList {
		width: 28px;
		height: 40px;
		border-radius: 8px 8px 0px 0px;
		margin-left: 4px;
		float: left;
		position: absolute;
		bottom: 0;
		// background: linear-gradient(360deg, #b84df7 0%, #c394fe 100%);
		border-radius: 4px 4px 0px 0px;
	}

	.in_cList {
		width: 100%;
		height: 100%;
		border-radius: 8px 8px 0px 0px;
	}

	.bgB67FFA_D2B1FC {
		background: linear-gradient(360deg, #b67ffa 0%, #d2b1fc 100%);
	}

	.bg7AAEFC_C8B2FF {
		background: linear-gradient(360deg, #7aaefc 0%, #c8b2ff 100%);
	}

	.colPicWrap .tips {
		width: 670px;
		height: auto;
		font-size: 28px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #262626;
		margin: 20px auto 0;
	}
}

.ai-btn {
	width: 120px;
	height: 56px;
	background: url(../assets/icon_ai_report_icon_1.png) no-repeat no-repeat;
	background-size: contain;
	cursor: pointer;
}

.ai-btn:hover {
	background: url(../assets/icon_ai_report_icon_2.png) no-repeat no-repeat;
	background-size: contain;
}

</style>
